var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === 'object' || typeof from === 'function') {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, 'default', { value: mod, enumerable: true }) : target,
  mod
));

// node_modules/flatpickr/dist/l10n/ja.js
var require_ja = __commonJS({
  'node_modules/flatpickr/dist/l10n/ja.js'(exports, module) {
    (function(global, factory) {
      /* eslint-disable no-undef */
      typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) : typeof define === 'function' && typeof define !== 'undefined' && define.amd ? define(['exports'], factory) : (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.ja = {}));
      /* eslint-enable no-undef */
    })(exports, function(exports2) {
      'use strict';
      var fp = typeof window !== 'undefined' && window.flatpickr !== void 0 ? window.flatpickr : {
        l10ns: {}
      };
      var Japanese2 = {
        weekdays: {
          shorthand: ['\u65E5', '\u6708', '\u706B', '\u6C34', '\u6728', '\u91D1', '\u571F'],
          longhand: [
            '\u65E5\u66DC\u65E5',
            '\u6708\u66DC\u65E5',
            '\u706B\u66DC\u65E5',
            '\u6C34\u66DC\u65E5',
            '\u6728\u66DC\u65E5',
            '\u91D1\u66DC\u65E5',
            '\u571F\u66DC\u65E5'
          ]
        },
        months: {
          shorthand: [
            '1\u6708',
            '2\u6708',
            '3\u6708',
            '4\u6708',
            '5\u6708',
            '6\u6708',
            '7\u6708',
            '8\u6708',
            '9\u6708',
            '10\u6708',
            '11\u6708',
            '12\u6708'
          ],
          longhand: [
            '1\u6708',
            '2\u6708',
            '3\u6708',
            '4\u6708',
            '5\u6708',
            '6\u6708',
            '7\u6708',
            '8\u6708',
            '9\u6708',
            '10\u6708',
            '11\u6708',
            '12\u6708'
          ]
        },
        time_24hr: true,
        rangeSeparator: ' \u304B\u3089 ',
        monthAriaLabel: '\u6708',
        amPM: ['\u5348\u524D', '\u5348\u5F8C'],
        yearAriaLabel: '\u5E74',
        hourAriaLabel: '\u6642\u9593',
        minuteAriaLabel: '\u5206'
      };
      fp.l10ns.ja = Japanese2;
      var ja = fp.l10ns;
      exports2.Japanese = Japanese2;
      exports2.default = ja;
      Object.defineProperty(exports2, '__esModule', { value: true });
    });
  }
});

// src/js/_module/_modal.ts
function modal() {
  const openModalFromUrl = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const modalId = urlParams.get('modal');
    if (modalId) {
      const targetModal = document.getElementById(modalId);
      if (targetModal) {
        targetModal.classList.add('is-active');
        document.body.style.overflow = 'hidden';
      } else {
        console.error(`Modal element with ID "${modalId}" from URL parameter not found.`);
      }
    }
  };
  openModalFromUrl();
  document.addEventListener('click', (event) => {
    const target = event.target;
    const openButton = target.closest('.js-modal-open-button[data-modal-target]');
    const closeTrigger = target.closest('.js-modal-close-trigger');
  
    // 1. Open modal
    if (openButton) {
      const modalId = openButton.dataset.modalTarget;
      if (!modalId) {
        console.error('data-modal-target attribute is missing or empty.');
        return;
      }
      const targetModal = document.getElementById(modalId);
      if (!targetModal) {
        console.error(`Modal element with ID "${modalId}" not found.`);
        return;
      }
      targetModal.classList.add('is-active');
      document.body.style.overflow = 'hidden';
      return; // Stop here, do not check further
    } else if (closeTrigger) {
      const modalContainer = closeTrigger.closest('.js-modal-container');
      if (modalContainer) {
        modalContainer.classList.remove('is-active');
        const activeModalExists = document.querySelector('.js-modal-container.is-active');
        if (!activeModalExists) {
          document.body.style.overflow = '';
        }
      }
    }
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      const activeModal = document.querySelector('.js-modal-container.is-active');
      if (activeModal) {
        activeModal.classList.remove('is-active');
        document.body.style.overflow = '';
      }
    }
  });
}

// src/js/_module/_show_password.ts
function showPassword() {
  const toggleButtons = document.querySelectorAll('.js-toggle-password');
  toggleButtons.forEach((toggleButton) => {
    toggleButton.addEventListener('click', function(e) {
      e.preventDefault();
      const passwordField = toggleButton.parentElement?.querySelector('.js-password-field');
      if (passwordField) {
        if (passwordField.type === 'password') {
          passwordField.type = 'text';
          toggleButton.classList.add('--is-visible');
        } else {
          passwordField.type = 'password';
          toggleButton.classList.remove('--is-visible');
        }
      }
    });
  });
}

// node_modules/@splidejs/splide/dist/js/splide.esm.js
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ('value' in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, 'prototype', { writable: false });
  return Constructor;
}
var MEDIA_PREFERS_REDUCED_MOTION = '(prefers-reduced-motion: reduce)';
var CREATED = 1;
var MOUNTED = 2;
var IDLE = 3;
var MOVING = 4;
var SCROLLING = 5;
var DRAGGING = 6;
var DESTROYED = 7;
var STATES = {
  CREATED,
  MOUNTED,
  IDLE,
  MOVING,
  SCROLLING,
  DRAGGING,
  DESTROYED
};
function empty(array) {
  array.length = 0;
}
function slice(arrayLike, start, end) {
  return Array.prototype.slice.call(arrayLike, start, end);
}
function apply(func) {
  return func.bind.apply(func, [null].concat(slice(arguments, 1)));
}
var nextTick = setTimeout;
// eslint-disable-next-line @typescript-eslint/no-empty-function
var noop = function noop2() {};
function raf(func) {
  return requestAnimationFrame(func);
}
function typeOf(type, subject) {
  return typeof subject === type;
}
function isObject(subject) {
  return !isNull(subject) && typeOf('object', subject);
}
var isArray = Array.isArray;
var isFunction = apply(typeOf, 'function');
var isString = apply(typeOf, 'string');
var isUndefined = apply(typeOf, 'undefined');
function isNull(subject) {
  return subject === null;
}
function isHTMLElement(subject) {
  try {
    return subject instanceof (subject.ownerDocument.defaultView || window).HTMLElement;
  } catch (e) {
    return false;
  }
}
function toArray(value) {
  return isArray(value) ? value : [value];
}
function forEach(values, iteratee) {
  toArray(values).forEach(iteratee);
}
function includes(array, value) {
  return array.indexOf(value) > -1;
}
function push(array, items) {
  array.push.apply(array, toArray(items));
  return array;
}
function toggleClass(elm, classes, add) {
  if (elm) {
    forEach(classes, function(name) {
      if (name) {
        elm.classList[add ? 'add' : 'remove'](name);
      }
    });
  }
}
function addClass(elm, classes) {
  toggleClass(elm, isString(classes) ? classes.split(' ') : classes, true);
}
function append(parent, children2) {
  forEach(children2, parent.appendChild.bind(parent));
}
function before(nodes, ref) {
  forEach(nodes, function(node) {
    var parent = (ref || node).parentNode;
    if (parent) {
      parent.insertBefore(node, ref);
    }
  });
}
function matches(elm, selector) {
  return isHTMLElement(elm) && (elm['msMatchesSelector'] || elm.matches).call(elm, selector);
}
function children(parent, selector) {
  var children2 = parent ? slice(parent.children) : [];
  return selector ? children2.filter(function(child2) {
    return matches(child2, selector);
  }) : children2;
}
function child(parent, selector) {
  return selector ? children(parent, selector)[0] : parent.firstElementChild;
}
var ownKeys = Object.keys;
function forOwn(object, iteratee, right) {
  if (object) {
    (right ? ownKeys(object).reverse() : ownKeys(object)).forEach(function(key) {
      key !== '__proto__' && iteratee(object[key], key);
    });
  }
  return object;
}
function assign(object) {
  slice(arguments, 1).forEach(function(source) {
    forOwn(source, function(value, key) {
      object[key] = source[key];
    });
  });
  return object;
}
function merge(object) {
  slice(arguments, 1).forEach(function(source) {
    forOwn(source, function(value, key) {
      if (isArray(value)) {
        object[key] = value.slice();
      } else if (isObject(value)) {
        object[key] = merge({}, isObject(object[key]) ? object[key] : {}, value);
      } else {
        object[key] = value;
      }
    });
  });
  return object;
}
function omit(object, keys) {
  forEach(keys || ownKeys(object), function(key) {
    delete object[key];
  });
}
function removeAttribute(elms, attrs) {
  forEach(elms, function(elm) {
    forEach(attrs, function(attr) {
      elm && elm.removeAttribute(attr);
    });
  });
}
function setAttribute(elms, attrs, value) {
  if (isObject(attrs)) {
    forOwn(attrs, function(value2, name) {
      setAttribute(elms, name, value2);
    });
  } else {
    forEach(elms, function(elm) {
      isNull(value) || value === '' ? removeAttribute(elm, attrs) : elm.setAttribute(attrs, String(value));
    });
  }
}
function create(tag, attrs, parent) {
  var elm = document.createElement(tag);
  if (attrs) {
    isString(attrs) ? addClass(elm, attrs) : setAttribute(elm, attrs);
  }
  parent && append(parent, elm);
  return elm;
}
function style(elm, prop, value) {
  if (isUndefined(value)) {
    return getComputedStyle(elm)[prop];
  }
  if (!isNull(value)) {
    elm.style[prop] = '' + value;
  }
}
function display(elm, display2) {
  style(elm, 'display', display2);
}
function focus(elm) {
  elm['setActive'] && elm['setActive']() || elm.focus({
    preventScroll: true
  });
}
function getAttribute(elm, attr) {
  return elm.getAttribute(attr);
}
function hasClass(elm, className) {
  return elm && elm.classList.contains(className);
}
function rect(target) {
  return target.getBoundingClientRect();
}
function remove(nodes) {
  forEach(nodes, function(node) {
    if (node && node.parentNode) {
      node.parentNode.removeChild(node);
    }
  });
}
function parseHtml(html) {
  return child(new DOMParser().parseFromString(html, 'text/html').body);
}
function prevent(e, stopPropagation) {
  e.preventDefault();
  if (stopPropagation) {
    e.stopPropagation();
    e.stopImmediatePropagation();
  }
}
function query(parent, selector) {
  return parent && parent.querySelector(selector);
}
function queryAll(parent, selector) {
  return selector ? slice(parent.querySelectorAll(selector)) : [];
}
function removeClass(elm, classes) {
  toggleClass(elm, classes, false);
}
function timeOf(e) {
  return e.timeStamp;
}
function unit(value) {
  return isString(value) ? value : value ? value + 'px' : '';
}
var PROJECT_CODE = 'splide';
var DATA_ATTRIBUTE = 'data-' + PROJECT_CODE;
function assert(condition, message) {
  if (!condition) {
    throw new Error('[' + PROJECT_CODE + '] ' + (message || ''));
  }
}
var min = Math.min;
var max = Math.max;
var floor = Math.floor;
var ceil = Math.ceil;
var abs = Math.abs;
function approximatelyEqual(x, y, epsilon) {
  return abs(x - y) < epsilon;
}
function between(number, x, y, exclusive) {
  var minimum = min(x, y);
  var maximum = max(x, y);
  return exclusive ? minimum < number && number < maximum : minimum <= number && number <= maximum;
}
function clamp(number, x, y) {
  var minimum = min(x, y);
  var maximum = max(x, y);
  return min(max(minimum, number), maximum);
}
function sign(x) {
  return +(x > 0) - +(x < 0);
}
function format(string, replacements) {
  forEach(replacements, function(replacement) {
    string = string.replace('%s', '' + replacement);
  });
  return string;
}
function pad(number) {
  return number < 10 ? '0' + number : '' + number;
}
var ids = {};
function uniqueId(prefix) {
  return '' + prefix + pad(ids[prefix] = (ids[prefix] || 0) + 1);
}
function EventBinder() {
  var listeners = [];
  function bind(targets, events, callback, options) {
    forEachEvent(targets, events, function(target, event, namespace) {
      var isEventTarget = 'addEventListener' in target;
      var remover = isEventTarget ? target.removeEventListener.bind(target, event, callback, options) : target['removeListener'].bind(target, callback);
      isEventTarget ? target.addEventListener(event, callback, options) : target['addListener'](callback);
      listeners.push([target, event, namespace, callback, remover]);
    });
  }
  function unbind(targets, events, callback) {
    forEachEvent(targets, events, function(target, event, namespace) {
      listeners = listeners.filter(function(listener) {
        if (listener[0] === target && listener[1] === event && listener[2] === namespace && (!callback || listener[3] === callback)) {
          listener[4]();
          return false;
        }
        return true;
      });
    });
  }
  function dispatch(target, type, detail) {
    var e;
    var bubbles = true;
    if (typeof CustomEvent === 'function') {
      e = new CustomEvent(type, {
        bubbles,
        detail
      });
    } else {
      e = document.createEvent('CustomEvent');
      e.initCustomEvent(type, bubbles, false, detail);
    }
    target.dispatchEvent(e);
    return e;
  }
  function forEachEvent(targets, events, iteratee) {
    forEach(targets, function(target) {
      target && forEach(events, function(events2) {
        events2.split(' ').forEach(function(eventNS) {
          var fragment = eventNS.split('.');
          iteratee(target, fragment[0], fragment[1]);
        });
      });
    });
  }
  function destroy() {
    listeners.forEach(function(data) {
      data[4]();
    });
    empty(listeners);
  }
  return {
    bind,
    unbind,
    dispatch,
    destroy
  };
}
var EVENT_MOUNTED = 'mounted';
var EVENT_READY = 'ready';
var EVENT_MOVE = 'move';
var EVENT_MOVED = 'moved';
var EVENT_CLICK = 'click';
var EVENT_ACTIVE = 'active';
var EVENT_INACTIVE = 'inactive';
var EVENT_VISIBLE = 'visible';
var EVENT_HIDDEN = 'hidden';
var EVENT_REFRESH = 'refresh';
var EVENT_UPDATED = 'updated';
var EVENT_RESIZE = 'resize';
var EVENT_RESIZED = 'resized';
var EVENT_DRAG = 'drag';
var EVENT_DRAGGING = 'dragging';
var EVENT_DRAGGED = 'dragged';
var EVENT_SCROLL = 'scroll';
var EVENT_SCROLLED = 'scrolled';
var EVENT_OVERFLOW = 'overflow';
var EVENT_DESTROY = 'destroy';
var EVENT_ARROWS_MOUNTED = 'arrows:mounted';
var EVENT_ARROWS_UPDATED = 'arrows:updated';
var EVENT_PAGINATION_MOUNTED = 'pagination:mounted';
var EVENT_PAGINATION_UPDATED = 'pagination:updated';
var EVENT_NAVIGATION_MOUNTED = 'navigation:mounted';
var EVENT_AUTOPLAY_PLAY = 'autoplay:play';
var EVENT_AUTOPLAY_PLAYING = 'autoplay:playing';
var EVENT_AUTOPLAY_PAUSE = 'autoplay:pause';
var EVENT_LAZYLOAD_LOADED = 'lazyload:loaded';
var EVENT_SLIDE_KEYDOWN = 'sk';
var EVENT_SHIFTED = 'sh';
var EVENT_END_INDEX_CHANGED = 'ei';
function EventInterface(Splide2) {
  var bus = Splide2 ? Splide2.event.bus : document.createDocumentFragment();
  var binder = EventBinder();
  function on(events, callback) {
    binder.bind(bus, toArray(events).join(' '), function(e) {
      callback.apply(callback, isArray(e.detail) ? e.detail : []);
    });
  }
  function emit(event) {
    binder.dispatch(bus, event, slice(arguments, 1));
  }
  if (Splide2) {
    Splide2.event.on(EVENT_DESTROY, binder.destroy);
  }
  return assign(binder, {
    bus,
    on,
    off: apply(binder.unbind, bus),
    emit
  });
}
function RequestInterval(interval, onInterval, onUpdate, limit) {
  var now = Date.now;
  var startTime;
  var rate = 0;
  var id;
  var paused = true;
  var count = 0;
  function update() {
    if (!paused) {
      rate = interval ? min((now() - startTime) / interval, 1) : 1;
      onUpdate && onUpdate(rate);
      if (rate >= 1) {
        onInterval();
        startTime = now();
        if (limit && ++count >= limit) {
          return pause();
        }
      }
      id = raf(update);
    }
  }
  function start(resume) {
    resume || cancel();
    startTime = now() - (resume ? rate * interval : 0);
    paused = false;
    id = raf(update);
  }
  function pause() {
    paused = true;
  }
  function rewind() {
    startTime = now();
    rate = 0;
    if (onUpdate) {
      onUpdate(rate);
    }
  }
  function cancel() {
    id && cancelAnimationFrame(id);
    rate = 0;
    id = 0;
    paused = true;
  }
  function set(time) {
    interval = time;
  }
  function isPaused() {
    return paused;
  }
  return {
    start,
    rewind,
    pause,
    cancel,
    set,
    isPaused
  };
}
function State(initialState) {
  var state = initialState;
  function set(value) {
    state = value;
  }
  function is(states) {
    return includes(toArray(states), state);
  }
  return {
    set,
    is
  };
}
function Throttle(func, duration2) {
  var interval = RequestInterval(duration2 || 0, func, null, 1);
  return function() {
    interval.isPaused() && interval.start();
  };
}
function Media(Splide2, Components2, options) {
  var state = Splide2.state;
  var breakpoints = options.breakpoints || {};
  var reducedMotion = options.reducedMotion || {};
  var binder = EventBinder();
  var queries = [];
  function setup() {
    var isMin = options.mediaQuery === 'min';
    ownKeys(breakpoints).sort(function(n, m) {
      return isMin ? +n - +m : +m - +n;
    }).forEach(function(key) {
      register(breakpoints[key], '(' + (isMin ? 'min' : 'max') + '-width:' + key + 'px)');
    });
    register(reducedMotion, MEDIA_PREFERS_REDUCED_MOTION);
    update();
  }
  function destroy(completely) {
    if (completely) {
      binder.destroy();
    }
  }
  function register(options2, query2) {
    var queryList = matchMedia(query2);
    binder.bind(queryList, 'change', update);
    queries.push([options2, queryList]);
  }
  function update() {
    var destroyed = state.is(DESTROYED);
    var direction = options.direction;
    var merged = queries.reduce(function(merged2, entry) {
      return merge(merged2, entry[1].matches ? entry[0] : {});
    }, {});
    omit(options);
    set(merged);
    if (options.destroy) {
      Splide2.destroy(options.destroy === 'completely');
    } else if (destroyed) {
      destroy(true);
      Splide2.mount();
    } else {
      direction !== options.direction && Splide2.refresh();
    }
  }
  function reduce(enable) {
    if (matchMedia(MEDIA_PREFERS_REDUCED_MOTION).matches) {
      enable ? merge(options, reducedMotion) : omit(options, ownKeys(reducedMotion));
    }
  }
  function set(opts, base, notify) {
    merge(options, opts);
    base && merge(Object.getPrototypeOf(options), opts);
    if (notify || !state.is(CREATED)) {
      Splide2.emit(EVENT_UPDATED, options);
    }
  }
  return {
    setup,
    destroy,
    reduce,
    set
  };
}
var ARROW = 'Arrow';
var ARROW_LEFT = ARROW + 'Left';
var ARROW_RIGHT = ARROW + 'Right';
var ARROW_UP = ARROW + 'Up';
var ARROW_DOWN = ARROW + 'Down';
var RTL = 'rtl';
var TTB = 'ttb';
var ORIENTATION_MAP = {
  width: ['height'],
  left: ['top', 'right'],
  right: ['bottom', 'left'],
  x: ['y'],
  X: ['Y'],
  Y: ['X'],
  ArrowLeft: [ARROW_UP, ARROW_RIGHT],
  ArrowRight: [ARROW_DOWN, ARROW_LEFT]
};
function Direction(Splide2, Components2, options) {
  function resolve(prop, axisOnly, direction) {
    direction = direction || options.direction;
    var index = direction === RTL && !axisOnly ? 1 : direction === TTB ? 0 : -1;
    return ORIENTATION_MAP[prop] && ORIENTATION_MAP[prop][index] || prop.replace(/width|left|right/i, function(match, offset) {
      var replacement = ORIENTATION_MAP[match.toLowerCase()][index] || match;
      return offset > 0 ? replacement.charAt(0).toUpperCase() + replacement.slice(1) : replacement;
    });
  }
  function orient(value) {
    return value * (options.direction === RTL ? 1 : -1);
  }
  return {
    resolve,
    orient
  };
}
var ROLE = 'role';
var TAB_INDEX = 'tabindex';
var DISABLED = 'disabled';
var ARIA_PREFIX = 'aria-';
var ARIA_CONTROLS = ARIA_PREFIX + 'controls';
var ARIA_CURRENT = ARIA_PREFIX + 'current';
var ARIA_SELECTED = ARIA_PREFIX + 'selected';
var ARIA_LABEL = ARIA_PREFIX + 'label';
var ARIA_LABELLEDBY = ARIA_PREFIX + 'labelledby';
var ARIA_HIDDEN = ARIA_PREFIX + 'hidden';
var ARIA_ORIENTATION = ARIA_PREFIX + 'orientation';
var ARIA_ROLEDESCRIPTION = ARIA_PREFIX + 'roledescription';
var ARIA_LIVE = ARIA_PREFIX + 'live';
var ARIA_BUSY = ARIA_PREFIX + 'busy';
var ARIA_ATOMIC = ARIA_PREFIX + 'atomic';
var ALL_ATTRIBUTES = [ROLE, TAB_INDEX, DISABLED, ARIA_CONTROLS, ARIA_CURRENT, ARIA_LABEL, ARIA_LABELLEDBY, ARIA_HIDDEN, ARIA_ORIENTATION, ARIA_ROLEDESCRIPTION];
var CLASS_PREFIX = PROJECT_CODE + '__';
var STATUS_CLASS_PREFIX = 'is-';
var CLASS_ROOT = PROJECT_CODE;
var CLASS_TRACK = CLASS_PREFIX + 'track';
var CLASS_LIST = CLASS_PREFIX + 'list';
var CLASS_SLIDE = CLASS_PREFIX + 'slide';
var CLASS_CLONE = CLASS_SLIDE + '--clone';
var CLASS_CONTAINER = CLASS_SLIDE + '__container';
var CLASS_ARROWS = CLASS_PREFIX + 'arrows';
var CLASS_ARROW = CLASS_PREFIX + 'arrow';
var CLASS_ARROW_PREV = CLASS_ARROW + '--prev';
var CLASS_ARROW_NEXT = CLASS_ARROW + '--next';
var CLASS_PAGINATION = CLASS_PREFIX + 'pagination';
var CLASS_PAGINATION_PAGE = CLASS_PAGINATION + '__page';
var CLASS_PROGRESS = CLASS_PREFIX + 'progress';
var CLASS_PROGRESS_BAR = CLASS_PROGRESS + '__bar';
var CLASS_TOGGLE = CLASS_PREFIX + 'toggle';
var CLASS_TOGGLE_PLAY = CLASS_TOGGLE + '__play';
var CLASS_TOGGLE_PAUSE = CLASS_TOGGLE + '__pause';
var CLASS_SPINNER = CLASS_PREFIX + 'spinner';
var CLASS_SR = CLASS_PREFIX + 'sr';
var CLASS_INITIALIZED = STATUS_CLASS_PREFIX + 'initialized';
var CLASS_ACTIVE = STATUS_CLASS_PREFIX + 'active';
var CLASS_PREV = STATUS_CLASS_PREFIX + 'prev';
var CLASS_NEXT = STATUS_CLASS_PREFIX + 'next';
var CLASS_VISIBLE = STATUS_CLASS_PREFIX + 'visible';
var CLASS_LOADING = STATUS_CLASS_PREFIX + 'loading';
var CLASS_FOCUS_IN = STATUS_CLASS_PREFIX + 'focus-in';
var CLASS_OVERFLOW = STATUS_CLASS_PREFIX + 'overflow';
var STATUS_CLASSES = [CLASS_ACTIVE, CLASS_VISIBLE, CLASS_PREV, CLASS_NEXT, CLASS_LOADING, CLASS_FOCUS_IN, CLASS_OVERFLOW];
var CLASSES = {
  slide: CLASS_SLIDE,
  clone: CLASS_CLONE,
  arrows: CLASS_ARROWS,
  arrow: CLASS_ARROW,
  prev: CLASS_ARROW_PREV,
  next: CLASS_ARROW_NEXT,
  pagination: CLASS_PAGINATION,
  page: CLASS_PAGINATION_PAGE,
  spinner: CLASS_SPINNER
};
function closest(from, selector) {
  if (isFunction(from.closest)) {
    return from.closest(selector);
  }
  var elm = from;
  while (elm && elm.nodeType === 1) {
    if (matches(elm, selector)) {
      break;
    }
    elm = elm.parentElement;
  }
  return elm;
}
var FRICTION = 5;
var LOG_INTERVAL = 200;
var POINTER_DOWN_EVENTS = 'touchstart mousedown';
var POINTER_MOVE_EVENTS = 'touchmove mousemove';
var POINTER_UP_EVENTS = 'touchend touchcancel mouseup click';
function Elements(Splide2, Components2, options) {
  var _EventInterface = EventInterface(Splide2), on = _EventInterface.on, bind = _EventInterface.bind;
  var root = Splide2.root;
  var i18n = options.i18n;
  var elements = {};
  var slides = [];
  var rootClasses = [];
  var trackClasses = [];
  var track;
  var list;
  var isUsingKey;
  function setup() {
    collect();
    init();
    update();
  }
  function mount() {
    on(EVENT_REFRESH, destroy);
    on(EVENT_REFRESH, setup);
    on(EVENT_UPDATED, update);
    bind(document, POINTER_DOWN_EVENTS + ' keydown', function(e) {
      isUsingKey = e.type === 'keydown';
    }, {
      capture: true
    });
    bind(root, 'focusin', function() {
      toggleClass(root, CLASS_FOCUS_IN, !!isUsingKey);
    });
  }
  function destroy(completely) {
    var attrs = ALL_ATTRIBUTES.concat('style');
    empty(slides);
    removeClass(root, rootClasses);
    removeClass(track, trackClasses);
    removeAttribute([track, list], attrs);
    removeAttribute(root, completely ? attrs : ['style', ARIA_ROLEDESCRIPTION]);
  }
  function update() {
    removeClass(root, rootClasses);
    removeClass(track, trackClasses);
    rootClasses = getClasses(CLASS_ROOT);
    trackClasses = getClasses(CLASS_TRACK);
    addClass(root, rootClasses);
    addClass(track, trackClasses);
    setAttribute(root, ARIA_LABEL, options.label);
    setAttribute(root, ARIA_LABELLEDBY, options.labelledby);
  }
  function collect() {
    track = find('.' + CLASS_TRACK);
    list = child(track, '.' + CLASS_LIST);
    assert(track && list, 'A track/list element is missing.');
    push(slides, children(list, '.' + CLASS_SLIDE + ':not(.' + CLASS_CLONE + ')'));
    forOwn({
      arrows: CLASS_ARROWS,
      pagination: CLASS_PAGINATION,
      prev: CLASS_ARROW_PREV,
      next: CLASS_ARROW_NEXT,
      bar: CLASS_PROGRESS_BAR,
      toggle: CLASS_TOGGLE
    }, function(className, key) {
      elements[key] = find('.' + className);
    });
    assign(elements, {
      root,
      track,
      list,
      slides
    });
  }
  function init() {
    var id = root.id || uniqueId(PROJECT_CODE);
    var role = options.role;
    root.id = id;
    track.id = track.id || id + '-track';
    list.id = list.id || id + '-list';
    if (!getAttribute(root, ROLE) && root.tagName !== 'SECTION' && role) {
      setAttribute(root, ROLE, role);
    }
    setAttribute(root, ARIA_ROLEDESCRIPTION, i18n.carousel);
    setAttribute(list, ROLE, 'presentation');
  }
  function find(selector) {
    var elm = query(root, selector);
    return elm && closest(elm, '.' + CLASS_ROOT) === root ? elm : void 0;
  }
  function getClasses(base) {
    return [base + '--' + options.type, base + '--' + options.direction, options.drag && base + '--draggable', options.isNavigation && base + '--nav', base === CLASS_ROOT && CLASS_ACTIVE];
  }
  return assign(elements, {
    setup,
    mount,
    destroy
  });
}
var SLIDE = 'slide';
var LOOP = 'loop';
var FADE = 'fade';
function Slide$1(Splide2, index, slideIndex, slide) {
  var event = EventInterface(Splide2);
  var on = event.on, emit = event.emit, bind = event.bind;
  var Components = Splide2.Components, root = Splide2.root, options = Splide2.options;
  var isNavigation = options.isNavigation, updateOnMove = options.updateOnMove, i18n = options.i18n, pagination = options.pagination, slideFocus = options.slideFocus;
  var resolve = Components.Direction.resolve;
  var styles = getAttribute(slide, 'style');
  var label = getAttribute(slide, ARIA_LABEL);
  var isClone = slideIndex > -1;
  var container = child(slide, '.' + CLASS_CONTAINER);
  var destroyed;
  function mount() {
    if (!isClone) {
      slide.id = root.id + '-slide' + pad(index + 1);
      setAttribute(slide, ROLE, pagination ? 'tabpanel' : 'group');
      setAttribute(slide, ARIA_ROLEDESCRIPTION, i18n.slide);
      setAttribute(slide, ARIA_LABEL, label || format(i18n.slideLabel, [index + 1, Splide2.length]));
    }
    listen();
  }
  function listen() {
    bind(slide, 'click', apply(emit, EVENT_CLICK, self2));
    bind(slide, 'keydown', apply(emit, EVENT_SLIDE_KEYDOWN, self2));
    on([EVENT_MOVED, EVENT_SHIFTED, EVENT_SCROLLED], update);
    on(EVENT_NAVIGATION_MOUNTED, initNavigation);
    if (updateOnMove) {
      on(EVENT_MOVE, onMove);
    }
  }
  function destroy() {
    destroyed = true;
    event.destroy();
    removeClass(slide, STATUS_CLASSES);
    removeAttribute(slide, ALL_ATTRIBUTES);
    setAttribute(slide, 'style', styles);
    setAttribute(slide, ARIA_LABEL, label || '');
  }
  function initNavigation() {
    var controls = Splide2.splides.map(function(target) {
      var Slide2 = target.splide.Components.Slides.getAt(index);
      return Slide2 ? Slide2.slide.id : '';
    }).join(' ');
    setAttribute(slide, ARIA_LABEL, format(i18n.slideX, (isClone ? slideIndex : index) + 1));
    setAttribute(slide, ARIA_CONTROLS, controls);
    setAttribute(slide, ROLE, slideFocus ? 'button' : '');
    slideFocus && removeAttribute(slide, ARIA_ROLEDESCRIPTION);
  }
  function onMove() {
    if (!destroyed) {
      update();
    }
  }
  function update() {
    if (!destroyed) {
      var curr = Splide2.index;
      updateActivity();
      updateVisibility();
      toggleClass(slide, CLASS_PREV, index === curr - 1);
      toggleClass(slide, CLASS_NEXT, index === curr + 1);
    }
  }
  function updateActivity() {
    var active = isActive();
    if (active !== hasClass(slide, CLASS_ACTIVE)) {
      toggleClass(slide, CLASS_ACTIVE, active);
      setAttribute(slide, ARIA_CURRENT, isNavigation && active || '');
      emit(active ? EVENT_ACTIVE : EVENT_INACTIVE, self2);
    }
  }
  function updateVisibility() {
    var visible = isVisible();
    var hidden = !visible && (!isActive() || isClone);
    if (!Splide2.state.is([MOVING, SCROLLING])) {
      setAttribute(slide, ARIA_HIDDEN, hidden || '');
    }
    setAttribute(queryAll(slide, options.focusableNodes || ''), TAB_INDEX, hidden ? -1 : '');
    if (slideFocus) {
      setAttribute(slide, TAB_INDEX, hidden ? -1 : 0);
    }
    if (visible !== hasClass(slide, CLASS_VISIBLE)) {
      toggleClass(slide, CLASS_VISIBLE, visible);
      emit(visible ? EVENT_VISIBLE : EVENT_HIDDEN, self2);
    }
    if (!visible && document.activeElement === slide) {
      var Slide2 = Components.Slides.getAt(Splide2.index);
      Slide2 && focus(Slide2.slide);
    }
  }
  function style$1(prop, value, useContainer) {
    style(useContainer && container || slide, prop, value);
  }
  function isActive() {
    var curr = Splide2.index;
    return curr === index || options.cloneStatus && curr === slideIndex;
  }
  function isVisible() {
    if (Splide2.is(FADE)) {
      return isActive();
    }
    var trackRect = rect(Components.Elements.track);
    var slideRect = rect(slide);
    var left = resolve('left', true);
    var right = resolve('right', true);
    return floor(trackRect[left]) <= ceil(slideRect[left]) && floor(slideRect[right]) <= ceil(trackRect[right]);
  }
  function isWithin(from, distance) {
    var diff = abs(from - index);
    if (!isClone && (options.rewind || Splide2.is(LOOP))) {
      diff = min(diff, Splide2.length - diff);
    }
    return diff <= distance;
  }
  var self2 = {
    index,
    slideIndex,
    slide,
    container,
    isClone,
    mount,
    destroy,
    update,
    style: style$1,
    isWithin
  };
  return self2;
}
function Slides(Splide2, Components2, options) {
  var _EventInterface2 = EventInterface(Splide2), on = _EventInterface2.on, emit = _EventInterface2.emit, bind = _EventInterface2.bind;
  var _Components2$Elements = Components2.Elements, slides = _Components2$Elements.slides, list = _Components2$Elements.list;
  var Slides2 = [];
  function mount() {
    init();
    on(EVENT_REFRESH, destroy);
    on(EVENT_REFRESH, init);
  }
  function init() {
    slides.forEach(function(slide, index) {
      register(slide, index, -1);
    });
  }
  function destroy() {
    forEach$1(function(Slide2) {
      Slide2.destroy();
    });
    empty(Slides2);
  }
  function update() {
    forEach$1(function(Slide2) {
      Slide2.update();
    });
  }
  function register(slide, index, slideIndex) {
    var object = Slide$1(Splide2, index, slideIndex, slide);
    object.mount();
    Slides2.push(object);
    Slides2.sort(function(Slide1, Slide2) {
      return Slide1.index - Slide2.index;
    });
  }
  function get(excludeClones) {
    return excludeClones ? filter(function(Slide2) {
      return !Slide2.isClone;
    }) : Slides2;
  }
  function getIn(page) {
    var Controller2 = Components2.Controller;
    var index = Controller2.toIndex(page);
    var max2 = Controller2.hasFocus() ? 1 : options.perPage;
    return filter(function(Slide2) {
      return between(Slide2.index, index, index + max2 - 1);
    });
  }
  function getAt(index) {
    return filter(index)[0];
  }
  function add(items, index) {
    forEach(items, function(slide) {
      if (isString(slide)) {
        slide = parseHtml(slide);
      }
      if (isHTMLElement(slide)) {
        var ref = slides[index];
        ref ? before(slide, ref) : append(list, slide);
        addClass(slide, options.classes.slide);
        observeImages(slide, apply(emit, EVENT_RESIZE));
      }
    });
    emit(EVENT_REFRESH);
  }
  function remove$1(matcher) {
    remove(filter(matcher).map(function(Slide2) {
      return Slide2.slide;
    }));
    emit(EVENT_REFRESH);
  }
  function forEach$1(iteratee, excludeClones) {
    get(excludeClones).forEach(iteratee);
  }
  function filter(matcher) {
    return Slides2.filter(isFunction(matcher) ? matcher : function(Slide2) {
      return isString(matcher) ? matches(Slide2.slide, matcher) : includes(toArray(matcher), Slide2.index);
    });
  }
  function style2(prop, value, useContainer) {
    forEach$1(function(Slide2) {
      Slide2.style(prop, value, useContainer);
    });
  }
  function observeImages(elm, callback) {
    var images = queryAll(elm, 'img');
    var length = images.length;
    if (length) {
      images.forEach(function(img) {
        bind(img, 'load error', function() {
          if (!--length) {
            callback();
          }
        });
      });
    } else {
      callback();
    }
  }
  function getLength(excludeClones) {
    return excludeClones ? slides.length : Slides2.length;
  }
  function isEnough() {
    return Slides2.length > options.perPage;
  }
  return {
    mount,
    destroy,
    update,
    register,
    get,
    getIn,
    getAt,
    add,
    remove: remove$1,
    forEach: forEach$1,
    filter,
    style: style2,
    getLength,
    isEnough
  };
}
function Layout(Splide2, Components2, options) {
  var _EventInterface3 = EventInterface(Splide2), on = _EventInterface3.on, bind = _EventInterface3.bind, emit = _EventInterface3.emit;
  var Slides2 = Components2.Slides;
  var resolve = Components2.Direction.resolve;
  var _Components2$Elements2 = Components2.Elements, root = _Components2$Elements2.root, track = _Components2$Elements2.track, list = _Components2$Elements2.list;
  var getAt = Slides2.getAt, styleSlides = Slides2.style;
  var vertical;
  var rootRect;
  var overflow;
  function mount() {
    init();
    bind(window, 'resize load', Throttle(apply(emit, EVENT_RESIZE)));
    on([EVENT_UPDATED, EVENT_REFRESH], init);
    on(EVENT_RESIZE, resize);
  }
  function init() {
    vertical = options.direction === TTB;
    style(root, 'maxWidth', unit(options.width));
    style(track, resolve('paddingLeft'), cssPadding(false));
    style(track, resolve('paddingRight'), cssPadding(true));
    resize(true);
  }
  function resize(force) {
    var newRect = rect(root);
    if (force || rootRect.width !== newRect.width || rootRect.height !== newRect.height) {
      style(track, 'height', cssTrackHeight());
      styleSlides(resolve('marginRight'), unit(options.gap));
      styleSlides('width', cssSlideWidth());
      styleSlides('height', cssSlideHeight(), true);
      rootRect = newRect;
      emit(EVENT_RESIZED);
      if (overflow !== (overflow = isOverflow())) {
        toggleClass(root, CLASS_OVERFLOW, overflow);
        emit(EVENT_OVERFLOW, overflow);
      }
    }
  }
  function cssPadding(right) {
    var padding = options.padding;
    var prop = resolve(right ? 'right' : 'left');
    return padding && unit(padding[prop] || (isObject(padding) ? 0 : padding)) || '0px';
  }
  function cssTrackHeight() {
    var height = '';
    if (vertical) {
      height = cssHeight();
      assert(height, 'height or heightRatio is missing.');
      height = 'calc(' + height + ' - ' + cssPadding(false) + ' - ' + cssPadding(true) + ')';
    }
    return height;
  }
  function cssHeight() {
    return unit(options.height || rect(list).width * options.heightRatio);
  }
  function cssSlideWidth() {
    return options.autoWidth ? null : unit(options.fixedWidth) || (vertical ? '' : cssSlideSize());
  }
  function cssSlideHeight() {
    return unit(options.fixedHeight) || (vertical ? options.autoHeight ? null : cssSlideSize() : cssHeight());
  }
  function cssSlideSize() {
    var gap = unit(options.gap);
    return 'calc((100%' + (gap && ' + ' + gap) + ')/' + (options.perPage || 1) + (gap && ' - ' + gap) + ')';
  }
  function listSize() {
    return rect(list)[resolve('width')];
  }
  function slideSize(index, withoutGap) {
    var Slide2 = getAt(index || 0);
    return Slide2 ? rect(Slide2.slide)[resolve('width')] + (withoutGap ? 0 : getGap()) : 0;
  }
  function totalSize(index, withoutGap) {
    var Slide2 = getAt(index);
    if (Slide2) {
      var right = rect(Slide2.slide)[resolve('right')];
      var left = rect(list)[resolve('left')];
      return abs(right - left) + (withoutGap ? 0 : getGap());
    }
    return 0;
  }
  function sliderSize(withoutGap) {
    return totalSize(Splide2.length - 1) - totalSize(0) + slideSize(0, withoutGap);
  }
  function getGap() {
    var Slide2 = getAt(0);
    return Slide2 && parseFloat(style(Slide2.slide, resolve('marginRight'))) || 0;
  }
  function getPadding(right) {
    return parseFloat(style(track, resolve('padding' + (right ? 'Right' : 'Left')))) || 0;
  }
  function isOverflow() {
    return Splide2.is(FADE) || sliderSize(true) > listSize();
  }
  return {
    mount,
    resize,
    listSize,
    slideSize,
    sliderSize,
    totalSize,
    getPadding,
    isOverflow
  };
}
var MULTIPLIER = 2;
function Clones(Splide2, Components2, options) {
  var event = EventInterface(Splide2);
  var on = event.on;
  var Elements2 = Components2.Elements, Slides2 = Components2.Slides;
  var resolve = Components2.Direction.resolve;
  var clones = [];
  var cloneCount;
  function mount() {
    on(EVENT_REFRESH, remount);
    on([EVENT_UPDATED, EVENT_RESIZE], observe);
    if ((cloneCount = computeCloneCount())) {
      generate(cloneCount);
      Components2.Layout.resize(true);
    }
  }
  function remount() {
    destroy();
    mount();
  }
  function destroy() {
    remove(clones);
    empty(clones);
    event.destroy();
  }
  function observe() {
    var count = computeCloneCount();
    if (cloneCount !== count) {
      if (cloneCount < count || !count) {
        event.emit(EVENT_REFRESH);
      }
    }
  }
  function generate(count) {
    var slides = Slides2.get().slice();
    var length = slides.length;
    if (length) {
      while (slides.length < count) {
        push(slides, slides);
      }
      push(slides.slice(-count), slides.slice(0, count)).forEach(function(Slide2, index) {
        var isHead = index < count;
        var clone = cloneDeep(Slide2.slide, index);
        isHead ? before(clone, slides[0].slide) : append(Elements2.list, clone);
        push(clones, clone);
        Slides2.register(clone, index - count + (isHead ? 0 : length), Slide2.index);
      });
    }
  }
  function cloneDeep(elm, index) {
    var clone = elm.cloneNode(true);
    addClass(clone, options.classes.clone);
    clone.id = Splide2.root.id + '-clone' + pad(index + 1);
    return clone;
  }
  function computeCloneCount() {
    var clones2 = options.clones;
    if (!Splide2.is(LOOP)) {
      clones2 = 0;
    } else if (isUndefined(clones2)) {
      var fixedSize = options[resolve('fixedWidth')] && Components2.Layout.slideSize(0);
      var fixedCount = fixedSize && ceil(rect(Elements2.track)[resolve('width')] / fixedSize);
      clones2 = fixedCount || options[resolve('autoWidth')] && Splide2.length || options.perPage * MULTIPLIER;
    }
    return clones2;
  }
  return {
    mount,
    destroy
  };
}
function Move(Splide2, Components2, options) {
  var _EventInterface4 = EventInterface(Splide2), on = _EventInterface4.on, emit = _EventInterface4.emit;
  var set = Splide2.state.set;
  var _Components2$Layout = Components2.Layout, slideSize = _Components2$Layout.slideSize, getPadding = _Components2$Layout.getPadding, totalSize = _Components2$Layout.totalSize, listSize = _Components2$Layout.listSize, sliderSize = _Components2$Layout.sliderSize;
  var _Components2$Directio = Components2.Direction, resolve = _Components2$Directio.resolve, orient = _Components2$Directio.orient;
  var _Components2$Elements3 = Components2.Elements, list = _Components2$Elements3.list, track = _Components2$Elements3.track;
  var Transition;
  function mount() {
    Transition = Components2.Transition;
    on([EVENT_MOUNTED, EVENT_RESIZED, EVENT_UPDATED, EVENT_REFRESH], reposition);
  }
  function reposition() {
    if (!Components2.Controller.isBusy()) {
      Components2.Scroll.cancel();
      jump(Splide2.index);
      Components2.Slides.update();
    }
  }
  function move(dest, index, prev, callback) {
    if (dest !== index && canShift(dest > prev)) {
      cancel();
      translate(shift(getPosition(), dest > prev), true);
    }
    set(MOVING);
    emit(EVENT_MOVE, index, prev, dest);
    Transition.start(index, function() {
      set(IDLE);
      emit(EVENT_MOVED, index, prev, dest);
      callback && callback();
    });
  }
  function jump(index) {
    translate(toPosition(index, true));
  }
  function translate(position, preventLoop) {
    if (!Splide2.is(FADE)) {
      var destination = preventLoop ? position : loop(position);
      style(list, 'transform', 'translate' + resolve('X') + '(' + destination + 'px)');
      position !== destination && emit(EVENT_SHIFTED);
    }
  }
  function loop(position) {
    if (Splide2.is(LOOP)) {
      var index = toIndex(position);
      var exceededMax = index > Components2.Controller.getEnd();
      var exceededMin = index < 0;
      if (exceededMin || exceededMax) {
        position = shift(position, exceededMax);
      }
    }
    return position;
  }
  function shift(position, backwards) {
    var excess = position - getLimit(backwards);
    var size = sliderSize();
    position -= orient(size * (ceil(abs(excess) / size) || 1)) * (backwards ? 1 : -1);
    return position;
  }
  function cancel() {
    translate(getPosition(), true);
    Transition.cancel();
  }
  function toIndex(position) {
    var Slides2 = Components2.Slides.get();
    var index = 0;
    var minDistance = Infinity;
    for (var i = 0; i < Slides2.length; i++) {
      var slideIndex = Slides2[i].index;
      var distance = abs(toPosition(slideIndex, true) - position);
      if (distance <= minDistance) {
        minDistance = distance;
        index = slideIndex;
      } else {
        break;
      }
    }
    return index;
  }
  function toPosition(index, trimming) {
    var position = orient(totalSize(index - 1) - offset(index));
    return trimming ? trim(position) : position;
  }
  function getPosition() {
    var left = resolve('left');
    return rect(list)[left] - rect(track)[left] + orient(getPadding(false));
  }
  function trim(position) {
    if (options.trimSpace && Splide2.is(SLIDE)) {
      position = clamp(position, 0, orient(sliderSize(true) - listSize()));
    }
    return position;
  }
  function offset(index) {
    var focus2 = options.focus;
    return focus2 === 'center' ? (listSize() - slideSize(index, true)) / 2 : +focus2 * slideSize(index) || 0;
  }
  function getLimit(max2) {
    return toPosition(max2 ? Components2.Controller.getEnd() : 0, !!options.trimSpace);
  }
  function canShift(backwards) {
    var shifted = orient(shift(getPosition(), backwards));
    return backwards ? shifted >= 0 : shifted <= list[resolve('scrollWidth')] - rect(track)[resolve('width')];
  }
  function exceededLimit(max2, position) {
    position = isUndefined(position) ? getPosition() : position;
    var exceededMin = max2 !== true && orient(position) < orient(getLimit(false));
    var exceededMax = max2 !== false && orient(position) > orient(getLimit(true));
    return exceededMin || exceededMax;
  }
  return {
    mount,
    move,
    jump,
    translate,
    shift,
    cancel,
    toIndex,
    toPosition,
    getPosition,
    getLimit,
    exceededLimit,
    reposition
  };
}
function Controller(Splide2, Components2, options) {
  var _EventInterface5 = EventInterface(Splide2), on = _EventInterface5.on, emit = _EventInterface5.emit;
  var Move2 = Components2.Move;
  var getPosition = Move2.getPosition, getLimit = Move2.getLimit, toPosition = Move2.toPosition;
  var _Components2$Slides = Components2.Slides, isEnough = _Components2$Slides.isEnough, getLength = _Components2$Slides.getLength;
  var omitEnd = options.omitEnd;
  var isLoop = Splide2.is(LOOP);
  var isSlide = Splide2.is(SLIDE);
  var getNext = apply(getAdjacent, false);
  var getPrev = apply(getAdjacent, true);
  var currIndex = options.start || 0;
  var endIndex;
  var prevIndex = currIndex;
  var slideCount;
  var perMove;
  var perPage;
  function mount() {
    init();
    on([EVENT_UPDATED, EVENT_REFRESH, EVENT_END_INDEX_CHANGED], init);
    on(EVENT_RESIZED, onResized);
  }
  function init() {
    slideCount = getLength(true);
    perMove = options.perMove;
    perPage = options.perPage;
    endIndex = getEnd();
    var index = clamp(currIndex, 0, omitEnd ? endIndex : slideCount - 1);
    if (index !== currIndex) {
      currIndex = index;
      Move2.reposition();
    }
  }
  function onResized() {
    if (endIndex !== getEnd()) {
      emit(EVENT_END_INDEX_CHANGED);
    }
  }
  function go(control, allowSameIndex, callback) {
    if (!isBusy()) {
      var dest = parse(control);
      var index = loop(dest);
      if (index > -1 && (allowSameIndex || index !== currIndex)) {
        setIndex(index);
        Move2.move(dest, index, prevIndex, callback);
      }
    }
  }
  function scroll(destination, duration2, snap, callback) {
    Components2.Scroll.scroll(destination, duration2, snap, function() {
      var index = loop(Move2.toIndex(getPosition()));
      setIndex(omitEnd ? min(index, endIndex) : index);
      callback && callback();
    });
  }
  function parse(control) {
    var index = currIndex;
    if (isString(control)) {
      var _ref = control.match(/([+\-<>])(\d+)?/) || [], indicator = _ref[1], number = _ref[2];
      if (indicator === '+' || indicator === '-') {
        index = computeDestIndex(currIndex + +('' + indicator + (+number || 1)), currIndex);
      } else if (indicator === '>') {
        index = number ? toIndex(+number) : getNext(true);
      } else if (indicator === '<') {
        index = getPrev(true);
      }
    } else {
      index = isLoop ? control : clamp(control, 0, endIndex);
    }
    return index;
  }
  function getAdjacent(prev, destination) {
    var number = perMove || (hasFocus() ? 1 : perPage);
    var dest = computeDestIndex(currIndex + number * (prev ? -1 : 1), currIndex, !(perMove || hasFocus()));
    if (dest === -1 && isSlide) {
      if (!approximatelyEqual(getPosition(), getLimit(!prev), 1)) {
        return prev ? 0 : endIndex;
      }
    }
    return destination ? dest : loop(dest);
  }
  function computeDestIndex(dest, from, snapPage) {
    if (isEnough() || hasFocus()) {
      var index = computeMovableDestIndex(dest);
      if (index !== dest) {
        from = dest;
        dest = index;
        snapPage = false;
      }
      if (dest < 0 || dest > endIndex) {
        if (!perMove && (between(0, dest, from, true) || between(endIndex, from, dest, true))) {
          dest = toIndex(toPage(dest));
        } else {
          if (isLoop) {
            dest = snapPage ? dest < 0 ? -(slideCount % perPage || perPage) : slideCount : dest;
          } else if (options.rewind) {
            dest = dest < 0 ? endIndex : 0;
          } else {
            dest = -1;
          }
        }
      } else {
        if (snapPage && dest !== from) {
          dest = toIndex(toPage(from) + (dest < from ? -1 : 1));
        }
      }
    } else {
      dest = -1;
    }
    return dest;
  }
  function computeMovableDestIndex(dest) {
    if (isSlide && options.trimSpace === 'move' && dest !== currIndex) {
      var position = getPosition();
      while (position === toPosition(dest, true) && between(dest, 0, Splide2.length - 1, !options.rewind)) {
        dest < currIndex ? --dest : ++dest;
      }
    }
    return dest;
  }
  function loop(index) {
    return isLoop ? (index + slideCount) % slideCount || 0 : index;
  }
  function getEnd() {
    var end = slideCount - (hasFocus() || isLoop && perMove ? 1 : perPage);
    while (omitEnd && end-- > 0) {
      if (toPosition(slideCount - 1, true) !== toPosition(end, true)) {
        end++;
        break;
      }
    }
    return clamp(end, 0, slideCount - 1);
  }
  function toIndex(page) {
    return clamp(hasFocus() ? page : perPage * page, 0, endIndex);
  }
  function toPage(index) {
    return hasFocus() ? min(index, endIndex) : floor((index >= endIndex ? slideCount - 1 : index) / perPage);
  }
  function toDest(destination) {
    var closest2 = Move2.toIndex(destination);
    return isSlide ? clamp(closest2, 0, endIndex) : closest2;
  }
  function setIndex(index) {
    if (index !== currIndex) {
      prevIndex = currIndex;
      currIndex = index;
    }
  }
  function getIndex(prev) {
    return prev ? prevIndex : currIndex;
  }
  function hasFocus() {
    return !isUndefined(options.focus) || options.isNavigation;
  }
  function isBusy() {
    return Splide2.state.is([MOVING, SCROLLING]) && !!options.waitForTransition;
  }
  return {
    mount,
    go,
    scroll,
    getNext,
    getPrev,
    getAdjacent,
    getEnd,
    setIndex,
    getIndex,
    toIndex,
    toPage,
    toDest,
    hasFocus,
    isBusy
  };
}
var XML_NAME_SPACE = 'http://www.w3.org/2000/svg';
var PATH = 'm15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z';
var SIZE = 40;
function Arrows(Splide2, Components2, options) {
  var event = EventInterface(Splide2);
  var on = event.on, bind = event.bind, emit = event.emit;
  var classes = options.classes, i18n = options.i18n;
  var Elements2 = Components2.Elements, Controller2 = Components2.Controller;
  var placeholder = Elements2.arrows, track = Elements2.track;
  var wrapper = placeholder;
  var prev = Elements2.prev;
  var next = Elements2.next;
  var created;
  var wrapperClasses;
  var arrows = {};
  function mount() {
    init();
    on(EVENT_UPDATED, remount);
  }
  function remount() {
    destroy();
    mount();
  }
  function init() {
    var enabled = options.arrows;
    if (enabled && !(prev && next)) {
      createArrows();
    }
    if (prev && next) {
      assign(arrows, {
        prev,
        next
      });
      display(wrapper, enabled ? '' : 'none');
      addClass(wrapper, wrapperClasses = CLASS_ARROWS + '--' + options.direction);
      if (enabled) {
        listen();
        update();
        setAttribute([prev, next], ARIA_CONTROLS, track.id);
        emit(EVENT_ARROWS_MOUNTED, prev, next);
      }
    }
  }
  function destroy() {
    event.destroy();
    removeClass(wrapper, wrapperClasses);
    if (created) {
      remove(placeholder ? [prev, next] : wrapper);
      prev = next = null;
    } else {
      removeAttribute([prev, next], ALL_ATTRIBUTES);
    }
  }
  function listen() {
    on([EVENT_MOUNTED, EVENT_MOVED, EVENT_REFRESH, EVENT_SCROLLED, EVENT_END_INDEX_CHANGED], update);
    bind(next, 'click', apply(go, '>'));
    bind(prev, 'click', apply(go, '<'));
  }
  function go(control) {
    Controller2.go(control, true);
  }
  function createArrows() {
    wrapper = placeholder || create('div', classes.arrows);
    prev = createArrow(true);
    next = createArrow(false);
    created = true;
    append(wrapper, [prev, next]);
    !placeholder && before(wrapper, track);
  }
  function createArrow(prev2) {
    var arrow = '<button class="' + classes.arrow + ' ' + (prev2 ? classes.prev : classes.next) + '" type="button"><svg xmlns="' + XML_NAME_SPACE + '" viewBox="0 0 ' + SIZE + ' ' + SIZE + '" width="' + SIZE + '" height="' + SIZE + '" focusable="false"><path d="' + (options.arrowPath || PATH) + '" />';
    return parseHtml(arrow);
  }
  function update() {
    if (prev && next) {
      var index = Splide2.index;
      var prevIndex = Controller2.getPrev();
      var nextIndex = Controller2.getNext();
      var prevLabel = prevIndex > -1 && index < prevIndex ? i18n.last : i18n.prev;
      var nextLabel = nextIndex > -1 && index > nextIndex ? i18n.first : i18n.next;
      prev.disabled = prevIndex < 0;
      next.disabled = nextIndex < 0;
      setAttribute(prev, ARIA_LABEL, prevLabel);
      setAttribute(next, ARIA_LABEL, nextLabel);
      emit(EVENT_ARROWS_UPDATED, prev, next, prevIndex, nextIndex);
    }
  }
  return {
    arrows,
    mount,
    destroy,
    update
  };
}
var INTERVAL_DATA_ATTRIBUTE = DATA_ATTRIBUTE + '-interval';
function Autoplay(Splide2, Components2, options) {
  var _EventInterface6 = EventInterface(Splide2), on = _EventInterface6.on, bind = _EventInterface6.bind, emit = _EventInterface6.emit;
  var interval = RequestInterval(options.interval, Splide2.go.bind(Splide2, '>'), onAnimationFrame);
  var isPaused = interval.isPaused;
  var Elements2 = Components2.Elements, _Components2$Elements4 = Components2.Elements, root = _Components2$Elements4.root, toggle = _Components2$Elements4.toggle;
  var autoplay = options.autoplay;
  var hovered;
  var focused;
  var stopped = autoplay === 'pause';
  function mount() {
    if (autoplay) {
      listen();
      toggle && setAttribute(toggle, ARIA_CONTROLS, Elements2.track.id);
      stopped || play();
      update();
    }
  }
  function listen() {
    if (options.pauseOnHover) {
      bind(root, 'mouseenter mouseleave', function(e) {
        hovered = e.type === 'mouseenter';
        autoToggle();
      });
    }
    if (options.pauseOnFocus) {
      bind(root, 'focusin focusout', function(e) {
        focused = e.type === 'focusin';
        autoToggle();
      });
    }
    if (toggle) {
      bind(toggle, 'click', function() {
        stopped ? play() : pause(true);
      });
    }
    on([EVENT_MOVE, EVENT_SCROLL, EVENT_REFRESH], interval.rewind);
    on(EVENT_MOVE, onMove);
  }
  function play() {
    if (isPaused() && Components2.Slides.isEnough()) {
      interval.start(!options.resetProgress);
      focused = hovered = stopped = false;
      update();
      emit(EVENT_AUTOPLAY_PLAY);
    }
  }
  function pause(stop) {
    if (stop === void 0) {
      stop = true;
    }
    stopped = !!stop;
    update();
    if (!isPaused()) {
      interval.pause();
      emit(EVENT_AUTOPLAY_PAUSE);
    }
  }
  function autoToggle() {
    if (!stopped) {
      hovered || focused ? pause(false) : play();
    }
  }
  function update() {
    if (toggle) {
      toggleClass(toggle, CLASS_ACTIVE, !stopped);
      setAttribute(toggle, ARIA_LABEL, options.i18n[stopped ? 'play' : 'pause']);
    }
  }
  function onAnimationFrame(rate) {
    var bar = Elements2.bar;
    bar && style(bar, 'width', rate * 100 + '%');
    emit(EVENT_AUTOPLAY_PLAYING, rate);
  }
  function onMove(index) {
    var Slide2 = Components2.Slides.getAt(index);
    interval.set(Slide2 && +getAttribute(Slide2.slide, INTERVAL_DATA_ATTRIBUTE) || options.interval);
  }
  return {
    mount,
    destroy: interval.cancel,
    play,
    pause,
    isPaused
  };
}
function Cover(Splide2, Components2, options) {
  var _EventInterface7 = EventInterface(Splide2), on = _EventInterface7.on;
  function mount() {
    if (options.cover) {
      on(EVENT_LAZYLOAD_LOADED, apply(toggle, true));
      on([EVENT_MOUNTED, EVENT_UPDATED, EVENT_REFRESH], apply(cover, true));
    }
  }
  function cover(cover2) {
    Components2.Slides.forEach(function(Slide2) {
      var img = child(Slide2.container || Slide2.slide, 'img');
      if (img && img.src) {
        toggle(cover2, img, Slide2);
      }
    });
  }
  function toggle(cover2, img, Slide2) {
    Slide2.style('background', cover2 ? 'center/cover no-repeat url("' + img.src + '")' : '', true);
    display(img, cover2 ? 'none' : '');
  }
  return {
    mount,
    destroy: apply(cover, false)
  };
}
var BOUNCE_DIFF_THRESHOLD = 10;
var BOUNCE_DURATION = 600;
var FRICTION_FACTOR = 0.6;
var BASE_VELOCITY = 1.5;
var MIN_DURATION = 800;
function Scroll(Splide2, Components2, options) {
  var _EventInterface8 = EventInterface(Splide2), on = _EventInterface8.on, emit = _EventInterface8.emit;
  var set = Splide2.state.set;
  var Move2 = Components2.Move;
  var getPosition = Move2.getPosition, getLimit = Move2.getLimit, exceededLimit = Move2.exceededLimit, translate = Move2.translate;
  var isSlide = Splide2.is(SLIDE);
  var interval;
  var callback;
  var friction = 1;
  function mount() {
    on(EVENT_MOVE, clear2);
    on([EVENT_UPDATED, EVENT_REFRESH], cancel);
  }
  function scroll(destination, duration2, snap, onScrolled, noConstrain) {
    var from = getPosition();
    clear2();
    if (snap && (!isSlide || !exceededLimit())) {
      var size = Components2.Layout.sliderSize();
      var offset = sign(destination) * size * floor(abs(destination) / size) || 0;
      destination = Move2.toPosition(Components2.Controller.toDest(destination % size)) + offset;
    }
    var noDistance = approximatelyEqual(from, destination, 1);
    friction = 1;
    duration2 = noDistance ? 0 : duration2 || max(abs(destination - from) / BASE_VELOCITY, MIN_DURATION);
    callback = onScrolled;
    interval = RequestInterval(duration2, onEnd, apply(update, from, destination, noConstrain), 1);
    set(SCROLLING);
    emit(EVENT_SCROLL);
    interval.start();
  }
  function onEnd() {
    set(IDLE);
    callback && callback();
    emit(EVENT_SCROLLED);
  }
  function update(from, to, noConstrain, rate) {
    var position = getPosition();
    var target = from + (to - from) * easing(rate);
    var diff = (target - position) * friction;
    translate(position + diff);
    if (isSlide && !noConstrain && exceededLimit()) {
      friction *= FRICTION_FACTOR;
      if (abs(diff) < BOUNCE_DIFF_THRESHOLD) {
        scroll(getLimit(exceededLimit(true)), BOUNCE_DURATION, false, callback, true);
      }
    }
  }
  function clear2() {
    if (interval) {
      interval.cancel();
    }
  }
  function cancel() {
    if (interval && !interval.isPaused()) {
      clear2();
      onEnd();
    }
  }
  function easing(t) {
    var easingFunc = options.easingFunc;
    return easingFunc ? easingFunc(t) : 1 - Math.pow(1 - t, 4);
  }
  return {
    mount,
    destroy: clear2,
    scroll,
    cancel
  };
}
var SCROLL_LISTENER_OPTIONS = {
  passive: false,
  capture: true
};
function Drag(Splide2, Components2, options) {
  var _EventInterface9 = EventInterface(Splide2), on = _EventInterface9.on, emit = _EventInterface9.emit, bind = _EventInterface9.bind, unbind = _EventInterface9.unbind;
  var state = Splide2.state;
  var Move2 = Components2.Move, Scroll2 = Components2.Scroll, Controller2 = Components2.Controller, track = Components2.Elements.track, reduce = Components2.Media.reduce;
  var _Components2$Directio2 = Components2.Direction, resolve = _Components2$Directio2.resolve, orient = _Components2$Directio2.orient;
  var getPosition = Move2.getPosition, exceededLimit = Move2.exceededLimit;
  var basePosition;
  var baseEvent;
  var prevBaseEvent;
  var isFree;
  var dragging;
  var exceeded = false;
  var clickPrevented;
  var disabled;
  var target;
  function mount() {
    bind(track, POINTER_MOVE_EVENTS, noop, SCROLL_LISTENER_OPTIONS);
    bind(track, POINTER_UP_EVENTS, noop, SCROLL_LISTENER_OPTIONS);
    bind(track, POINTER_DOWN_EVENTS, onPointerDown, SCROLL_LISTENER_OPTIONS);
    bind(track, 'click', onClick, {
      capture: true
    });
    bind(track, 'dragstart', prevent);
    on([EVENT_MOUNTED, EVENT_UPDATED], init);
  }
  function init() {
    var drag = options.drag;
    disable(!drag);
    isFree = drag === 'free';
  }
  function onPointerDown(e) {
    clickPrevented = false;
    if (!disabled) {
      var isTouch = isTouchEvent(e);
      if (isDraggable(e.target) && (isTouch || !e.button)) {
        if (!Controller2.isBusy()) {
          target = isTouch ? track : window;
          dragging = state.is([MOVING, SCROLLING]);
          prevBaseEvent = null;
          bind(target, POINTER_MOVE_EVENTS, onPointerMove, SCROLL_LISTENER_OPTIONS);
          bind(target, POINTER_UP_EVENTS, onPointerUp, SCROLL_LISTENER_OPTIONS);
          Move2.cancel();
          Scroll2.cancel();
          save(e);
        } else {
          prevent(e, true);
        }
      }
    }
  }
  function onPointerMove(e) {
    if (!state.is(DRAGGING)) {
      state.set(DRAGGING);
      emit(EVENT_DRAG);
    }
    if (e.cancelable) {
      if (dragging) {
        Move2.translate(basePosition + constrain(diffCoord(e)));
        var expired = diffTime(e) > LOG_INTERVAL;
        var hasExceeded = exceeded !== (exceeded = exceededLimit());
        if (expired || hasExceeded) {
          save(e);
        }
        clickPrevented = true;
        emit(EVENT_DRAGGING);
        prevent(e);
      } else if (isSliderDirection(e)) {
        dragging = shouldStart(e);
        prevent(e);
      }
    }
  }
  function onPointerUp(e) {
    if (state.is(DRAGGING)) {
      state.set(IDLE);
      emit(EVENT_DRAGGED);
    }
    if (dragging) {
      move(e);
      prevent(e);
    }
    unbind(target, POINTER_MOVE_EVENTS, onPointerMove);
    unbind(target, POINTER_UP_EVENTS, onPointerUp);
    dragging = false;
  }
  function onClick(e) {
    if (!disabled && clickPrevented) {
      prevent(e, true);
    }
  }
  function save(e) {
    prevBaseEvent = baseEvent;
    baseEvent = e;
    basePosition = getPosition();
  }
  function move(e) {
    var velocity = computeVelocity(e);
    var destination = computeDestination(velocity);
    var rewind = options.rewind && options.rewindByDrag;
    reduce(false);
    if (isFree) {
      Controller2.scroll(destination, 0, options.snap);
    } else if (Splide2.is(FADE)) {
      Controller2.go(orient(sign(velocity)) < 0 ? rewind ? '<' : '-' : rewind ? '>' : '+');
    } else if (Splide2.is(SLIDE) && exceeded && rewind) {
      Controller2.go(exceededLimit(true) ? '>' : '<');
    } else {
      Controller2.go(Controller2.toDest(destination), true);
    }
    reduce(true);
  }
  function shouldStart(e) {
    var thresholds = options.dragMinThreshold;
    var isObj = isObject(thresholds);
    var mouse = isObj && thresholds.mouse || 0;
    var touch = (isObj ? thresholds.touch : +thresholds) || 10;
    return abs(diffCoord(e)) > (isTouchEvent(e) ? touch : mouse);
  }
  function isSliderDirection(e) {
    return abs(diffCoord(e)) > abs(diffCoord(e, true));
  }
  function computeVelocity(e) {
    if (Splide2.is(LOOP) || !exceeded) {
      var time = diffTime(e);
      if (time && time < LOG_INTERVAL) {
        return diffCoord(e) / time;
      }
    }
    return 0;
  }
  function computeDestination(velocity) {
    return getPosition() + sign(velocity) * min(abs(velocity) * (options.flickPower || 600), isFree ? Infinity : Components2.Layout.listSize() * (options.flickMaxPages || 1));
  }
  function diffCoord(e, orthogonal) {
    return coordOf(e, orthogonal) - coordOf(getBaseEvent(e), orthogonal);
  }
  function diffTime(e) {
    return timeOf(e) - timeOf(getBaseEvent(e));
  }
  function getBaseEvent(e) {
    return baseEvent === e && prevBaseEvent || baseEvent;
  }
  function coordOf(e, orthogonal) {
    return (isTouchEvent(e) ? e.changedTouches[0] : e)['page' + resolve(orthogonal ? 'Y' : 'X')];
  }
  function constrain(diff) {
    return diff / (exceeded && Splide2.is(SLIDE) ? FRICTION : 1);
  }
  function isDraggable(target2) {
    var noDrag = options.noDrag;
    return !matches(target2, '.' + CLASS_PAGINATION_PAGE + ', .' + CLASS_ARROW) && (!noDrag || !matches(target2, noDrag));
  }
  function isTouchEvent(e) {
    return typeof TouchEvent !== 'undefined' && e instanceof TouchEvent;
  }
  function isDragging() {
    return dragging;
  }
  function disable(value) {
    disabled = value;
  }
  return {
    mount,
    disable,
    isDragging
  };
}
var NORMALIZATION_MAP = {
  Spacebar: ' ',
  Right: ARROW_RIGHT,
  Left: ARROW_LEFT,
  Up: ARROW_UP,
  Down: ARROW_DOWN
};
function normalizeKey(key) {
  key = isString(key) ? key : key.key;
  return NORMALIZATION_MAP[key] || key;
}
var KEYBOARD_EVENT = 'keydown';
function Keyboard(Splide2, Components2, options) {
  var _EventInterface10 = EventInterface(Splide2), on = _EventInterface10.on, bind = _EventInterface10.bind, unbind = _EventInterface10.unbind;
  var root = Splide2.root;
  var resolve = Components2.Direction.resolve;
  var target;
  var disabled;
  function mount() {
    init();
    on(EVENT_UPDATED, destroy);
    on(EVENT_UPDATED, init);
    on(EVENT_MOVE, onMove);
  }
  function init() {
    var keyboard = options.keyboard;
    if (keyboard) {
      target = keyboard === 'global' ? window : root;
      bind(target, KEYBOARD_EVENT, onKeydown);
    }
  }
  function destroy() {
    unbind(target, KEYBOARD_EVENT);
  }
  function disable(value) {
    disabled = value;
  }
  function onMove() {
    var _disabled = disabled;
    disabled = true;
    nextTick(function() {
      disabled = _disabled;
    });
  }
  function onKeydown(e) {
    if (!disabled) {
      var key = normalizeKey(e);
      if (key === resolve(ARROW_LEFT)) {
        Splide2.go('<');
      } else if (key === resolve(ARROW_RIGHT)) {
        Splide2.go('>');
      }
    }
  }
  return {
    mount,
    destroy,
    disable
  };
}
var SRC_DATA_ATTRIBUTE = DATA_ATTRIBUTE + '-lazy';
var SRCSET_DATA_ATTRIBUTE = SRC_DATA_ATTRIBUTE + '-srcset';
var IMAGE_SELECTOR = '[' + SRC_DATA_ATTRIBUTE + '], [' + SRCSET_DATA_ATTRIBUTE + ']';
function LazyLoad(Splide2, Components2, options) {
  var _EventInterface11 = EventInterface(Splide2), on = _EventInterface11.on, off = _EventInterface11.off, bind = _EventInterface11.bind, emit = _EventInterface11.emit;
  var isSequential = options.lazyLoad === 'sequential';
  var events = [EVENT_MOVED, EVENT_SCROLLED];
  var entries = [];
  function mount() {
    if (options.lazyLoad) {
      init();
      on(EVENT_REFRESH, init);
    }
  }
  function init() {
    empty(entries);
    register();
    if (isSequential) {
      loadNext();
    } else {
      off(events);
      on(events, check);
      check();
    }
  }
  function register() {
    Components2.Slides.forEach(function(Slide2) {
      queryAll(Slide2.slide, IMAGE_SELECTOR).forEach(function(img) {
        var src = getAttribute(img, SRC_DATA_ATTRIBUTE);
        var srcset = getAttribute(img, SRCSET_DATA_ATTRIBUTE);
        if (src !== img.src || srcset !== img.srcset) {
          var className = options.classes.spinner;
          var parent = img.parentElement;
          var spinner = child(parent, '.' + className) || create('span', className, parent);
          entries.push([img, Slide2, spinner]);
          img.src || display(img, 'none');
        }
      });
    });
  }
  function check() {
    entries = entries.filter(function(data) {
      var distance = options.perPage * ((options.preloadPages || 1) + 1) - 1;
      return data[1].isWithin(Splide2.index, distance) ? load(data) : true;
    });
    entries.length || off(events);
  }
  function load(data) {
    var img = data[0];
    addClass(data[1].slide, CLASS_LOADING);
    bind(img, 'load error', apply(onLoad, data));
    setAttribute(img, 'src', getAttribute(img, SRC_DATA_ATTRIBUTE));
    setAttribute(img, 'srcset', getAttribute(img, SRCSET_DATA_ATTRIBUTE));
    removeAttribute(img, SRC_DATA_ATTRIBUTE);
    removeAttribute(img, SRCSET_DATA_ATTRIBUTE);
  }
  function onLoad(data, e) {
    var img = data[0], Slide2 = data[1];
    removeClass(Slide2.slide, CLASS_LOADING);
    if (e.type !== 'error') {
      remove(data[2]);
      display(img, '');
      emit(EVENT_LAZYLOAD_LOADED, img, Slide2);
      emit(EVENT_RESIZE);
    }
    isSequential && loadNext();
  }
  function loadNext() {
    entries.length && load(entries.shift());
  }
  return {
    mount,
    destroy: apply(empty, entries),
    check
  };
}
function Pagination(Splide2, Components2, options) {
  var event = EventInterface(Splide2);
  var on = event.on, emit = event.emit, bind = event.bind;
  var Slides2 = Components2.Slides, Elements2 = Components2.Elements, Controller2 = Components2.Controller;
  var hasFocus = Controller2.hasFocus, getIndex = Controller2.getIndex, go = Controller2.go;
  var resolve = Components2.Direction.resolve;
  var placeholder = Elements2.pagination;
  var items = [];
  var list;
  var paginationClasses;
  function mount() {
    destroy();
    on([EVENT_UPDATED, EVENT_REFRESH, EVENT_END_INDEX_CHANGED], mount);
    var enabled = options.pagination;
    placeholder && display(placeholder, enabled ? '' : 'none');
    if (enabled) {
      on([EVENT_MOVE, EVENT_SCROLL, EVENT_SCROLLED], update);
      createPagination();
      update();
      emit(EVENT_PAGINATION_MOUNTED, {
        list,
        items
      }, getAt(Splide2.index));
    }
  }
  function destroy() {
    if (list) {
      remove(placeholder ? slice(list.children) : list);
      removeClass(list, paginationClasses);
      empty(items);
      list = null;
    }
    event.destroy();
  }
  function createPagination() {
    var length = Splide2.length;
    var classes = options.classes, i18n = options.i18n, perPage = options.perPage;
    var max2 = hasFocus() ? Controller2.getEnd() + 1 : ceil(length / perPage);
    list = placeholder || create('ul', classes.pagination, Elements2.track.parentElement);
    addClass(list, paginationClasses = CLASS_PAGINATION + '--' + getDirection());
    setAttribute(list, ROLE, 'tablist');
    setAttribute(list, ARIA_LABEL, i18n.select);
    setAttribute(list, ARIA_ORIENTATION, getDirection() === TTB ? 'vertical' : '');
    for (var i = 0; i < max2; i++) {
      var li = create('li', null, list);
      var button = create('button', {
        class: classes.page,
        type: 'button'
      }, li);
      var controls = Slides2.getIn(i).map(function(Slide2) {
        return Slide2.slide.id;
      });
      var text = !hasFocus() && perPage > 1 ? i18n.pageX : i18n.slideX;
      bind(button, 'click', apply(onClick, i));
      if (options.paginationKeyboard) {
        bind(button, 'keydown', apply(onKeydown, i));
      }
      setAttribute(li, ROLE, 'presentation');
      setAttribute(button, ROLE, 'tab');
      setAttribute(button, ARIA_CONTROLS, controls.join(' '));
      setAttribute(button, ARIA_LABEL, format(text, i + 1));
      setAttribute(button, TAB_INDEX, -1);
      items.push({
        li,
        button,
        page: i
      });
    }
  }
  function onClick(page) {
    go('>' + page, true);
  }
  function onKeydown(page, e) {
    var length = items.length;
    var key = normalizeKey(e);
    var dir = getDirection();
    var nextPage = -1;
    if (key === resolve(ARROW_RIGHT, false, dir)) {
      nextPage = ++page % length;
    } else if (key === resolve(ARROW_LEFT, false, dir)) {
      nextPage = (--page + length) % length;
    } else if (key === 'Home') {
      nextPage = 0;
    } else if (key === 'End') {
      nextPage = length - 1;
    }
    var item = items[nextPage];
    if (item) {
      focus(item.button);
      go('>' + nextPage);
      prevent(e, true);
    }
  }
  function getDirection() {
    return options.paginationDirection || options.direction;
  }
  function getAt(index) {
    return items[Controller2.toPage(index)];
  }
  function update() {
    var prev = getAt(getIndex(true));
    var curr = getAt(getIndex());
    if (prev) {
      var button = prev.button;
      removeClass(button, CLASS_ACTIVE);
      removeAttribute(button, ARIA_SELECTED);
      setAttribute(button, TAB_INDEX, -1);
    }
    if (curr) {
      var _button = curr.button;
      addClass(_button, CLASS_ACTIVE);
      setAttribute(_button, ARIA_SELECTED, true);
      setAttribute(_button, TAB_INDEX, '');
    }
    emit(EVENT_PAGINATION_UPDATED, {
      list,
      items
    }, prev, curr);
  }
  return {
    items,
    mount,
    destroy,
    getAt,
    update
  };
}
var TRIGGER_KEYS = [' ', 'Enter'];
function Sync(Splide2, Components2, options) {
  var isNavigation = options.isNavigation, slideFocus = options.slideFocus;
  var events = [];
  function mount() {
    Splide2.splides.forEach(function(target) {
      if (!target.isParent) {
        sync(Splide2, target.splide);
        sync(target.splide, Splide2);
      }
    });
    if (isNavigation) {
      navigate();
    }
  }
  function destroy() {
    events.forEach(function(event) {
      event.destroy();
    });
    empty(events);
  }
  function remount() {
    destroy();
    mount();
  }
  function sync(splide, target) {
    var event = EventInterface(splide);
    event.on(EVENT_MOVE, function(index, prev, dest) {
      target.go(target.is(LOOP) ? dest : index);
    });
    events.push(event);
  }
  function navigate() {
    var event = EventInterface(Splide2);
    var on = event.on;
    on(EVENT_CLICK, onClick);
    on(EVENT_SLIDE_KEYDOWN, onKeydown);
    on([EVENT_MOUNTED, EVENT_UPDATED], update);
    events.push(event);
    event.emit(EVENT_NAVIGATION_MOUNTED, Splide2.splides);
  }
  function update() {
    setAttribute(Components2.Elements.list, ARIA_ORIENTATION, options.direction === TTB ? 'vertical' : '');
  }
  function onClick(Slide2) {
    Splide2.go(Slide2.index);
  }
  function onKeydown(Slide2, e) {
    if (includes(TRIGGER_KEYS, normalizeKey(e))) {
      onClick(Slide2);
      prevent(e);
    }
  }
  return {
    setup: apply(Components2.Media.set, {
      slideFocus: isUndefined(slideFocus) ? isNavigation : slideFocus
    }, true),
    mount,
    destroy,
    remount
  };
}
function Wheel(Splide2, Components2, options) {
  var _EventInterface12 = EventInterface(Splide2), bind = _EventInterface12.bind;
  var lastTime = 0;
  function mount() {
    if (options.wheel) {
      bind(Components2.Elements.track, 'wheel', onWheel, SCROLL_LISTENER_OPTIONS);
    }
  }
  function onWheel(e) {
    if (e.cancelable) {
      var deltaY = e.deltaY;
      var backwards = deltaY < 0;
      var timeStamp = timeOf(e);
      var _min = options.wheelMinThreshold || 0;
      var sleep = options.wheelSleep || 0;
      if (abs(deltaY) > _min && timeStamp - lastTime > sleep) {
        Splide2.go(backwards ? '<' : '>');
        lastTime = timeStamp;
      }
      shouldPrevent(backwards) && prevent(e);
    }
  }
  function shouldPrevent(backwards) {
    return !options.releaseWheel || Splide2.state.is(MOVING) || Components2.Controller.getAdjacent(backwards) !== -1;
  }
  return {
    mount
  };
}
var SR_REMOVAL_DELAY = 90;
function Live(Splide2, Components2, options) {
  var _EventInterface13 = EventInterface(Splide2), on = _EventInterface13.on;
  var track = Components2.Elements.track;
  var enabled = options.live && !options.isNavigation;
  var sr = create('span', CLASS_SR);
  var interval = RequestInterval(SR_REMOVAL_DELAY, apply(toggle, false));
  function mount() {
    if (enabled) {
      disable(!Components2.Autoplay.isPaused());
      setAttribute(track, ARIA_ATOMIC, true);
      sr.textContent = '\u2026';
      on(EVENT_AUTOPLAY_PLAY, apply(disable, true));
      on(EVENT_AUTOPLAY_PAUSE, apply(disable, false));
      on([EVENT_MOVED, EVENT_SCROLLED], apply(toggle, true));
    }
  }
  function toggle(active) {
    setAttribute(track, ARIA_BUSY, active);
    if (active) {
      append(track, sr);
      interval.start();
    } else {
      remove(sr);
      interval.cancel();
    }
  }
  function destroy() {
    removeAttribute(track, [ARIA_LIVE, ARIA_ATOMIC, ARIA_BUSY]);
    remove(sr);
  }
  function disable(disabled) {
    if (enabled) {
      setAttribute(track, ARIA_LIVE, disabled ? 'off' : 'polite');
    }
  }
  return {
    mount,
    disable,
    destroy
  };
}
var ComponentConstructors = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  Media,
  Direction,
  Elements,
  Slides,
  Layout,
  Clones,
  Move,
  Controller,
  Arrows,
  Autoplay,
  Cover,
  Scroll,
  Drag,
  Keyboard,
  LazyLoad,
  Pagination,
  Sync,
  Wheel,
  Live
});
var I18N = {
  prev: 'Previous slide',
  next: 'Next slide',
  first: 'Go to first slide',
  last: 'Go to last slide',
  slideX: 'Go to slide %s',
  pageX: 'Go to page %s',
  play: 'Start autoplay',
  pause: 'Pause autoplay',
  carousel: 'carousel',
  slide: 'slide',
  select: 'Select a slide to show',
  slideLabel: '%s of %s'
};
var DEFAULTS = {
  type: 'slide',
  role: 'region',
  speed: 400,
  perPage: 1,
  cloneStatus: true,
  arrows: true,
  pagination: true,
  paginationKeyboard: true,
  interval: 5e3,
  pauseOnHover: true,
  pauseOnFocus: true,
  resetProgress: true,
  easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
  drag: true,
  direction: 'ltr',
  trimSpace: true,
  focusableNodes: 'a, button, textarea, input, select, iframe',
  live: true,
  classes: CLASSES,
  i18n: I18N,
  reducedMotion: {
    speed: 0,
    rewindSpeed: 0,
    autoplay: 'pause'
  }
};
function Fade(Splide2, Components2, options) {
  var Slides2 = Components2.Slides;
  function mount() {
    EventInterface(Splide2).on([EVENT_MOUNTED, EVENT_REFRESH], init);
  }
  function init() {
    Slides2.forEach(function(Slide2) {
      Slide2.style('transform', 'translateX(-' + 100 * Slide2.index + '%)');
    });
  }
  function start(index, done) {
    Slides2.style('transition', 'opacity ' + options.speed + 'ms ' + options.easing);
    nextTick(done);
  }
  return {
    mount,
    start,
    cancel: noop
  };
}
function Slide(Splide2, Components2, options) {
  var Move2 = Components2.Move, Controller2 = Components2.Controller, Scroll2 = Components2.Scroll;
  var list = Components2.Elements.list;
  var transition = apply(style, list, 'transition');
  var endCallback;
  function mount() {
    EventInterface(Splide2).bind(list, 'transitionend', function(e) {
      if (e.target === list && endCallback) {
        cancel();
        endCallback();
      }
    });
  }
  function start(index, done) {
    var destination = Move2.toPosition(index, true);
    var position = Move2.getPosition();
    var speed = getSpeed(index);
    if (abs(destination - position) >= 1 && speed >= 1) {
      if (options.useScroll) {
        Scroll2.scroll(destination, speed, false, done);
      } else {
        transition('transform ' + speed + 'ms ' + options.easing);
        Move2.translate(destination, true);
        endCallback = done;
      }
    } else {
      Move2.jump(index);
      done();
    }
  }
  function cancel() {
    transition('');
    Scroll2.cancel();
  }
  function getSpeed(index) {
    var rewindSpeed = options.rewindSpeed;
    if (Splide2.is(SLIDE) && rewindSpeed) {
      var prev = Controller2.getIndex(true);
      var end = Controller2.getEnd();
      if (prev === 0 && index >= end || prev >= end && index === 0) {
        return rewindSpeed;
      }
    }
    return options.speed;
  }
  return {
    mount,
    start,
    cancel
  };
}
var _Splide = /* @__PURE__ */ function() {
  function _Splide2(target, options) {
    this.event = EventInterface();
    this.Components = {};
    this.state = State(CREATED);
    this.splides = [];
    this._o = {};
    this._E = {};
    var root = isString(target) ? query(document, target) : target;
    assert(root, root + ' is invalid.');
    this.root = root;
    options = merge({
      label: getAttribute(root, ARIA_LABEL) || '',
      labelledby: getAttribute(root, ARIA_LABELLEDBY) || ''
    }, DEFAULTS, _Splide2.defaults, options || {});
    try {
      merge(options, JSON.parse(getAttribute(root, DATA_ATTRIBUTE)));
    } catch (e) {
      assert(false, 'Invalid JSON');
    }
    this._o = Object.create(merge({}, options));
  }
  var _proto = _Splide2.prototype;
  _proto.mount = function mount(Extensions, Transition) {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    var _this = this;
    var state = this.state, Components2 = this.Components;
    assert(state.is([CREATED, DESTROYED]), 'Already mounted!');
    state.set(CREATED);
    this._C = Components2;
    this._T = Transition || this._T || (this.is(FADE) ? Fade : Slide);
    this._E = Extensions || this._E;
    var Constructors = assign({}, ComponentConstructors, this._E, {
      Transition: this._T
    });
    forOwn(Constructors, function(Component, key) {
      var component = Component(_this, Components2, _this._o);
      Components2[key] = component;
      component.setup && component.setup();
    });
    forOwn(Components2, function(component) {
      component.mount && component.mount();
    });
    this.emit(EVENT_MOUNTED);
    addClass(this.root, CLASS_INITIALIZED);
    state.set(IDLE);
    this.emit(EVENT_READY);
    return this;
  };
  _proto.sync = function sync(splide) {
    this.splides.push({
      splide
    });
    splide.splides.push({
      splide: this,
      isParent: true
    });
    if (this.state.is(IDLE)) {
      this._C.Sync.remount();
      splide.Components.Sync.remount();
    }
    return this;
  };
  _proto.go = function go(control) {
    this._C.Controller.go(control);
    return this;
  };
  _proto.on = function on(events, callback) {
    this.event.on(events, callback);
    return this;
  };
  _proto.off = function off(events) {
    this.event.off(events);
    return this;
  };
  _proto.emit = function emit(event) {
    var _this$event;
    (_this$event = this.event).emit.apply(_this$event, [event].concat(slice(arguments, 1)));
    return this;
  };
  _proto.add = function add(slides, index) {
    this._C.Slides.add(slides, index);
    return this;
  };
  _proto.remove = function remove2(matcher) {
    this._C.Slides.remove(matcher);
    return this;
  };
  _proto.is = function is(type) {
    return this._o.type === type;
  };
  _proto.refresh = function refresh() {
    this.emit(EVENT_REFRESH);
    return this;
  };
  _proto.destroy = function destroy(completely) {
    if (completely === void 0) {
      completely = true;
    }
    var event = this.event, state = this.state;
    if (state.is(CREATED)) {
      EventInterface(this).on(EVENT_READY, this.destroy.bind(this, completely));
    } else {
      forOwn(this._C, function(component) {
        component.destroy && component.destroy(completely);
      }, true);
      event.emit(EVENT_DESTROY);
      event.destroy();
      completely && empty(this.splides);
      state.set(DESTROYED);
    }
    return this;
  };
  _createClass(_Splide2, [{
    key: 'options',
    get: function get() {
      return this._o;
    },
    set: function set(options) {
      this._C.Media.set(options, true, true);
    }
  }, {
    key: 'length',
    get: function get() {
      return this._C.Slides.getLength(true);
    }
  }, {
    key: 'index',
    get: function get() {
      return this._C.Controller.getIndex();
    }
  }]);
  return _Splide2;
}();
var Splide = _Splide;
Splide.defaults = {};
Splide.STATES = STATES;

// src/js/_module/_splideSlider.ts
function splideSlider() {
  const slide = document.querySelectorAll('.splide');
  if (!slide.length) return;
  for (const element of Array.from(slide)) {
    new Splide(element, {
      perMove: 1,
      flickPower: 400,
      flickMaxPages: 1,
      autoWidth: true
    }).mount();
  }
}

// src/js/_module/_gMenu.ts
function gMenu() {
  const gMenu2 = document.querySelectorAll(
    '.js-gMenu'
  );
  if (!gMenu2?.length) return;
  const currentUrl = window.location.pathname;
  const pathArray = currentUrl.split('/');
  let menuCurrent = '';
  const currentList = [
    {
      path: ['news'],
      class: '-home'
    },
    {
      path: ['apply'],
      class: '-id'
    },
    {
      path: ['jobsearch', 'refusal', 'refusallist'],
      class: '-search'
    },
    {
      path: ['pending'],
      class: '-fav'
    },
    {
      path: [
        'profile',
        'recommend',
        'resume',
        'sendsetting',
        'pwupdate',
        'video'
      ],
      class: '-menu'
    }
  ];
  const matched = currentList.find((item) => item.path.includes(pathArray[1]));
  if (matched) {
    menuCurrent = matched.class;
  }
  if (!pathArray[1]) menuCurrent = '-home';
  if (pathArray[1] === 'apply' && (pathArray[2] === 'form' || pathArray[2] === 'multiple')) {
    menuCurrent = '-search';
  }
  const modalFunc = (button, content, bodyFix) => {
    const is_expanded = button.getAttribute('aria-expanded') === 'true';
    button.setAttribute('aria-expanded', String(!is_expanded));
    content.setAttribute('aria-hidden', String(is_expanded));
    if (!is_expanded) {
      if (bodyFix) document.body.style.overflow = 'hidden';
      if (button.textContent?.trim() === '\u30E1\u30CB\u30E5\u30FC') {
        button.textContent = '\u3068\u3058\u308B';
      }
    } else {
      if (bodyFix) document.body.style.overflow = '';
      if (button.textContent?.trim() === '\u3068\u3058\u308B') {
        button.textContent = '\u30E1\u30CB\u30E5\u30FC';
      }
      button.focus();
    }
  };
  const modalInit = (button, content, bodyFix) => {
    button.addEventListener('click', () => {
      modalFunc(button, content, bodyFix);
    });
    content.addEventListener('click', () => {
      modalFunc(button, content, bodyFix);
    });
    const contentBody = content.querySelector(':scope > *');
    contentBody?.addEventListener('click', (event) => {
      event.stopPropagation();
    });
    const closeButtons = content.querySelectorAll(
      '.js-gMenu-close'
    );
    if (!closeButtons?.length) return;
    for (const element of Array.from(closeButtons)) {
      element.addEventListener('click', () => {
        modalFunc(button, content, bodyFix);
      });
    }
  };
  for (const element of Array.from(gMenu2)) {
    const gMenuContent = element.querySelector(
      '.js-gMenu-content'
    );
    if (!gMenuContent) return;
    const gMenuButton = element.querySelector(
      '.js-gMenu-button'
    );
    if (!gMenuButton) return;
    modalInit(gMenuButton, gMenuContent, true);
    const logoutContent = element.querySelector(
      '.js-gMenu-logout-content'
    );
    if (!logoutContent) return;
    const logoutButton = element.querySelector(
      '.js-gMenu-logout-button'
    );
    if (!logoutButton) return;
    modalInit(logoutButton, logoutContent);
    const gMenuItems = element.querySelectorAll(
      '.g-menu_button'
    );
    if (gMenuItems) {
      for (const item of Array.from(gMenuItems)) {
        const classList = Array.from(item.classList).filter(
          (className) => className !== 'g-menu_button'
        );
        if (classList.includes(menuCurrent)) {
          item.classList.add('is-active');
        }
      }
    }
  }
}

// src/js/_module/_p-apply.ts
function pApply() {
  const radioEl = document.querySelectorAll('.p-apply_label-radio');
  const update = (index, radios) => {
    radios.forEach((el, i) => {
      if (i <= index) {
        el.classList.add('-active');
      } else {
        el.classList.remove('-active');
      }
    });
  };
  radioEl?.forEach((el, i) => {
    const labels = el.querySelectorAll('label');
    if (labels.length === 0) return;
    labels.forEach((label, index) => {
      const input = label.querySelector('input[type="radio"]');
      if (!input) return;
      if (input.checked) {
        update(
          index,
          Array.from(labels).map(
            (l) => l.querySelector('input[type="radio"]')
          ).filter((input2) => input2 !== null)
        );
      }
      input.addEventListener('change', () => {
        if (input.checked) {
          update(
            index,
            Array.from(labels).map(
              (l) => l.querySelector('input[type="radio"]')
            ).filter((input2) => input2 !== null)
          );
        }
      });
    });
  });
  const modalEl = document.querySelectorAll('.js-modal-container');
  modalEl?.forEach((el, i) => {
    const elmTab = el.querySelectorAll('.js-apply-tab');
    if (elmTab.length === 0) return;
    const btnApply = el.querySelector(
      '.p-apply-modal_button.-apply'
    );
    btnApply?.addEventListener('click', () => {
      elmTab.forEach((tab, idx) => {
        if (idx === 1) {
          tab.removeAttribute('hidden');
        } else {
          tab.setAttribute('hidden', 'true');
        }
      });
    });
  });
}

// node_modules/flatpickr/dist/esm/types/options.js
var HOOKS = [
  'onChange',
  'onClose',
  'onDayCreate',
  'onDestroy',
  'onKeyDown',
  'onMonthChange',
  'onOpen',
  'onParseConfig',
  'onReady',
  'onValueUpdate',
  'onYearChange',
  'onPreCalendarPosition'
];
var defaults = {
  _disable: [],
  allowInput: false,
  allowInvalidPreload: false,
  altFormat: 'F j, Y',
  altInput: false,
  altInputClass: 'form-control input',
  animate: typeof window === 'object' && window.navigator.userAgent.indexOf('MSIE') === -1,
  ariaDateFormat: 'F j, Y',
  autoFillDefaultTime: true,
  clickOpens: true,
  closeOnSelect: true,
  conjunction: ', ',
  dateFormat: 'Y-m-d',
  defaultHour: 12,
  defaultMinute: 0,
  defaultSeconds: 0,
  disable: [],
  disableMobile: false,
  enableSeconds: false,
  enableTime: false,
  errorHandler: function(err) {
    return typeof console !== 'undefined' && console.warn(err);
  },
  getWeek: function(givenDate) {
    var date = new Date(givenDate.getTime());
    date.setHours(0, 0, 0, 0);
    date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
    var week1 = new Date(date.getFullYear(), 0, 4);
    return 1 + Math.round(((date.getTime() - week1.getTime()) / 864e5 - 3 + (week1.getDay() + 6) % 7) / 7);
  },
  hourIncrement: 1,
  ignoredFocusElements: [],
  inline: false,
  locale: 'default',
  minuteIncrement: 5,
  mode: 'single',
  monthSelectorType: 'dropdown',
  nextArrow: '<svg version=\'1.1\' xmlns=\'http://www.w3.org/2000/svg\' xmlns:xlink=\'http://www.w3.org/1999/xlink\' viewBox=\'0 0 17 17\'><g></g><path d=\'M13.207 8.472l-7.854 7.854-0.707-0.707 7.146-7.146-7.146-7.148 0.707-0.707 7.854 7.854z\' /></svg>',
  noCalendar: false,
  now: /* @__PURE__ */ new Date(),
  onChange: [],
  onClose: [],
  onDayCreate: [],
  onDestroy: [],
  onKeyDown: [],
  onMonthChange: [],
  onOpen: [],
  onParseConfig: [],
  onReady: [],
  onValueUpdate: [],
  onYearChange: [],
  onPreCalendarPosition: [],
  plugins: [],
  position: 'auto',
  positionElement: void 0,
  prevArrow: '<svg version=\'1.1\' xmlns=\'http://www.w3.org/2000/svg\' xmlns:xlink=\'http://www.w3.org/1999/xlink\' viewBox=\'0 0 17 17\'><g></g><path d=\'M5.207 8.471l7.146 7.147-0.707 0.707-7.853-7.854 7.854-7.853 0.707 0.707-7.147 7.146z\' /></svg>',
  shorthandCurrentMonth: false,
  showMonths: 1,
  static: false,
  time_24hr: false,
  weekNumbers: false,
  wrap: false
};

// node_modules/flatpickr/dist/esm/l10n/default.js
var english = {
  weekdays: {
    shorthand: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    longhand: [
      'Sunday',
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday'
    ]
  },
  months: {
    shorthand: [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec'
    ],
    longhand: [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December'
    ]
  },
  daysInMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
  firstDayOfWeek: 0,
  ordinal: function(nth) {
    var s = nth % 100;
    if (s > 3 && s < 21)
      return 'th';
    switch (s % 10) {
      case 1:
        return 'st';
      case 2:
        return 'nd';
      case 3:
        return 'rd';
      default:
        return 'th';
    }
  },
  rangeSeparator: ' to ',
  weekAbbreviation: 'Wk',
  scrollTitle: 'Scroll to increment',
  toggleTitle: 'Click to toggle',
  amPM: ['AM', 'PM'],
  yearAriaLabel: 'Year',
  monthAriaLabel: 'Month',
  hourAriaLabel: 'Hour',
  minuteAriaLabel: 'Minute',
  time_24hr: false
};
var default_default = english;

// node_modules/flatpickr/dist/esm/utils/index.js
var pad2 = function(number, length) {
  if (length === void 0) {
    length = 2;
  }
  return ('000' + number).slice(length * -1);
};
var int = function(bool) {
  return bool === true ? 1 : 0;
};
function debounce(fn, wait) {
  var t;
  return function() {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    var _this = this;
    var args = arguments;
    clearTimeout(t);
    t = setTimeout(function() {
      return fn.apply(_this, args);
    }, wait);
  };
}
var arrayify = function(obj) {
  return obj instanceof Array ? obj : [obj];
};

// node_modules/flatpickr/dist/esm/utils/dom.js
function toggleClass2(elem, className, bool) {
  if (bool === true)
    return elem.classList.add(className);
  elem.classList.remove(className);
}
function createElement(tag, className, content) {
  var e = window.document.createElement(tag);
  className = className || '';
  content = content || '';
  e.className = className;
  if (content !== void 0)
    e.textContent = content;
  return e;
}
function clearNode(node) {
  while (node.firstChild)
    node.removeChild(node.firstChild);
}
function findParent(node, condition) {
  if (condition(node))
    return node;
  else if (node.parentNode)
    return findParent(node.parentNode, condition);
  return void 0;
}
function createNumberInput(inputClassName, opts) {
  var wrapper = createElement('div', 'numInputWrapper'), numInput = createElement('input', 'numInput ' + inputClassName), arrowUp = createElement('span', 'arrowUp'), arrowDown = createElement('span', 'arrowDown');
  if (navigator.userAgent.indexOf('MSIE 9.0') === -1) {
    numInput.type = 'number';
  } else {
    numInput.type = 'text';
    numInput.pattern = '\\d*';
  }
  if (opts !== void 0)
    for (var key in opts)
      numInput.setAttribute(key, opts[key]);
  wrapper.appendChild(numInput);
  wrapper.appendChild(arrowUp);
  wrapper.appendChild(arrowDown);
  return wrapper;
}
function getEventTarget(event) {
  try {
    if (typeof event.composedPath === 'function') {
      var path = event.composedPath();
      return path[0];
    }
    return event.target;
  } catch (error) {
    return event.target;
  }
}

// node_modules/flatpickr/dist/esm/utils/formatting.js
var doNothing = function() {
  return void 0;
};
var monthToStr = function(monthNumber, shorthand, locale) {
  return locale.months[shorthand ? 'shorthand' : 'longhand'][monthNumber];
};
var revFormat = {
  D: doNothing,
  F: function(dateObj, monthName, locale) {
    dateObj.setMonth(locale.months.longhand.indexOf(monthName));
  },
  G: function(dateObj, hour) {
    dateObj.setHours((dateObj.getHours() >= 12 ? 12 : 0) + parseFloat(hour));
  },
  H: function(dateObj, hour) {
    dateObj.setHours(parseFloat(hour));
  },
  J: function(dateObj, day) {
    dateObj.setDate(parseFloat(day));
  },
  K: function(dateObj, amPM, locale) {
    dateObj.setHours(dateObj.getHours() % 12 + 12 * int(new RegExp(locale.amPM[1], 'i').test(amPM)));
  },
  M: function(dateObj, shortMonth, locale) {
    dateObj.setMonth(locale.months.shorthand.indexOf(shortMonth));
  },
  S: function(dateObj, seconds) {
    dateObj.setSeconds(parseFloat(seconds));
  },
  U: function(_, unixSeconds) {
    return new Date(parseFloat(unixSeconds) * 1e3);
  },
  W: function(dateObj, weekNum, locale) {
    var weekNumber = parseInt(weekNum);
    var date = new Date(dateObj.getFullYear(), 0, 2 + (weekNumber - 1) * 7, 0, 0, 0, 0);
    date.setDate(date.getDate() - date.getDay() + locale.firstDayOfWeek);
    return date;
  },
  Y: function(dateObj, year) {
    dateObj.setFullYear(parseFloat(year));
  },
  Z: function(_, ISODate) {
    return new Date(ISODate);
  },
  d: function(dateObj, day) {
    dateObj.setDate(parseFloat(day));
  },
  h: function(dateObj, hour) {
    dateObj.setHours((dateObj.getHours() >= 12 ? 12 : 0) + parseFloat(hour));
  },
  i: function(dateObj, minutes) {
    dateObj.setMinutes(parseFloat(minutes));
  },
  j: function(dateObj, day) {
    dateObj.setDate(parseFloat(day));
  },
  l: doNothing,
  m: function(dateObj, month) {
    dateObj.setMonth(parseFloat(month) - 1);
  },
  n: function(dateObj, month) {
    dateObj.setMonth(parseFloat(month) - 1);
  },
  s: function(dateObj, seconds) {
    dateObj.setSeconds(parseFloat(seconds));
  },
  u: function(_, unixMillSeconds) {
    return new Date(parseFloat(unixMillSeconds));
  },
  w: doNothing,
  y: function(dateObj, year) {
    dateObj.setFullYear(2e3 + parseFloat(year));
  }
};
var tokenRegex = {
  D: '',
  F: '',
  G: '(\\d\\d|\\d)',
  H: '(\\d\\d|\\d)',
  J: '(\\d\\d|\\d)\\w+',
  K: '',
  M: '',
  S: '(\\d\\d|\\d)',
  U: '(.+)',
  W: '(\\d\\d|\\d)',
  Y: '(\\d{4})',
  Z: '(.+)',
  d: '(\\d\\d|\\d)',
  h: '(\\d\\d|\\d)',
  i: '(\\d\\d|\\d)',
  j: '(\\d\\d|\\d)',
  l: '',
  m: '(\\d\\d|\\d)',
  n: '(\\d\\d|\\d)',
  s: '(\\d\\d|\\d)',
  u: '(.+)',
  w: '(\\d\\d|\\d)',
  y: '(\\d{2})'
};
var formats = {
  Z: function(date) {
    return date.toISOString();
  },
  D: function(date, locale, options) {
    return locale.weekdays.shorthand[formats.w(date, locale, options)];
  },
  F: function(date, locale, options) {
    return monthToStr(formats.n(date, locale, options) - 1, false, locale);
  },
  G: function(date, locale, options) {
    return pad2(formats.h(date, locale, options));
  },
  H: function(date) {
    return pad2(date.getHours());
  },
  J: function(date, locale) {
    return locale.ordinal !== void 0 ? date.getDate() + locale.ordinal(date.getDate()) : date.getDate();
  },
  K: function(date, locale) {
    return locale.amPM[int(date.getHours() > 11)];
  },
  M: function(date, locale) {
    return monthToStr(date.getMonth(), true, locale);
  },
  S: function(date) {
    return pad2(date.getSeconds());
  },
  U: function(date) {
    return date.getTime() / 1e3;
  },
  W: function(date, _, options) {
    return options.getWeek(date);
  },
  Y: function(date) {
    return pad2(date.getFullYear(), 4);
  },
  d: function(date) {
    return pad2(date.getDate());
  },
  h: function(date) {
    return date.getHours() % 12 ? date.getHours() % 12 : 12;
  },
  i: function(date) {
    return pad2(date.getMinutes());
  },
  j: function(date) {
    return date.getDate();
  },
  l: function(date, locale) {
    return locale.weekdays.longhand[date.getDay()];
  },
  m: function(date) {
    return pad2(date.getMonth() + 1);
  },
  n: function(date) {
    return date.getMonth() + 1;
  },
  s: function(date) {
    return date.getSeconds();
  },
  u: function(date) {
    return date.getTime();
  },
  w: function(date) {
    return date.getDay();
  },
  y: function(date) {
    return String(date.getFullYear()).substring(2);
  }
};

// node_modules/flatpickr/dist/esm/utils/dates.js
var createDateFormatter = function(_a) {
  var _b = _a.config, config = _b === void 0 ? defaults : _b, _c = _a.l10n, l10n = _c === void 0 ? english : _c, _d = _a.isMobile, isMobile = _d === void 0 ? false : _d;
  return function(dateObj, frmt, overrideLocale) {
    var locale = overrideLocale || l10n;
    if (config.formatDate !== void 0 && !isMobile) {
      return config.formatDate(dateObj, frmt, locale);
    }
    return frmt.split('').map(function(c, i, arr) {
      return formats[c] && arr[i - 1] !== '\\' ? formats[c](dateObj, locale, config) : c !== '\\' ? c : '';
    }).join('');
  };
};
var createDateParser = function(_a) {
  var _b = _a.config, config = _b === void 0 ? defaults : _b, _c = _a.l10n, l10n = _c === void 0 ? english : _c;
  return function(date, givenFormat, timeless, customLocale) {
    if (date !== 0 && !date)
      return void 0;
    var locale = customLocale || l10n;
    var parsedDate;
    var dateOrig = date;
    if (date instanceof Date)
      parsedDate = new Date(date.getTime());
    else if (typeof date !== 'string' && date.toFixed !== void 0)
      parsedDate = new Date(date);
    else if (typeof date === 'string') {
      var format2 = givenFormat || (config || defaults).dateFormat;
      var datestr = String(date).trim();
      if (datestr === 'today') {
        parsedDate = /* @__PURE__ */ new Date();
        timeless = true;
      } else if (config && config.parseDate) {
        parsedDate = config.parseDate(date, format2);
      } else if (/Z$/.test(datestr) || /GMT$/.test(datestr)) {
        parsedDate = new Date(date);
      } else {
        var matched = void 0, ops = [];
        for (var i = 0, matchIndex = 0, regexStr = ''; i < format2.length; i++) {
          var token = format2[i];
          var isBackSlash = token === '\\';
          var escaped = format2[i - 1] === '\\' || isBackSlash;
          if (tokenRegex[token] && !escaped) {
            regexStr += tokenRegex[token];
            var match = new RegExp(regexStr).exec(date);
            if (match && (matched = true)) {
              ops[token !== 'Y' ? 'push' : 'unshift']({
                fn: revFormat[token],
                val: match[++matchIndex]
              });
            }
          } else if (!isBackSlash)
            regexStr += '.';
        }
        parsedDate = !config || !config.noCalendar ? new Date((/* @__PURE__ */ new Date()).getFullYear(), 0, 1, 0, 0, 0, 0) : new Date((/* @__PURE__ */ new Date()).setHours(0, 0, 0, 0));
        ops.forEach(function(_a2) {
          var fn = _a2.fn, val = _a2.val;
          return parsedDate = fn(parsedDate, val, locale) || parsedDate;
        });
        parsedDate = matched ? parsedDate : void 0;
      }
    }
    if (!(parsedDate instanceof Date && !isNaN(parsedDate.getTime()))) {
      config.errorHandler(new Error('Invalid date provided: ' + dateOrig));
      return void 0;
    }
    if (timeless === true)
      parsedDate.setHours(0, 0, 0, 0);
    return parsedDate;
  };
};
function compareDates(date1, date2, timeless) {
  if (timeless === void 0) {
    timeless = true;
  }
  if (timeless !== false) {
    return new Date(date1.getTime()).setHours(0, 0, 0, 0) - new Date(date2.getTime()).setHours(0, 0, 0, 0);
  }
  return date1.getTime() - date2.getTime();
}
var isBetween = function(ts, ts1, ts2) {
  return ts > Math.min(ts1, ts2) && ts < Math.max(ts1, ts2);
};
var calculateSecondsSinceMidnight = function(hours, minutes, seconds) {
  return hours * 3600 + minutes * 60 + seconds;
};
var parseSeconds = function(secondsSinceMidnight) {
  var hours = Math.floor(secondsSinceMidnight / 3600), minutes = (secondsSinceMidnight - hours * 3600) / 60;
  return [hours, minutes, secondsSinceMidnight - hours * 3600 - minutes * 60];
};
var duration = {
  DAY: 864e5
};
function getDefaultHours(config) {
  var hours = config.defaultHour;
  var minutes = config.defaultMinute;
  var seconds = config.defaultSeconds;
  if (config.minDate !== void 0) {
    var minHour = config.minDate.getHours();
    var minMinutes = config.minDate.getMinutes();
    var minSeconds = config.minDate.getSeconds();
    if (hours < minHour) {
      hours = minHour;
    }
    if (hours === minHour && minutes < minMinutes) {
      minutes = minMinutes;
    }
    if (hours === minHour && minutes === minMinutes && seconds < minSeconds)
      seconds = config.minDate.getSeconds();
  }
  if (config.maxDate !== void 0) {
    var maxHr = config.maxDate.getHours();
    var maxMinutes = config.maxDate.getMinutes();
    hours = Math.min(hours, maxHr);
    if (hours === maxHr)
      minutes = Math.min(maxMinutes, minutes);
    if (hours === maxHr && minutes === maxMinutes)
      seconds = config.maxDate.getSeconds();
  }
  return { hours, minutes, seconds };
}

// node_modules/flatpickr/dist/esm/utils/polyfills.js
if (typeof Object.assign !== 'function') {
  Object.assign = function(target) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
      args[_i - 1] = arguments[_i];
    }
    if (!target) {
      throw TypeError('Cannot convert undefined or null to object');
    }
    var _loop_1 = function(source2) {
      if (source2) {
        Object.keys(source2).forEach(function(key) {
          return target[key] = source2[key];
        });
      }
    };
    for (var _a = 0, args_1 = args; _a < args_1.length; _a++) {
      var source = args_1[_a];
      _loop_1(source);
    }
    return target;
  };
}

// node_modules/flatpickr/dist/esm/index.js
var __assign = function() {
  __assign = Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
        t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __spreadArrays = function() {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
  // eslint-disable-next-line no-redeclare
  for (var r = Array(s), k = 0, i = 0; i < il; i++)
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
      r[k] = a[j];
  return r;
};
var DEBOUNCED_CHANGE_MS = 300;
function FlatpickrInstance(element, instanceConfig) {
  var self2 = {
    config: __assign(__assign({}, defaults), flatpickr.defaultConfig),
    l10n: default_default
  };
  self2.parseDate = createDateParser({ config: self2.config, l10n: self2.l10n });
  self2._handlers = [];
  self2.pluginElements = [];
  self2.loadedPlugins = [];
  self2._bind = bind;
  self2._setHoursFromDate = setHoursFromDate;
  self2._positionCalendar = positionCalendar;
  self2.changeMonth = changeMonth;
  self2.changeYear = changeYear;
  self2.clear = clear2;
  self2.close = close;
  self2.onMouseOver = onMouseOver;
  self2._createElement = createElement;
  self2.createDay = createDay;
  self2.destroy = destroy;
  self2.isEnabled = isEnabled;
  self2.jumpToDate = jumpToDate;
  self2.updateValue = updateValue;
  self2.open = open;
  self2.redraw = redraw;
  self2.set = set;
  self2.setDate = setDate;
  self2.toggle = toggle;
  function setupHelperFunctions() {
    self2.utils = {
      getDaysInMonth: function(month, yr) {
        if (month === void 0) {
          month = self2.currentMonth;
        }
        if (yr === void 0) {
          yr = self2.currentYear;
        }
        if (month === 1 && (yr % 4 === 0 && yr % 100 !== 0 || yr % 400 === 0))
          return 29;
        return self2.l10n.daysInMonth[month];
      }
    };
  }
  function init() {
    self2.element = self2.input = element;
    self2.isOpen = false;
    parseConfig();
    setupLocale();
    setupInputs();
    setupDates();
    setupHelperFunctions();
    if (!self2.isMobile)
      build();
    bindEvents();
    if (self2.selectedDates.length || self2.config.noCalendar) {
      if (self2.config.enableTime) {
        setHoursFromDate(self2.config.noCalendar ? self2.latestSelectedDateObj : void 0);
      }
      updateValue(false);
    }
    setCalendarWidth();
    var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (!self2.isMobile && isSafari) {
      positionCalendar();
    }
    triggerEvent('onReady');
  }
  function getClosestActiveElement() {
    var _a;
    return ((_a = self2.calendarContainer) === null || _a === void 0 ? void 0 : _a.getRootNode()).activeElement || document.activeElement;
  }
  function bindToInstance(fn) {
    return fn.bind(self2);
  }
  function setCalendarWidth() {
    var config = self2.config;
    if (config.weekNumbers === false && config.showMonths === 1) {
      return;
    } else if (config.noCalendar !== true) {
      window.requestAnimationFrame(function() {
        if (self2.calendarContainer !== void 0) {
          self2.calendarContainer.style.visibility = 'hidden';
          self2.calendarContainer.style.display = 'block';
        }
        if (self2.daysContainer !== void 0) {
          var daysWidth = (self2.days.offsetWidth + 1) * config.showMonths;
          self2.daysContainer.style.width = daysWidth + 'px';
          self2.calendarContainer.style.width = daysWidth + (self2.weekWrapper !== void 0 ? self2.weekWrapper.offsetWidth : 0) + 'px';
          self2.calendarContainer.style.removeProperty('visibility');
          self2.calendarContainer.style.removeProperty('display');
        }
      });
    }
  }
  function updateTime(e) {
    if (self2.selectedDates.length === 0) {
      var defaultDate = self2.config.minDate === void 0 || compareDates(/* @__PURE__ */ new Date(), self2.config.minDate) >= 0 ? /* @__PURE__ */ new Date() : new Date(self2.config.minDate.getTime());
      var defaults2 = getDefaultHours(self2.config);
      defaultDate.setHours(defaults2.hours, defaults2.minutes, defaults2.seconds, defaultDate.getMilliseconds());
      self2.selectedDates = [defaultDate];
      self2.latestSelectedDateObj = defaultDate;
    }
    if (e !== void 0 && e.type !== 'blur') {
      timeWrapper(e);
    }
    var prevValue = self2._input.value;
    setHoursFromInputs();
    updateValue();
    if (self2._input.value !== prevValue) {
      self2._debouncedChange();
    }
  }
  function ampm2military(hour, amPM) {
    return hour % 12 + 12 * int(amPM === self2.l10n.amPM[1]);
  }
  function military2ampm(hour) {
    switch (hour % 24) {
      case 0:
      case 12:
        return 12;
      default:
        return hour % 12;
    }
  }
  function setHoursFromInputs() {
    if (self2.hourElement === void 0 || self2.minuteElement === void 0)
      return;
    var hours = (parseInt(self2.hourElement.value.slice(-2), 10) || 0) % 24, minutes = (parseInt(self2.minuteElement.value, 10) || 0) % 60, seconds = self2.secondElement !== void 0 ? (parseInt(self2.secondElement.value, 10) || 0) % 60 : 0;
    if (self2.amPM !== void 0) {
      hours = ampm2military(hours, self2.amPM.textContent);
    }
    var limitMinHours = self2.config.minTime !== void 0 || self2.config.minDate && self2.minDateHasTime && self2.latestSelectedDateObj && compareDates(self2.latestSelectedDateObj, self2.config.minDate, true) === 0;
    var limitMaxHours = self2.config.maxTime !== void 0 || self2.config.maxDate && self2.maxDateHasTime && self2.latestSelectedDateObj && compareDates(self2.latestSelectedDateObj, self2.config.maxDate, true) === 0;
    if (self2.config.maxTime !== void 0 && self2.config.minTime !== void 0 && self2.config.minTime > self2.config.maxTime) {
      var minBound = calculateSecondsSinceMidnight(self2.config.minTime.getHours(), self2.config.minTime.getMinutes(), self2.config.minTime.getSeconds());
      var maxBound = calculateSecondsSinceMidnight(self2.config.maxTime.getHours(), self2.config.maxTime.getMinutes(), self2.config.maxTime.getSeconds());
      var currentTime = calculateSecondsSinceMidnight(hours, minutes, seconds);
      if (currentTime > maxBound && currentTime < minBound) {
        var result = parseSeconds(minBound);
        hours = result[0];
        minutes = result[1];
        seconds = result[2];
      }
    } else {
      if (limitMaxHours) {
        var maxTime = self2.config.maxTime !== void 0 ? self2.config.maxTime : self2.config.maxDate;
        hours = Math.min(hours, maxTime.getHours());
        if (hours === maxTime.getHours())
          minutes = Math.min(minutes, maxTime.getMinutes());
        if (minutes === maxTime.getMinutes())
          seconds = Math.min(seconds, maxTime.getSeconds());
      }
      if (limitMinHours) {
        var minTime = self2.config.minTime !== void 0 ? self2.config.minTime : self2.config.minDate;
        hours = Math.max(hours, minTime.getHours());
        if (hours === minTime.getHours() && minutes < minTime.getMinutes())
          minutes = minTime.getMinutes();
        if (minutes === minTime.getMinutes())
          seconds = Math.max(seconds, minTime.getSeconds());
      }
    }
    setHours(hours, minutes, seconds);
  }
  function setHoursFromDate(dateObj) {
    var date = dateObj || self2.latestSelectedDateObj;
    if (date && date instanceof Date) {
      setHours(date.getHours(), date.getMinutes(), date.getSeconds());
    }
  }
  function setHours(hours, minutes, seconds) {
    if (self2.latestSelectedDateObj !== void 0) {
      self2.latestSelectedDateObj.setHours(hours % 24, minutes, seconds || 0, 0);
    }
    if (!self2.hourElement || !self2.minuteElement || self2.isMobile)
      return;
    self2.hourElement.value = pad2(!self2.config.time_24hr ? (12 + hours) % 12 + 12 * int(hours % 12 === 0) : hours);
    self2.minuteElement.value = pad2(minutes);
    if (self2.amPM !== void 0)
      self2.amPM.textContent = self2.l10n.amPM[int(hours >= 12)];
    if (self2.secondElement !== void 0)
      self2.secondElement.value = pad2(seconds);
  }
  function onYearInput(event) {
    var eventTarget = getEventTarget(event);
    var year = parseInt(eventTarget.value) + (event.delta || 0);
    if (year / 1e3 > 1 || event.key === 'Enter' && !/[^\d]/.test(year.toString())) {
      changeYear(year);
    }
  }
  function bind(element2, event, handler, options) {
    if (event instanceof Array)
      return event.forEach(function(ev) {
        return bind(element2, ev, handler, options);
      });
    if (element2 instanceof Array)
      return element2.forEach(function(el) {
        return bind(el, event, handler, options);
      });
    element2.addEventListener(event, handler, options);
    self2._handlers.push({
      remove: function() {
        return element2.removeEventListener(event, handler, options);
      }
    });
  }
  function triggerChange() {
    triggerEvent('onChange');
  }
  function bindEvents() {
    if (self2.config.wrap) {
      ['open', 'close', 'toggle', 'clear'].forEach(function(evt) {
        Array.prototype.forEach.call(self2.element.querySelectorAll('[data-' + evt + ']'), function(el) {
          return bind(el, 'click', self2[evt]);
        });
      });
    }
    if (self2.isMobile) {
      setupMobile();
      return;
    }
    var debouncedResize = debounce(onResize, 50);
    self2._debouncedChange = debounce(triggerChange, DEBOUNCED_CHANGE_MS);
    if (self2.daysContainer && !/iPhone|iPad|iPod/i.test(navigator.userAgent))
      bind(self2.daysContainer, 'mouseover', function(e) {
        if (self2.config.mode === 'range')
          onMouseOver(getEventTarget(e));
      });
    bind(self2._input, 'keydown', onKeyDown);
    if (self2.calendarContainer !== void 0) {
      bind(self2.calendarContainer, 'keydown', onKeyDown);
    }
    if (!self2.config.inline && !self2.config.static)
      bind(window, 'resize', debouncedResize);
    if (window.ontouchstart !== void 0)
      bind(window.document, 'touchstart', documentClick);
    else
      bind(window.document, 'mousedown', documentClick);
    bind(window.document, 'focus', documentClick, { capture: true });
    if (self2.config.clickOpens === true) {
      bind(self2._input, 'focus', self2.open);
      bind(self2._input, 'click', self2.open);
    }
    if (self2.daysContainer !== void 0) {
      bind(self2.monthNav, 'click', onMonthNavClick);
      bind(self2.monthNav, ['keyup', 'increment'], onYearInput);
      bind(self2.daysContainer, 'click', selectDate);
    }
    if (self2.timeContainer !== void 0 && self2.minuteElement !== void 0 && self2.hourElement !== void 0) {
      var selText = function(e) {
        return getEventTarget(e).select();
      };
      bind(self2.timeContainer, ['increment'], updateTime);
      bind(self2.timeContainer, 'blur', updateTime, { capture: true });
      bind(self2.timeContainer, 'click', timeIncrement);
      bind([self2.hourElement, self2.minuteElement], ['focus', 'click'], selText);
      if (self2.secondElement !== void 0)
        bind(self2.secondElement, 'focus', function() {
          return self2.secondElement && self2.secondElement.select();
        });
      if (self2.amPM !== void 0) {
        bind(self2.amPM, 'click', function(e) {
          updateTime(e);
        });
      }
    }
    if (self2.config.allowInput) {
      bind(self2._input, 'blur', onBlur);
    }
  }
  function jumpToDate(jumpDate, triggerChange2) {
    var jumpTo = jumpDate !== void 0 ? self2.parseDate(jumpDate) : self2.latestSelectedDateObj || (self2.config.minDate && self2.config.minDate > self2.now ? self2.config.minDate : self2.config.maxDate && self2.config.maxDate < self2.now ? self2.config.maxDate : self2.now);
    var oldYear = self2.currentYear;
    var oldMonth = self2.currentMonth;
    try {
      if (jumpTo !== void 0) {
        self2.currentYear = jumpTo.getFullYear();
        self2.currentMonth = jumpTo.getMonth();
      }
    } catch (e) {
      e.message = 'Invalid date supplied: ' + jumpTo;
      self2.config.errorHandler(e);
    }
    if (triggerChange2 && self2.currentYear !== oldYear) {
      triggerEvent('onYearChange');
      buildMonthSwitch();
    }
    if (triggerChange2 && (self2.currentYear !== oldYear || self2.currentMonth !== oldMonth)) {
      triggerEvent('onMonthChange');
    }
    self2.redraw();
  }
  function timeIncrement(e) {
    var eventTarget = getEventTarget(e);
    if (~eventTarget.className.indexOf('arrow'))
      incrementNumInput(e, eventTarget.classList.contains('arrowUp') ? 1 : -1);
  }
  function incrementNumInput(e, delta, inputElem) {
    var target = e && getEventTarget(e);
    var input = inputElem || target && target.parentNode && target.parentNode.firstChild;
    var event = createEvent('increment');
    event.delta = delta;
    input && input.dispatchEvent(event);
  }
  function build() {
    var fragment = window.document.createDocumentFragment();
    self2.calendarContainer = createElement('div', 'flatpickr-calendar');
    self2.calendarContainer.tabIndex = -1;
    if (!self2.config.noCalendar) {
      fragment.appendChild(buildMonthNav());
      self2.innerContainer = createElement('div', 'flatpickr-innerContainer');
      if (self2.config.weekNumbers) {
        var _a = buildWeeks(), weekWrapper = _a.weekWrapper, weekNumbers = _a.weekNumbers;
        self2.innerContainer.appendChild(weekWrapper);
        self2.weekNumbers = weekNumbers;
        self2.weekWrapper = weekWrapper;
      }
      self2.rContainer = createElement('div', 'flatpickr-rContainer');
      self2.rContainer.appendChild(buildWeekdays());
      if (!self2.daysContainer) {
        self2.daysContainer = createElement('div', 'flatpickr-days');
        self2.daysContainer.tabIndex = -1;
      }
      buildDays();
      self2.rContainer.appendChild(self2.daysContainer);
      self2.innerContainer.appendChild(self2.rContainer);
      fragment.appendChild(self2.innerContainer);
    }
    if (self2.config.enableTime) {
      fragment.appendChild(buildTime());
    }
    toggleClass2(self2.calendarContainer, 'rangeMode', self2.config.mode === 'range');
    toggleClass2(self2.calendarContainer, 'animate', self2.config.animate === true);
    toggleClass2(self2.calendarContainer, 'multiMonth', self2.config.showMonths > 1);
    self2.calendarContainer.appendChild(fragment);
    var customAppend = self2.config.appendTo !== void 0 && self2.config.appendTo.nodeType !== void 0;
    if (self2.config.inline || self2.config.static) {
      self2.calendarContainer.classList.add(self2.config.inline ? 'inline' : 'static');
      if (self2.config.inline) {
        if (!customAppend && self2.element.parentNode)
          self2.element.parentNode.insertBefore(self2.calendarContainer, self2._input.nextSibling);
        else if (self2.config.appendTo !== void 0)
          self2.config.appendTo.appendChild(self2.calendarContainer);
      }
      if (self2.config.static) {
        var wrapper = createElement('div', 'flatpickr-wrapper');
        if (self2.element.parentNode)
          self2.element.parentNode.insertBefore(wrapper, self2.element);
        wrapper.appendChild(self2.element);
        if (self2.altInput)
          wrapper.appendChild(self2.altInput);
        wrapper.appendChild(self2.calendarContainer);
      }
    }
    if (!self2.config.static && !self2.config.inline)
      (self2.config.appendTo !== void 0 ? self2.config.appendTo : window.document.body).appendChild(self2.calendarContainer);
  }
  function createDay(className, date, _dayNumber, i) {
    var dateIsEnabled = isEnabled(date, true), dayElement = createElement('span', className, date.getDate().toString());
    dayElement.dateObj = date;
    dayElement.$i = i;
    dayElement.setAttribute('aria-label', self2.formatDate(date, self2.config.ariaDateFormat));
    if (className.indexOf('hidden') === -1 && compareDates(date, self2.now) === 0) {
      self2.todayDateElem = dayElement;
      dayElement.classList.add('today');
      dayElement.setAttribute('aria-current', 'date');
    }
    if (dateIsEnabled) {
      dayElement.tabIndex = -1;
      if (isDateSelected(date)) {
        dayElement.classList.add('selected');
        self2.selectedDateElem = dayElement;
        if (self2.config.mode === 'range') {
          toggleClass2(dayElement, 'startRange', self2.selectedDates[0] && compareDates(date, self2.selectedDates[0], true) === 0);
          toggleClass2(dayElement, 'endRange', self2.selectedDates[1] && compareDates(date, self2.selectedDates[1], true) === 0);
          if (className === 'nextMonthDay')
            dayElement.classList.add('inRange');
        }
      }
    } else {
      dayElement.classList.add('flatpickr-disabled');
    }
    if (self2.config.mode === 'range') {
      if (isDateInRange(date) && !isDateSelected(date))
        dayElement.classList.add('inRange');
    }
    if (self2.weekNumbers && self2.config.showMonths === 1 && className !== 'prevMonthDay' && i % 7 === 6) {
      self2.weekNumbers.insertAdjacentHTML('beforeend', '<span class=\'flatpickr-day\'>' + self2.config.getWeek(date) + '</span>');
    }
    triggerEvent('onDayCreate', dayElement);
    return dayElement;
  }
  function focusOnDayElem(targetNode) {
    targetNode.focus();
    if (self2.config.mode === 'range')
      onMouseOver(targetNode);
  }
  function getFirstAvailableDay(delta) {
    var startMonth = delta > 0 ? 0 : self2.config.showMonths - 1;
    var endMonth = delta > 0 ? self2.config.showMonths : -1;
    for (var m = startMonth; m != endMonth; m += delta) {
      var month = self2.daysContainer.children[m];
      var startIndex = delta > 0 ? 0 : month.children.length - 1;
      var endIndex = delta > 0 ? month.children.length : -1;
      for (var i = startIndex; i != endIndex; i += delta) {
        var c = month.children[i];
        if (c.className.indexOf('hidden') === -1 && isEnabled(c.dateObj))
          return c;
      }
    }
    return void 0;
  }
  function getNextAvailableDay(current, delta) {
    var givenMonth = current.className.indexOf('Month') === -1 ? current.dateObj.getMonth() : self2.currentMonth;
    var endMonth = delta > 0 ? self2.config.showMonths : -1;
    var loopDelta = delta > 0 ? 1 : -1;
    for (var m = givenMonth - self2.currentMonth; m != endMonth; m += loopDelta) {
      var month = self2.daysContainer.children[m];
      var startIndex = givenMonth - self2.currentMonth === m ? current.$i + delta : delta < 0 ? month.children.length - 1 : 0;
      var numMonthDays = month.children.length;
      for (var i = startIndex; i >= 0 && i < numMonthDays && i != (delta > 0 ? numMonthDays : -1); i += loopDelta) {
        var c = month.children[i];
        if (c.className.indexOf('hidden') === -1 && isEnabled(c.dateObj) && Math.abs(current.$i - i) >= Math.abs(delta))
          return focusOnDayElem(c);
      }
    }
    self2.changeMonth(loopDelta);
    focusOnDay(getFirstAvailableDay(loopDelta), 0);
    return void 0;
  }
  function focusOnDay(current, offset) {
    var activeElement = getClosestActiveElement();
    var dayFocused = isInView(activeElement || document.body);
    var startElem = current !== void 0 ? current : dayFocused ? activeElement : self2.selectedDateElem !== void 0 && isInView(self2.selectedDateElem) ? self2.selectedDateElem : self2.todayDateElem !== void 0 && isInView(self2.todayDateElem) ? self2.todayDateElem : getFirstAvailableDay(offset > 0 ? 1 : -1);
    if (startElem === void 0) {
      self2._input.focus();
    } else if (!dayFocused) {
      focusOnDayElem(startElem);
    } else {
      getNextAvailableDay(startElem, offset);
    }
  }
  function buildMonthDays(year, month) {
    var firstOfMonth = (new Date(year, month, 1).getDay() - self2.l10n.firstDayOfWeek + 7) % 7;
    var prevMonthDays = self2.utils.getDaysInMonth((month - 1 + 12) % 12, year);
    var daysInMonth = self2.utils.getDaysInMonth(month, year), days = window.document.createDocumentFragment(), isMultiMonth = self2.config.showMonths > 1, prevMonthDayClass = isMultiMonth ? 'prevMonthDay hidden' : 'prevMonthDay', nextMonthDayClass = isMultiMonth ? 'nextMonthDay hidden' : 'nextMonthDay';
    var dayNumber = prevMonthDays + 1 - firstOfMonth, dayIndex = 0;
    for (; dayNumber <= prevMonthDays; dayNumber++, dayIndex++) {
      days.appendChild(createDay('flatpickr-day ' + prevMonthDayClass, new Date(year, month - 1, dayNumber), dayNumber, dayIndex));
    }
    for (dayNumber = 1; dayNumber <= daysInMonth; dayNumber++, dayIndex++) {
      days.appendChild(createDay('flatpickr-day', new Date(year, month, dayNumber), dayNumber, dayIndex));
    }
    for (var dayNum = daysInMonth + 1; dayNum <= 42 - firstOfMonth && (self2.config.showMonths === 1 || dayIndex % 7 !== 0); dayNum++, dayIndex++) {
      days.appendChild(createDay('flatpickr-day ' + nextMonthDayClass, new Date(year, month + 1, dayNum % daysInMonth), dayNum, dayIndex));
    }
    var dayContainer = createElement('div', 'dayContainer');
    dayContainer.appendChild(days);
    return dayContainer;
  }
  function buildDays() {
    if (self2.daysContainer === void 0) {
      return;
    }
    clearNode(self2.daysContainer);
    if (self2.weekNumbers)
      clearNode(self2.weekNumbers);
    var frag = document.createDocumentFragment();
    for (var i = 0; i < self2.config.showMonths; i++) {
      var d = new Date(self2.currentYear, self2.currentMonth, 1);
      d.setMonth(self2.currentMonth + i);
      frag.appendChild(buildMonthDays(d.getFullYear(), d.getMonth()));
    }
    self2.daysContainer.appendChild(frag);
    self2.days = self2.daysContainer.firstChild;
    if (self2.config.mode === 'range' && self2.selectedDates.length === 1) {
      onMouseOver();
    }
  }
  function buildMonthSwitch() {
    if (self2.config.showMonths > 1 || self2.config.monthSelectorType !== 'dropdown')
      return;
    var shouldBuildMonth = function(month2) {
      if (self2.config.minDate !== void 0 && self2.currentYear === self2.config.minDate.getFullYear() && month2 < self2.config.minDate.getMonth()) {
        return false;
      }
      return !(self2.config.maxDate !== void 0 && self2.currentYear === self2.config.maxDate.getFullYear() && month2 > self2.config.maxDate.getMonth());
    };
    self2.monthsDropdownContainer.tabIndex = -1;
    self2.monthsDropdownContainer.innerHTML = '';
    for (var i = 0; i < 12; i++) {
      if (!shouldBuildMonth(i))
        continue;
      var month = createElement('option', 'flatpickr-monthDropdown-month');
      month.value = new Date(self2.currentYear, i).getMonth().toString();
      month.textContent = monthToStr(i, self2.config.shorthandCurrentMonth, self2.l10n);
      month.tabIndex = -1;
      if (self2.currentMonth === i) {
        month.selected = true;
      }
      self2.monthsDropdownContainer.appendChild(month);
    }
  }
  function buildMonth() {
    var container = createElement('div', 'flatpickr-month');
    var monthNavFragment = window.document.createDocumentFragment();
    var monthElement;
    if (self2.config.showMonths > 1 || self2.config.monthSelectorType === 'static') {
      monthElement = createElement('span', 'cur-month');
    } else {
      self2.monthsDropdownContainer = createElement('select', 'flatpickr-monthDropdown-months');
      self2.monthsDropdownContainer.setAttribute('aria-label', self2.l10n.monthAriaLabel);
      bind(self2.monthsDropdownContainer, 'change', function(e) {
        var target = getEventTarget(e);
        var selectedMonth = parseInt(target.value, 10);
        self2.changeMonth(selectedMonth - self2.currentMonth);
        triggerEvent('onMonthChange');
      });
      buildMonthSwitch();
      monthElement = self2.monthsDropdownContainer;
    }
    var yearInput = createNumberInput('cur-year', { tabindex: '-1' });
    var yearElement = yearInput.getElementsByTagName('input')[0];
    yearElement.setAttribute('aria-label', self2.l10n.yearAriaLabel);
    if (self2.config.minDate) {
      yearElement.setAttribute('min', self2.config.minDate.getFullYear().toString());
    }
    if (self2.config.maxDate) {
      yearElement.setAttribute('max', self2.config.maxDate.getFullYear().toString());
      yearElement.disabled = !!self2.config.minDate && self2.config.minDate.getFullYear() === self2.config.maxDate.getFullYear();
    }
    var currentMonth = createElement('div', 'flatpickr-current-month');
    currentMonth.appendChild(monthElement);
    currentMonth.appendChild(yearInput);
    monthNavFragment.appendChild(currentMonth);
    container.appendChild(monthNavFragment);
    return {
      container,
      yearElement,
      monthElement
    };
  }
  function buildMonths() {
    clearNode(self2.monthNav);
    self2.monthNav.appendChild(self2.prevMonthNav);
    if (self2.config.showMonths) {
      self2.yearElements = [];
      self2.monthElements = [];
    }
    for (var m = self2.config.showMonths; m--; ) {
      var month = buildMonth();
      self2.yearElements.push(month.yearElement);
      self2.monthElements.push(month.monthElement);
      self2.monthNav.appendChild(month.container);
    }
    self2.monthNav.appendChild(self2.nextMonthNav);
  }
  function buildMonthNav() {
    self2.monthNav = createElement('div', 'flatpickr-months');
    self2.yearElements = [];
    self2.monthElements = [];
    self2.prevMonthNav = createElement('span', 'flatpickr-prev-month');
    self2.prevMonthNav.innerHTML = self2.config.prevArrow;
    self2.nextMonthNav = createElement('span', 'flatpickr-next-month');
    self2.nextMonthNav.innerHTML = self2.config.nextArrow;
    buildMonths();
    Object.defineProperty(self2, '_hidePrevMonthArrow', {
      get: function() {
        return self2.__hidePrevMonthArrow;
      },
      set: function(bool) {
        if (self2.__hidePrevMonthArrow !== bool) {
          toggleClass2(self2.prevMonthNav, 'flatpickr-disabled', bool);
          self2.__hidePrevMonthArrow = bool;
        }
      }
    });
    Object.defineProperty(self2, '_hideNextMonthArrow', {
      get: function() {
        return self2.__hideNextMonthArrow;
      },
      set: function(bool) {
        if (self2.__hideNextMonthArrow !== bool) {
          toggleClass2(self2.nextMonthNav, 'flatpickr-disabled', bool);
          self2.__hideNextMonthArrow = bool;
        }
      }
    });
    self2.currentYearElement = self2.yearElements[0];
    updateNavigationCurrentMonth();
    return self2.monthNav;
  }
  function buildTime() {
    self2.calendarContainer.classList.add('hasTime');
    if (self2.config.noCalendar)
      self2.calendarContainer.classList.add('noCalendar');
    var defaults2 = getDefaultHours(self2.config);
    self2.timeContainer = createElement('div', 'flatpickr-time');
    self2.timeContainer.tabIndex = -1;
    var separator = createElement('span', 'flatpickr-time-separator', ':');
    var hourInput = createNumberInput('flatpickr-hour', {
      'aria-label': self2.l10n.hourAriaLabel
    });
    self2.hourElement = hourInput.getElementsByTagName('input')[0];
    var minuteInput = createNumberInput('flatpickr-minute', {
      'aria-label': self2.l10n.minuteAriaLabel
    });
    self2.minuteElement = minuteInput.getElementsByTagName('input')[0];
    self2.hourElement.tabIndex = self2.minuteElement.tabIndex = -1;
    self2.hourElement.value = pad2(self2.latestSelectedDateObj ? self2.latestSelectedDateObj.getHours() : self2.config.time_24hr ? defaults2.hours : military2ampm(defaults2.hours));
    self2.minuteElement.value = pad2(self2.latestSelectedDateObj ? self2.latestSelectedDateObj.getMinutes() : defaults2.minutes);
    self2.hourElement.setAttribute('step', self2.config.hourIncrement.toString());
    self2.minuteElement.setAttribute('step', self2.config.minuteIncrement.toString());
    self2.hourElement.setAttribute('min', self2.config.time_24hr ? '0' : '1');
    self2.hourElement.setAttribute('max', self2.config.time_24hr ? '23' : '12');
    self2.hourElement.setAttribute('maxlength', '2');
    self2.minuteElement.setAttribute('min', '0');
    self2.minuteElement.setAttribute('max', '59');
    self2.minuteElement.setAttribute('maxlength', '2');
    self2.timeContainer.appendChild(hourInput);
    self2.timeContainer.appendChild(separator);
    self2.timeContainer.appendChild(minuteInput);
    if (self2.config.time_24hr)
      self2.timeContainer.classList.add('time24hr');
    if (self2.config.enableSeconds) {
      self2.timeContainer.classList.add('hasSeconds');
      var secondInput = createNumberInput('flatpickr-second');
      self2.secondElement = secondInput.getElementsByTagName('input')[0];
      self2.secondElement.value = pad2(self2.latestSelectedDateObj ? self2.latestSelectedDateObj.getSeconds() : defaults2.seconds);
      self2.secondElement.setAttribute('step', self2.minuteElement.getAttribute('step'));
      self2.secondElement.setAttribute('min', '0');
      self2.secondElement.setAttribute('max', '59');
      self2.secondElement.setAttribute('maxlength', '2');
      self2.timeContainer.appendChild(createElement('span', 'flatpickr-time-separator', ':'));
      self2.timeContainer.appendChild(secondInput);
    }
    if (!self2.config.time_24hr) {
      self2.amPM = createElement('span', 'flatpickr-am-pm', self2.l10n.amPM[int((self2.latestSelectedDateObj ? self2.hourElement.value : self2.config.defaultHour) > 11)]);
      self2.amPM.title = self2.l10n.toggleTitle;
      self2.amPM.tabIndex = -1;
      self2.timeContainer.appendChild(self2.amPM);
    }
    return self2.timeContainer;
  }
  function buildWeekdays() {
    if (!self2.weekdayContainer)
      self2.weekdayContainer = createElement('div', 'flatpickr-weekdays');
    else
      clearNode(self2.weekdayContainer);
    for (var i = self2.config.showMonths; i--; ) {
      var container = createElement('div', 'flatpickr-weekdaycontainer');
      self2.weekdayContainer.appendChild(container);
    }
    updateWeekdays();
    return self2.weekdayContainer;
  }
  function updateWeekdays() {
    if (!self2.weekdayContainer) {
      return;
    }
    var firstDayOfWeek = self2.l10n.firstDayOfWeek;
    var weekdays = __spreadArrays(self2.l10n.weekdays.shorthand);
    if (firstDayOfWeek > 0 && firstDayOfWeek < weekdays.length) {
      weekdays = __spreadArrays(weekdays.splice(firstDayOfWeek, weekdays.length), weekdays.splice(0, firstDayOfWeek));
    }
    for (var i = self2.config.showMonths; i--; ) {
      self2.weekdayContainer.children[i].innerHTML = '\n      <span class=\'flatpickr-weekday\'>\n        ' + weekdays.join('</span><span class=\'flatpickr-weekday\'>') + '\n      </span>\n      ';
    }
  }
  function buildWeeks() {
    self2.calendarContainer.classList.add('hasWeeks');
    var weekWrapper = createElement('div', 'flatpickr-weekwrapper');
    weekWrapper.appendChild(createElement('span', 'flatpickr-weekday', self2.l10n.weekAbbreviation));
    var weekNumbers = createElement('div', 'flatpickr-weeks');
    weekWrapper.appendChild(weekNumbers);
    return {
      weekWrapper,
      weekNumbers
    };
  }
  function changeMonth(value, isOffset) {
    if (isOffset === void 0) {
      isOffset = true;
    }
    var delta = isOffset ? value : value - self2.currentMonth;
    if (delta < 0 && self2._hidePrevMonthArrow === true || delta > 0 && self2._hideNextMonthArrow === true)
      return;
    self2.currentMonth += delta;
    if (self2.currentMonth < 0 || self2.currentMonth > 11) {
      self2.currentYear += self2.currentMonth > 11 ? 1 : -1;
      self2.currentMonth = (self2.currentMonth + 12) % 12;
      triggerEvent('onYearChange');
      buildMonthSwitch();
    }
    buildDays();
    triggerEvent('onMonthChange');
    updateNavigationCurrentMonth();
  }
  function clear2(triggerChangeEvent, toInitial) {
    if (triggerChangeEvent === void 0) {
      triggerChangeEvent = true;
    }
    if (toInitial === void 0) {
      toInitial = true;
    }
    self2.input.value = '';
    if (self2.altInput !== void 0)
      self2.altInput.value = '';
    if (self2.mobileInput !== void 0)
      self2.mobileInput.value = '';
    self2.selectedDates = [];
    self2.latestSelectedDateObj = void 0;
    if (toInitial === true) {
      self2.currentYear = self2._initialDate.getFullYear();
      self2.currentMonth = self2._initialDate.getMonth();
    }
    if (self2.config.enableTime === true) {
      var _a = getDefaultHours(self2.config), hours = _a.hours, minutes = _a.minutes, seconds = _a.seconds;
      setHours(hours, minutes, seconds);
    }
    self2.redraw();
    if (triggerChangeEvent)
      triggerEvent('onChange');
  }
  function close() {
    self2.isOpen = false;
    if (!self2.isMobile) {
      if (self2.calendarContainer !== void 0) {
        self2.calendarContainer.classList.remove('open');
      }
      if (self2._input !== void 0) {
        self2._input.classList.remove('active');
      }
    }
    triggerEvent('onClose');
  }
  function destroy() {
    if (self2.config !== void 0)
      triggerEvent('onDestroy');
    for (var i = self2._handlers.length; i--; ) {
      self2._handlers[i].remove();
    }
    self2._handlers = [];
    if (self2.mobileInput) {
      if (self2.mobileInput.parentNode)
        self2.mobileInput.parentNode.removeChild(self2.mobileInput);
      self2.mobileInput = void 0;
    } else if (self2.calendarContainer && self2.calendarContainer.parentNode) {
      if (self2.config.static && self2.calendarContainer.parentNode) {
        var wrapper = self2.calendarContainer.parentNode;
        wrapper.lastChild && wrapper.removeChild(wrapper.lastChild);
        if (wrapper.parentNode) {
          while (wrapper.firstChild)
            wrapper.parentNode.insertBefore(wrapper.firstChild, wrapper);
          wrapper.parentNode.removeChild(wrapper);
        }
      } else
        self2.calendarContainer.parentNode.removeChild(self2.calendarContainer);
    }
    if (self2.altInput) {
      self2.input.type = 'text';
      if (self2.altInput.parentNode)
        self2.altInput.parentNode.removeChild(self2.altInput);
      delete self2.altInput;
    }
    if (self2.input) {
      self2.input.type = self2.input._type;
      self2.input.classList.remove('flatpickr-input');
      self2.input.removeAttribute('readonly');
    }
    [
      '_showTimeInput',
      'latestSelectedDateObj',
      '_hideNextMonthArrow',
      '_hidePrevMonthArrow',
      '__hideNextMonthArrow',
      '__hidePrevMonthArrow',
      'isMobile',
      'isOpen',
      'selectedDateElem',
      'minDateHasTime',
      'maxDateHasTime',
      'days',
      'daysContainer',
      '_input',
      '_positionElement',
      'innerContainer',
      'rContainer',
      'monthNav',
      'todayDateElem',
      'calendarContainer',
      'weekdayContainer',
      'prevMonthNav',
      'nextMonthNav',
      'monthsDropdownContainer',
      'currentMonthElement',
      'currentYearElement',
      'navigationCurrentMonth',
      'selectedDateElem',
      'config'
    ].forEach(function(k) {
      try {
        delete self2[k];
      } catch (_) {
          // eslint-disable-next-line no-empty
      }
    });
  }
  function isCalendarElem(elem) {
    return self2.calendarContainer.contains(elem);
  }
  // eslint-disable-next-line no-empty
  function documentClick(e) {
    if (self2.isOpen && !self2.config.inline) {
      var eventTarget_1 = getEventTarget(e);
      var isCalendarElement = isCalendarElem(eventTarget_1);
      var isInput = eventTarget_1 === self2.input || eventTarget_1 === self2.altInput || self2.element.contains(eventTarget_1) || e.path && e.path.indexOf && (~e.path.indexOf(self2.input) || ~e.path.indexOf(self2.altInput));
      var lostFocus = !isInput && !isCalendarElement && !isCalendarElem(e.relatedTarget);
      var isIgnored = !self2.config.ignoredFocusElements.some(function(elem) {
        return elem.contains(eventTarget_1);
      });
      if (lostFocus && isIgnored) {
        if (self2.config.allowInput) {
          self2.setDate(self2._input.value, false, self2.config.altInput ? self2.config.altFormat : self2.config.dateFormat);
        }
        if (self2.timeContainer !== void 0 && self2.minuteElement !== void 0 && self2.hourElement !== void 0 && self2.input.value !== '' && self2.input.value !== void 0) {
          updateTime();
        }
        self2.close();
        if (self2.config && self2.config.mode === 'range' && self2.selectedDates.length === 1)
          self2.clear(false);
      }
    }
  }
  function changeYear(newYear) {
    if (!newYear || self2.config.minDate && newYear < self2.config.minDate.getFullYear() || self2.config.maxDate && newYear > self2.config.maxDate.getFullYear())
      return;
    var newYearNum = newYear, isNewYear = self2.currentYear !== newYearNum;
    self2.currentYear = newYearNum || self2.currentYear;
    if (self2.config.maxDate && self2.currentYear === self2.config.maxDate.getFullYear()) {
      self2.currentMonth = Math.min(self2.config.maxDate.getMonth(), self2.currentMonth);
    } else if (self2.config.minDate && self2.currentYear === self2.config.minDate.getFullYear()) {
      self2.currentMonth = Math.max(self2.config.minDate.getMonth(), self2.currentMonth);
    }
    if (isNewYear) {
      self2.redraw();
      triggerEvent('onYearChange');
      buildMonthSwitch();
    }
  }
  function isEnabled(date, timeless) {
    var _a;
    if (timeless === void 0) {
      timeless = true;
    }
    var dateToCheck = self2.parseDate(date, void 0, timeless);
    if (self2.config.minDate && dateToCheck && compareDates(dateToCheck, self2.config.minDate, timeless !== void 0 ? timeless : !self2.minDateHasTime) < 0 || self2.config.maxDate && dateToCheck && compareDates(dateToCheck, self2.config.maxDate, timeless !== void 0 ? timeless : !self2.maxDateHasTime) > 0)
      return false;
    if (!self2.config.enable && self2.config.disable.length === 0)
      return true;
    if (dateToCheck === void 0)
      return false;
    var bool = !!self2.config.enable, array = (_a = self2.config.enable) !== null && _a !== void 0 ? _a : self2.config.disable;
    for (var i = 0, d = void 0; i < array.length; i++) {
      d = array[i];
      if (typeof d === 'function' && d(dateToCheck))
        return bool;
      else if (d instanceof Date && dateToCheck !== void 0 && d.getTime() === dateToCheck.getTime())
        return bool;
      else if (typeof d === 'string') {
        var parsed = self2.parseDate(d, void 0, true);
        return parsed && parsed.getTime() === dateToCheck.getTime() ? bool : !bool;
      } else if (typeof d === 'object' && dateToCheck !== void 0 && d.from && d.to && dateToCheck.getTime() >= d.from.getTime() && dateToCheck.getTime() <= d.to.getTime())
        return bool;
    }
    return !bool;
  }
  function isInView(elem) {
    if (self2.daysContainer !== void 0)
      return elem.className.indexOf('hidden') === -1 && elem.className.indexOf('flatpickr-disabled') === -1 && self2.daysContainer.contains(elem);
    return false;
  }
  function onBlur(e) {
    var isInput = e.target === self2._input;
    var valueChanged = self2._input.value.trimEnd() !== getDateStr();
    if (isInput && valueChanged && !(e.relatedTarget && isCalendarElem(e.relatedTarget))) {
      self2.setDate(self2._input.value, true, e.target === self2.altInput ? self2.config.altFormat : self2.config.dateFormat);
    }
  }
  function onKeyDown(e) {
    var eventTarget = getEventTarget(e);
    var isInput = self2.config.wrap ? element.contains(eventTarget) : eventTarget === self2._input;
    var allowInput = self2.config.allowInput;
    var allowKeydown = self2.isOpen && (!allowInput || !isInput);
    var allowInlineKeydown = self2.config.inline && isInput && !allowInput;
    if (e.keyCode === 13 && isInput) {
      if (allowInput) {
        self2.setDate(self2._input.value, true, eventTarget === self2.altInput ? self2.config.altFormat : self2.config.dateFormat);
        self2.close();
        return eventTarget.blur();
      } else {
        self2.open();
      }
    } else if (isCalendarElem(eventTarget) || allowKeydown || allowInlineKeydown) {
      var isTimeObj = !!self2.timeContainer && self2.timeContainer.contains(eventTarget);
      switch (e.keyCode) {
        case 13:
          if (isTimeObj) {
            e.preventDefault();
            updateTime();
            focusAndClose();
          } else
            selectDate(e);
          break;
        case 27:
          e.preventDefault();
          focusAndClose();
          break;
        case 8:
        case 46:
          if (isInput && !self2.config.allowInput) {
            e.preventDefault();
            self2.clear();
          }
          break;
        case 37:
        case 39:
          if (!isTimeObj && !isInput) {
            e.preventDefault();
            var activeElement = getClosestActiveElement();
            if (self2.daysContainer !== void 0 && (allowInput === false || activeElement && isInView(activeElement))) {
              var delta_1 = e.keyCode === 39 ? 1 : -1;
              if (!e.ctrlKey)
                focusOnDay(void 0, delta_1);
              else {
                e.stopPropagation();
                changeMonth(delta_1);
                focusOnDay(getFirstAvailableDay(1), 0);
              }
            }
          } else if (self2.hourElement)
            self2.hourElement.focus();
          break;
        case 38:
        case 40:
          e.preventDefault();
          var delta = e.keyCode === 40 ? 1 : -1;
          if (self2.daysContainer && eventTarget.$i !== void 0 || eventTarget === self2.input || eventTarget === self2.altInput) {
            if (e.ctrlKey) {
              e.stopPropagation();
              changeYear(self2.currentYear - delta);
              focusOnDay(getFirstAvailableDay(1), 0);
            } else if (!isTimeObj)
              focusOnDay(void 0, delta * 7);
          } else if (eventTarget === self2.currentYearElement) {
            changeYear(self2.currentYear - delta);
          } else if (self2.config.enableTime) {
            if (!isTimeObj && self2.hourElement)
              self2.hourElement.focus();
            updateTime(e);
            self2._debouncedChange();
          }
          break;
        case 9:
          if (isTimeObj) {
            var elems = [
              self2.hourElement,
              self2.minuteElement,
              self2.secondElement,
              self2.amPM
            ].concat(self2.pluginElements).filter(function(x) {
              return x;
            });
            var i = elems.indexOf(eventTarget);
            if (i !== -1) {
              var target = elems[i + (e.shiftKey ? -1 : 1)];
              e.preventDefault();
              (target || self2._input).focus();
            }
          } else if (!self2.config.noCalendar && self2.daysContainer && self2.daysContainer.contains(eventTarget) && e.shiftKey) {
            e.preventDefault();
            self2._input.focus();
          }
          break;
        default:
          break;
      }
    }
    if (self2.amPM !== void 0 && eventTarget === self2.amPM) {
      switch (e.key) {
        case self2.l10n.amPM[0].charAt(0):
        case self2.l10n.amPM[0].charAt(0).toLowerCase():
          self2.amPM.textContent = self2.l10n.amPM[0];
          setHoursFromInputs();
          updateValue();
          break;
        case self2.l10n.amPM[1].charAt(0):
        case self2.l10n.amPM[1].charAt(0).toLowerCase():
          self2.amPM.textContent = self2.l10n.amPM[1];
          setHoursFromInputs();
          updateValue();
          break;
      }
    }
    if (isInput || isCalendarElem(eventTarget)) {
      triggerEvent('onKeyDown', e);
    }
  }
  function onMouseOver(elem, cellClass) {
    if (cellClass === void 0) {
      cellClass = 'flatpickr-day';
    }
    if (self2.selectedDates.length !== 1 || elem && (!elem.classList.contains(cellClass) || elem.classList.contains('flatpickr-disabled')))
      return;
    var hoverDate = elem ? elem.dateObj.getTime() : self2.days.firstElementChild.dateObj.getTime(), initialDate = self2.parseDate(self2.selectedDates[0], void 0, true).getTime(), rangeStartDate = Math.min(hoverDate, self2.selectedDates[0].getTime()), rangeEndDate = Math.max(hoverDate, self2.selectedDates[0].getTime());
    var containsDisabled = false;
    var minRange = 0, maxRange = 0;
    for (var t = rangeStartDate; t < rangeEndDate; t += duration.DAY) {
      if (!isEnabled(new Date(t), true)) {
        containsDisabled = containsDisabled || t > rangeStartDate && t < rangeEndDate;
        if (t < initialDate && (!minRange || t > minRange))
          minRange = t;
        else if (t > initialDate && (!maxRange || t < maxRange))
          maxRange = t;
      }
    }
    var hoverableCells = Array.from(self2.rContainer.querySelectorAll('*:nth-child(-n+' + self2.config.showMonths + ') > .' + cellClass));
    hoverableCells.forEach(function(dayElem) {
      var date = dayElem.dateObj;
      var timestamp = date.getTime();
      var outOfRange = minRange > 0 && timestamp < minRange || maxRange > 0 && timestamp > maxRange;
      if (outOfRange) {
        dayElem.classList.add('notAllowed');
        ['inRange', 'startRange', 'endRange'].forEach(function(c) {
          dayElem.classList.remove(c);
        });
        return;
      } else if (containsDisabled && !outOfRange)
        return;
      ['startRange', 'inRange', 'endRange', 'notAllowed'].forEach(function(c) {
        dayElem.classList.remove(c);
      });
      if (elem !== void 0) {
        elem.classList.add(hoverDate <= self2.selectedDates[0].getTime() ? 'startRange' : 'endRange');
        if (initialDate < hoverDate && timestamp === initialDate)
          dayElem.classList.add('startRange');
        else if (initialDate > hoverDate && timestamp === initialDate)
          dayElem.classList.add('endRange');
        if (timestamp >= minRange && (maxRange === 0 || timestamp <= maxRange) && isBetween(timestamp, initialDate, hoverDate))
          dayElem.classList.add('inRange');
      }
    });
  }
  function onResize() {
    if (self2.isOpen && !self2.config.static && !self2.config.inline)
      positionCalendar();
  }
  function open(e, positionElement) {
    if (positionElement === void 0) {
      positionElement = self2._positionElement;
    }
    if (self2.isMobile === true) {
      if (e) {
        e.preventDefault();
        var eventTarget = getEventTarget(e);
        if (eventTarget) {
          eventTarget.blur();
        }
      }
      if (self2.mobileInput !== void 0) {
        self2.mobileInput.focus();
        self2.mobileInput.click();
      }
      triggerEvent('onOpen');
      return;
    } else if (self2._input.disabled || self2.config.inline) {
      return;
    }
    var wasOpen = self2.isOpen;
    self2.isOpen = true;
    if (!wasOpen) {
      self2.calendarContainer.classList.add('open');
      self2._input.classList.add('active');
      triggerEvent('onOpen');
      positionCalendar(positionElement);
    }
    if (self2.config.enableTime === true && self2.config.noCalendar === true) {
      if (self2.config.allowInput === false && (e === void 0 || !self2.timeContainer.contains(e.relatedTarget))) {
        setTimeout(function() {
          return self2.hourElement.select();
        }, 50);
      }
    }
  }
  function minMaxDateSetter(type) {
    return function(date) {
      var dateObj = self2.config['_' + type + 'Date'] = self2.parseDate(date, self2.config.dateFormat);
      var inverseDateObj = self2.config['_' + (type === 'min' ? 'max' : 'min') + 'Date'];
      if (dateObj !== void 0) {
        self2[type === 'min' ? 'minDateHasTime' : 'maxDateHasTime'] = dateObj.getHours() > 0 || dateObj.getMinutes() > 0 || dateObj.getSeconds() > 0;
      }
      if (self2.selectedDates) {
        self2.selectedDates = self2.selectedDates.filter(function(d) {
          return isEnabled(d);
        });
        if (!self2.selectedDates.length && type === 'min')
          setHoursFromDate(dateObj);
        updateValue();
      }
      if (self2.daysContainer) {
        redraw();
        if (dateObj !== void 0)
          self2.currentYearElement[type] = dateObj.getFullYear().toString();
        else
          self2.currentYearElement.removeAttribute(type);
        self2.currentYearElement.disabled = !!inverseDateObj && dateObj !== void 0 && inverseDateObj.getFullYear() === dateObj.getFullYear();
      }
    };
  }
  function parseConfig() {
    var boolOpts = [
      'wrap',
      'weekNumbers',
      'allowInput',
      'allowInvalidPreload',
      'clickOpens',
      'time_24hr',
      'enableTime',
      'noCalendar',
      'altInput',
      'shorthandCurrentMonth',
      'inline',
      'static',
      'enableSeconds',
      'disableMobile'
    ];
    var userConfig = __assign(__assign({}, JSON.parse(JSON.stringify(element.dataset || {}))), instanceConfig);
    var formats2 = {};
    self2.config.parseDate = userConfig.parseDate;
    self2.config.formatDate = userConfig.formatDate;
    Object.defineProperty(self2.config, 'enable', {
      get: function() {
        return self2.config._enable;
      },
      set: function(dates) {
        self2.config._enable = parseDateRules(dates);
      }
    });
    Object.defineProperty(self2.config, 'disable', {
      get: function() {
        return self2.config._disable;
      },
      set: function(dates) {
        self2.config._disable = parseDateRules(dates);
      }
    });
    var timeMode = userConfig.mode === 'time';
    if (!userConfig.dateFormat && (userConfig.enableTime || timeMode)) {
      var defaultDateFormat = flatpickr.defaultConfig.dateFormat || defaults.dateFormat;
      formats2.dateFormat = userConfig.noCalendar || timeMode ? 'H:i' + (userConfig.enableSeconds ? ':S' : '') : defaultDateFormat + ' H:i' + (userConfig.enableSeconds ? ':S' : '');
    }
    if (userConfig.altInput && (userConfig.enableTime || timeMode) && !userConfig.altFormat) {
      var defaultAltFormat = flatpickr.defaultConfig.altFormat || defaults.altFormat;
      formats2.altFormat = userConfig.noCalendar || timeMode ? 'h:i' + (userConfig.enableSeconds ? ':S K' : ' K') : defaultAltFormat + (' h:i' + (userConfig.enableSeconds ? ':S' : '') + ' K');
    }
    Object.defineProperty(self2.config, 'minDate', {
      get: function() {
        return self2.config._minDate;
      },
      set: minMaxDateSetter('min')
    });
    Object.defineProperty(self2.config, 'maxDate', {
      get: function() {
        return self2.config._maxDate;
      },
      set: minMaxDateSetter('max')
    });
    var minMaxTimeSetter = function(type) {
      return function(val) {
        self2.config[type === 'min' ? '_minTime' : '_maxTime'] = self2.parseDate(val, 'H:i:S');
      };
    };
    Object.defineProperty(self2.config, 'minTime', {
      get: function() {
        return self2.config._minTime;
      },
      set: minMaxTimeSetter('min')
    });
    Object.defineProperty(self2.config, 'maxTime', {
      get: function() {
        return self2.config._maxTime;
      },
      set: minMaxTimeSetter('max')
    });
    if (userConfig.mode === 'time') {
      self2.config.noCalendar = true;
      self2.config.enableTime = true;
    }
    Object.assign(self2.config, formats2, userConfig);
    for (var i = 0; i < boolOpts.length; i++)
      self2.config[boolOpts[i]] = self2.config[boolOpts[i]] === true || self2.config[boolOpts[i]] === 'true';
    HOOKS.filter(function(hook) {
      return self2.config[hook] !== void 0;
    }).forEach(function(hook) {
      self2.config[hook] = arrayify(self2.config[hook] || []).map(bindToInstance);
    });
    self2.isMobile = !self2.config.disableMobile && !self2.config.inline && self2.config.mode === 'single' && !self2.config.disable.length && !self2.config.enable && !self2.config.weekNumbers && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    // eslint-disable-next-line no-redeclare
    for (var i = 0; i < self2.config.plugins.length; i++) {
      var pluginConf = self2.config.plugins[i](self2) || {};
      for (var key in pluginConf) {
        if (HOOKS.indexOf(key) > -1) {
          self2.config[key] = arrayify(pluginConf[key]).map(bindToInstance).concat(self2.config[key]);
        } else if (typeof userConfig[key] === 'undefined')
          self2.config[key] = pluginConf[key];
      }
    }
    if (!userConfig.altInputClass) {
      self2.config.altInputClass = getInputElem().className + ' ' + self2.config.altInputClass;
    }
    triggerEvent('onParseConfig');
  }
  function getInputElem() {
    return self2.config.wrap ? element.querySelector('[data-input]') : element;
  }
  function setupLocale() {
    if (typeof self2.config.locale !== 'object' && typeof flatpickr.l10ns[self2.config.locale] === 'undefined')
      self2.config.errorHandler(new Error('flatpickr: invalid locale ' + self2.config.locale));
    self2.l10n = __assign(__assign({}, flatpickr.l10ns.default), typeof self2.config.locale === 'object' ? self2.config.locale : self2.config.locale !== 'default' ? flatpickr.l10ns[self2.config.locale] : void 0);
    tokenRegex.D = '(' + self2.l10n.weekdays.shorthand.join('|') + ')';
    tokenRegex.l = '(' + self2.l10n.weekdays.longhand.join('|') + ')';
    tokenRegex.M = '(' + self2.l10n.months.shorthand.join('|') + ')';
    tokenRegex.F = '(' + self2.l10n.months.longhand.join('|') + ')';
    tokenRegex.K = '(' + self2.l10n.amPM[0] + '|' + self2.l10n.amPM[1] + '|' + self2.l10n.amPM[0].toLowerCase() + '|' + self2.l10n.amPM[1].toLowerCase() + ')';
    var userConfig = __assign(__assign({}, instanceConfig), JSON.parse(JSON.stringify(element.dataset || {})));
    if (userConfig.time_24hr === void 0 && flatpickr.defaultConfig.time_24hr === void 0) {
      self2.config.time_24hr = self2.l10n.time_24hr;
    }
    self2.formatDate = createDateFormatter(self2);
    self2.parseDate = createDateParser({ config: self2.config, l10n: self2.l10n });
  }
  function positionCalendar(customPositionElement) {
    if (typeof self2.config.position === 'function') {
      return void self2.config.position(self2, customPositionElement);
    }
    if (self2.calendarContainer === void 0)
      return;
    triggerEvent('onPreCalendarPosition');
    var positionElement = customPositionElement || self2._positionElement;
    var calendarHeight = Array.prototype.reduce.call(self2.calendarContainer.children, function(acc, child2) {
      return acc + child2.offsetHeight;
    }, 0), calendarWidth = self2.calendarContainer.offsetWidth, configPos = self2.config.position.split(' '), configPosVertical = configPos[0], configPosHorizontal = configPos.length > 1 ? configPos[1] : null, inputBounds = positionElement.getBoundingClientRect(), distanceFromBottom = window.innerHeight - inputBounds.bottom, showOnTop = configPosVertical === 'above' || configPosVertical !== 'below' && distanceFromBottom < calendarHeight && inputBounds.top > calendarHeight;
    var top = window.pageYOffset + inputBounds.top + (!showOnTop ? positionElement.offsetHeight + 2 : -calendarHeight - 2);
    toggleClass2(self2.calendarContainer, 'arrowTop', !showOnTop);
    toggleClass2(self2.calendarContainer, 'arrowBottom', showOnTop);
    if (self2.config.inline)
      return;
    var left = window.pageXOffset + inputBounds.left;
    var isCenter = false;
    var isRight = false;
    if (configPosHorizontal === 'center') {
      left -= (calendarWidth - inputBounds.width) / 2;
      isCenter = true;
    } else if (configPosHorizontal === 'right') {
      left -= calendarWidth - inputBounds.width;
      isRight = true;
    }
    toggleClass2(self2.calendarContainer, 'arrowLeft', !isCenter && !isRight);
    toggleClass2(self2.calendarContainer, 'arrowCenter', isCenter);
    toggleClass2(self2.calendarContainer, 'arrowRight', isRight);
    var right = window.document.body.offsetWidth - (window.pageXOffset + inputBounds.right);
    var rightMost = left + calendarWidth > window.document.body.offsetWidth;
    var centerMost = right + calendarWidth > window.document.body.offsetWidth;
    toggleClass2(self2.calendarContainer, 'rightMost', rightMost);
    if (self2.config.static)
      return;
    self2.calendarContainer.style.top = top + 'px';
    if (!rightMost) {
      self2.calendarContainer.style.left = left + 'px';
      self2.calendarContainer.style.right = 'auto';
    } else if (!centerMost) {
      self2.calendarContainer.style.left = 'auto';
      self2.calendarContainer.style.right = right + 'px';
    } else {
      var doc = getDocumentStyleSheet();
      if (doc === void 0)
        return;
      var bodyWidth = window.document.body.offsetWidth;
      var centerLeft = Math.max(0, bodyWidth / 2 - calendarWidth / 2);
      var centerBefore = '.flatpickr-calendar.centerMost:before';
      var centerAfter = '.flatpickr-calendar.centerMost:after';
      var centerIndex = doc.cssRules.length;
      var centerStyle = '{left:' + inputBounds.left + 'px;right:auto;}';
      toggleClass2(self2.calendarContainer, 'rightMost', false);
      toggleClass2(self2.calendarContainer, 'centerMost', true);
      doc.insertRule(centerBefore + ',' + centerAfter + centerStyle, centerIndex);
      self2.calendarContainer.style.left = centerLeft + 'px';
      self2.calendarContainer.style.right = 'auto';
    }
  }
  function getDocumentStyleSheet() {
    var editableSheet = null;
    for (var i = 0; i < document.styleSheets.length; i++) {
      var sheet = document.styleSheets[i];
      if (!sheet.cssRules)
        continue;
      try {
        sheet.cssRules;
      } catch (err) {
        continue;
      }
      editableSheet = sheet;
      break;
    }
    return editableSheet != null ? editableSheet : createStyleSheet();
  }
  function createStyleSheet() {
    var style2 = document.createElement('style');
    document.head.appendChild(style2);
    return style2.sheet;
  }
  function redraw() {
    if (self2.config.noCalendar || self2.isMobile)
      return;
    buildMonthSwitch();
    updateNavigationCurrentMonth();
    buildDays();
  }
  function focusAndClose() {
    self2._input.focus();
    if (window.navigator.userAgent.indexOf('MSIE') !== -1 || navigator.msMaxTouchPoints !== void 0) {
      setTimeout(self2.close, 0);
    } else {
      self2.close();
    }
  }
  function selectDate(e) {
    e.preventDefault();
    e.stopPropagation();
    var isSelectable = function(day) {
      return day.classList && day.classList.contains('flatpickr-day') && !day.classList.contains('flatpickr-disabled') && !day.classList.contains('notAllowed');
    };
    var t = findParent(getEventTarget(e), isSelectable);
    if (t === void 0)
      return;
    var target = t;
    var selectedDate = self2.latestSelectedDateObj = new Date(target.dateObj.getTime());
    var shouldChangeMonth = (selectedDate.getMonth() < self2.currentMonth || selectedDate.getMonth() > self2.currentMonth + self2.config.showMonths - 1) && self2.config.mode !== 'range';
    self2.selectedDateElem = target;
    if (self2.config.mode === 'single')
      self2.selectedDates = [selectedDate];
    else if (self2.config.mode === 'multiple') {
      var selectedIndex = isDateSelected(selectedDate);
      if (selectedIndex)
        self2.selectedDates.splice(parseInt(selectedIndex), 1);
      else
        self2.selectedDates.push(selectedDate);
    } else if (self2.config.mode === 'range') {
      if (self2.selectedDates.length === 2) {
        self2.clear(false, false);
      }
      self2.latestSelectedDateObj = selectedDate;
      self2.selectedDates.push(selectedDate);
      if (compareDates(selectedDate, self2.selectedDates[0], true) !== 0)
        self2.selectedDates.sort(function(a, b) {
          return a.getTime() - b.getTime();
        });
    }
    setHoursFromInputs();
    if (shouldChangeMonth) {
      var isNewYear = self2.currentYear !== selectedDate.getFullYear();
      self2.currentYear = selectedDate.getFullYear();
      self2.currentMonth = selectedDate.getMonth();
      if (isNewYear) {
        triggerEvent('onYearChange');
        buildMonthSwitch();
      }
      triggerEvent('onMonthChange');
    }
    updateNavigationCurrentMonth();
    buildDays();
    updateValue();
    if (!shouldChangeMonth && self2.config.mode !== 'range' && self2.config.showMonths === 1)
      focusOnDayElem(target);
    else if (self2.selectedDateElem !== void 0 && self2.hourElement === void 0) {
      self2.selectedDateElem && self2.selectedDateElem.focus();
    }
    if (self2.hourElement !== void 0)
      self2.hourElement !== void 0 && self2.hourElement.focus();
    if (self2.config.closeOnSelect) {
      var single = self2.config.mode === 'single' && !self2.config.enableTime;
      var range = self2.config.mode === 'range' && self2.selectedDates.length === 2 && !self2.config.enableTime;
      if (single || range) {
        focusAndClose();
      }
    }
    triggerChange();
  }
  var CALLBACKS = {
    locale: [setupLocale, updateWeekdays],
    showMonths: [buildMonths, setCalendarWidth, buildWeekdays],
    minDate: [jumpToDate],
    maxDate: [jumpToDate],
    positionElement: [updatePositionElement],
    clickOpens: [
      function() {
        if (self2.config.clickOpens === true) {
          bind(self2._input, 'focus', self2.open);
          bind(self2._input, 'click', self2.open);
        } else {
          self2._input.removeEventListener('focus', self2.open);
          self2._input.removeEventListener('click', self2.open);
        }
      }
    ]
  };
  function set(option, value) {
    if (option !== null && typeof option === 'object') {
      Object.assign(self2.config, option);
      for (var key in option) {
        if (CALLBACKS[key] !== void 0)
          CALLBACKS[key].forEach(function(x) {
            return x();
          });
      }
    } else {
      self2.config[option] = value;
      if (CALLBACKS[option] !== void 0)
        CALLBACKS[option].forEach(function(x) {
          return x();
        });
      else if (HOOKS.indexOf(option) > -1)
        self2.config[option] = arrayify(value);
    }
    self2.redraw();
    updateValue(true);
  }
  function setSelectedDate(inputDate, format2) {
    var dates = [];
    if (inputDate instanceof Array)
      dates = inputDate.map(function(d) {
        return self2.parseDate(d, format2);
      });
    else if (inputDate instanceof Date || typeof inputDate === 'number')
      dates = [self2.parseDate(inputDate, format2)];
    else if (typeof inputDate === 'string') {
      switch (self2.config.mode) {
        case 'single':
        case 'time':
          dates = [self2.parseDate(inputDate, format2)];
          break;
        case 'multiple':
          dates = inputDate.split(self2.config.conjunction).map(function(date) {
            return self2.parseDate(date, format2);
          });
          break;
        case 'range':
          dates = inputDate.split(self2.l10n.rangeSeparator).map(function(date) {
            return self2.parseDate(date, format2);
          });
          break;
        default:
          break;
      }
    } else
      self2.config.errorHandler(new Error('Invalid date supplied: ' + JSON.stringify(inputDate)));
    self2.selectedDates = self2.config.allowInvalidPreload ? dates : dates.filter(function(d) {
      return d instanceof Date && isEnabled(d, false);
    });
    if (self2.config.mode === 'range')
      self2.selectedDates.sort(function(a, b) {
        return a.getTime() - b.getTime();
      });
  }
  function setDate(date, triggerChange2, format2) {
    if (triggerChange2 === void 0) {
      triggerChange2 = false;
    }
    if (format2 === void 0) {
      format2 = self2.config.dateFormat;
    }
    if (date !== 0 && !date || date instanceof Array && date.length === 0)
      return self2.clear(triggerChange2);
    setSelectedDate(date, format2);
    self2.latestSelectedDateObj = self2.selectedDates[self2.selectedDates.length - 1];
    self2.redraw();
    jumpToDate(void 0, triggerChange2);
    setHoursFromDate();
    if (self2.selectedDates.length === 0) {
      self2.clear(false);
    }
    updateValue(triggerChange2);
    if (triggerChange2)
      triggerEvent('onChange');
  }
  function parseDateRules(arr) {
    return arr.slice().map(function(rule) {
      if (typeof rule === 'string' || typeof rule === 'number' || rule instanceof Date) {
        return self2.parseDate(rule, void 0, true);
      } else if (rule && typeof rule === 'object' && rule.from && rule.to)
        return {
          from: self2.parseDate(rule.from, void 0),
          to: self2.parseDate(rule.to, void 0)
        };
      return rule;
    }).filter(function(x) {
      return x;
    });
  }
  function setupDates() {
    self2.selectedDates = [];
    self2.now = self2.parseDate(self2.config.now) || /* @__PURE__ */ new Date();
    var preloadedDate = self2.config.defaultDate || ((self2.input.nodeName === 'INPUT' || self2.input.nodeName === 'TEXTAREA') && self2.input.placeholder && self2.input.value === self2.input.placeholder ? null : self2.input.value);
    if (preloadedDate)
      setSelectedDate(preloadedDate, self2.config.dateFormat);
    self2._initialDate = self2.selectedDates.length > 0 ? self2.selectedDates[0] : self2.config.minDate && self2.config.minDate.getTime() > self2.now.getTime() ? self2.config.minDate : self2.config.maxDate && self2.config.maxDate.getTime() < self2.now.getTime() ? self2.config.maxDate : self2.now;
    self2.currentYear = self2._initialDate.getFullYear();
    self2.currentMonth = self2._initialDate.getMonth();
    if (self2.selectedDates.length > 0)
      self2.latestSelectedDateObj = self2.selectedDates[0];
    if (self2.config.minTime !== void 0)
      self2.config.minTime = self2.parseDate(self2.config.minTime, 'H:i');
    if (self2.config.maxTime !== void 0)
      self2.config.maxTime = self2.parseDate(self2.config.maxTime, 'H:i');
    self2.minDateHasTime = !!self2.config.minDate && (self2.config.minDate.getHours() > 0 || self2.config.minDate.getMinutes() > 0 || self2.config.minDate.getSeconds() > 0);
    self2.maxDateHasTime = !!self2.config.maxDate && (self2.config.maxDate.getHours() > 0 || self2.config.maxDate.getMinutes() > 0 || self2.config.maxDate.getSeconds() > 0);
  }
  function setupInputs() {
    self2.input = getInputElem();
    if (!self2.input) {
      self2.config.errorHandler(new Error('Invalid input element specified'));
      return;
    }
    self2.input._type = self2.input.type;
    self2.input.type = 'text';
    self2.input.classList.add('flatpickr-input');
    self2._input = self2.input;
    if (self2.config.altInput) {
      self2.altInput = createElement(self2.input.nodeName, self2.config.altInputClass);
      self2._input = self2.altInput;
      self2.altInput.placeholder = self2.input.placeholder;
      self2.altInput.disabled = self2.input.disabled;
      self2.altInput.required = self2.input.required;
      self2.altInput.tabIndex = self2.input.tabIndex;
      self2.altInput.type = 'text';
      self2.input.setAttribute('type', 'hidden');
      if (!self2.config.static && self2.input.parentNode)
        self2.input.parentNode.insertBefore(self2.altInput, self2.input.nextSibling);
    }
    if (!self2.config.allowInput)
      self2._input.setAttribute('readonly', 'readonly');
    updatePositionElement();
  }
  function updatePositionElement() {
    self2._positionElement = self2.config.positionElement || self2._input;
  }
  function setupMobile() {
    var inputType = self2.config.enableTime ? self2.config.noCalendar ? 'time' : 'datetime-local' : 'date';
    self2.mobileInput = createElement('input', self2.input.className + ' flatpickr-mobile');
    self2.mobileInput.tabIndex = 1;
    self2.mobileInput.type = inputType;
    self2.mobileInput.disabled = self2.input.disabled;
    self2.mobileInput.required = self2.input.required;
    self2.mobileInput.placeholder = self2.input.placeholder;
    self2.mobileFormatStr = inputType === 'datetime-local' ? 'Y-m-d\\TH:i:S' : inputType === 'date' ? 'Y-m-d' : 'H:i:S';
    if (self2.selectedDates.length > 0) {
      self2.mobileInput.defaultValue = self2.mobileInput.value = self2.formatDate(self2.selectedDates[0], self2.mobileFormatStr);
    }
    if (self2.config.minDate)
      self2.mobileInput.min = self2.formatDate(self2.config.minDate, 'Y-m-d');
    if (self2.config.maxDate)
      self2.mobileInput.max = self2.formatDate(self2.config.maxDate, 'Y-m-d');
    if (self2.input.getAttribute('step'))
      self2.mobileInput.step = String(self2.input.getAttribute('step'));
    self2.input.type = 'hidden';
    if (self2.altInput !== void 0)
      self2.altInput.type = 'hidden';
    try {
      if (self2.input.parentNode)
        self2.input.parentNode.insertBefore(self2.mobileInput, self2.input.nextSibling);
    } catch (_a) {
      // eslint-disable-next-line no-empty
    }
    bind(self2.mobileInput, 'change', function(e) {
      self2.setDate(getEventTarget(e).value, false, self2.mobileFormatStr);
      triggerEvent('onChange');
      triggerEvent('onClose');
    });
  }
  function toggle(e) {
    if (self2.isOpen === true)
      return self2.close();
    self2.open(e);
  }
  function triggerEvent(event, data) {
    if (self2.config === void 0)
      return;
    var hooks = self2.config[event];
    if (hooks !== void 0 && hooks.length > 0) {
      for (var i = 0; hooks[i] && i < hooks.length; i++)
        hooks[i](self2.selectedDates, self2.input.value, self2, data);
    }
    if (event === 'onChange') {
      self2.input.dispatchEvent(createEvent('change'));
      self2.input.dispatchEvent(createEvent('input'));
    }
  }
  function createEvent(name) {
    var e = document.createEvent('Event');
    e.initEvent(name, true, true);
    return e;
  }
  function isDateSelected(date) {
    for (var i = 0; i < self2.selectedDates.length; i++) {
      var selectedDate = self2.selectedDates[i];
      if (selectedDate instanceof Date && compareDates(selectedDate, date) === 0)
        return '' + i;
    }
    return false;
  }
  function isDateInRange(date) {
    if (self2.config.mode !== 'range' || self2.selectedDates.length < 2)
      return false;
    return compareDates(date, self2.selectedDates[0]) >= 0 && compareDates(date, self2.selectedDates[1]) <= 0;
  }
  function updateNavigationCurrentMonth() {
    if (self2.config.noCalendar || self2.isMobile || !self2.monthNav)
      return;
    self2.yearElements.forEach(function(yearElement, i) {
      var d = new Date(self2.currentYear, self2.currentMonth, 1);
      d.setMonth(self2.currentMonth + i);
      if (self2.config.showMonths > 1 || self2.config.monthSelectorType === 'static') {
        self2.monthElements[i].textContent = monthToStr(d.getMonth(), self2.config.shorthandCurrentMonth, self2.l10n) + ' ';
      } else {
        self2.monthsDropdownContainer.value = d.getMonth().toString();
      }
      yearElement.value = d.getFullYear().toString();
    });
    self2._hidePrevMonthArrow = self2.config.minDate !== void 0 && (self2.currentYear === self2.config.minDate.getFullYear() ? self2.currentMonth <= self2.config.minDate.getMonth() : self2.currentYear < self2.config.minDate.getFullYear());
    self2._hideNextMonthArrow = self2.config.maxDate !== void 0 && (self2.currentYear === self2.config.maxDate.getFullYear() ? self2.currentMonth + 1 > self2.config.maxDate.getMonth() : self2.currentYear > self2.config.maxDate.getFullYear());
  }
  function getDateStr(specificFormat) {
    var format2 = specificFormat || (self2.config.altInput ? self2.config.altFormat : self2.config.dateFormat);
    return self2.selectedDates.map(function(dObj) {
      return self2.formatDate(dObj, format2);
    }).filter(function(d, i, arr) {
      return self2.config.mode !== 'range' || self2.config.enableTime || arr.indexOf(d) === i;
    }).join(self2.config.mode !== 'range' ? self2.config.conjunction : self2.l10n.rangeSeparator);
  }
  function updateValue(triggerChange2) {
    if (triggerChange2 === void 0) {
      triggerChange2 = true;
    }
    if (self2.mobileInput !== void 0 && self2.mobileFormatStr) {
      self2.mobileInput.value = self2.latestSelectedDateObj !== void 0 ? self2.formatDate(self2.latestSelectedDateObj, self2.mobileFormatStr) : '';
    }
    self2.input.value = getDateStr(self2.config.dateFormat);
    if (self2.altInput !== void 0) {
      self2.altInput.value = getDateStr(self2.config.altFormat);
    }
    if (triggerChange2 !== false)
      triggerEvent('onValueUpdate');
  }
  function onMonthNavClick(e) {
    var eventTarget = getEventTarget(e);
    var isPrevMonth = self2.prevMonthNav.contains(eventTarget);
    var isNextMonth = self2.nextMonthNav.contains(eventTarget);
    if (isPrevMonth || isNextMonth) {
      changeMonth(isPrevMonth ? -1 : 1);
    } else if (self2.yearElements.indexOf(eventTarget) >= 0) {
      eventTarget.select();
    } else if (eventTarget.classList.contains('arrowUp')) {
      self2.changeYear(self2.currentYear + 1);
    } else if (eventTarget.classList.contains('arrowDown')) {
      self2.changeYear(self2.currentYear - 1);
    }
  }
  function timeWrapper(e) {
    e.preventDefault();
    var isKeyDown = e.type === 'keydown', eventTarget = getEventTarget(e), input = eventTarget;
    if (self2.amPM !== void 0 && eventTarget === self2.amPM) {
      self2.amPM.textContent = self2.l10n.amPM[int(self2.amPM.textContent === self2.l10n.amPM[0])];
    }
    var min2 = parseFloat(input.getAttribute('min')), max2 = parseFloat(input.getAttribute('max')), step = parseFloat(input.getAttribute('step')), curValue = parseInt(input.value, 10), delta = e.delta || (isKeyDown ? e.which === 38 ? 1 : -1 : 0);
    var newValue = curValue + step * delta;
    if (typeof input.value !== 'undefined' && input.value.length === 2) {
      var isHourElem = input === self2.hourElement, isMinuteElem = input === self2.minuteElement;
      if (newValue < min2) {
        newValue = max2 + newValue + int(!isHourElem) + (int(isHourElem) && int(!self2.amPM));
        if (isMinuteElem)
          incrementNumInput(void 0, -1, self2.hourElement);
      } else if (newValue > max2) {
        newValue = input === self2.hourElement ? newValue - max2 - int(!self2.amPM) : min2;
        if (isMinuteElem)
          incrementNumInput(void 0, 1, self2.hourElement);
      }
      if (self2.amPM && isHourElem && (step === 1 ? newValue + curValue === 23 : Math.abs(newValue - curValue) > step)) {
        self2.amPM.textContent = self2.l10n.amPM[int(self2.amPM.textContent === self2.l10n.amPM[0])];
      }
      input.value = pad2(newValue);
    }
  }
  init();
  return self2;
}
function _flatpickr(nodeList, config) {
  var nodes = Array.prototype.slice.call(nodeList).filter(function(x) {
    return x instanceof HTMLElement;
  });
  var instances = [];
  for (var i = 0; i < nodes.length; i++) {
    var node = nodes[i];
    try {
      if (node.getAttribute('data-fp-omit') !== null)
        continue;
      if (node._flatpickr !== void 0) {
        node._flatpickr.destroy();
        node._flatpickr = void 0;
      }
      node._flatpickr = FlatpickrInstance(node, config || {});
      instances.push(node._flatpickr);
    } catch (e) {
      console.error(e);
    }
  }
  return instances.length === 1 ? instances[0] : instances;
}
if (typeof HTMLElement !== 'undefined' && typeof HTMLCollection !== 'undefined' && typeof NodeList !== 'undefined') {
  HTMLCollection.prototype.flatpickr = NodeList.prototype.flatpickr = function(config) {
    return _flatpickr(this, config);
  };
  HTMLElement.prototype.flatpickr = function(config) {
    return _flatpickr([this], config);
  };
}
var flatpickr = function(selector, config) {
  if (typeof selector === 'string') {
    return _flatpickr(window.document.querySelectorAll(selector), config);
  } else if (selector instanceof Node) {
    return _flatpickr([selector], config);
  } else {
    return _flatpickr(selector, config);
  }
};
flatpickr.defaultConfig = {};
flatpickr.l10ns = {
  en: __assign({}, default_default),
  default: __assign({}, default_default)
};
flatpickr.localize = function(l10n) {
  flatpickr.l10ns.default = __assign(__assign({}, flatpickr.l10ns.default), l10n);
};
flatpickr.setDefaults = function(config) {
  flatpickr.defaultConfig = __assign(__assign({}, flatpickr.defaultConfig), config);
};
flatpickr.parseDate = createDateParser({});
flatpickr.formatDate = createDateFormatter({});
flatpickr.compareDates = compareDates;
/* eslint-disable no-undef */
if (typeof jQuery !== 'undefined' && typeof jQuery.fn !== 'undefined') {
  jQuery.fn.flatpickr = function(config) {
    return _flatpickr(this, config);
  };
}
/* eslint-enable no-undef */
Date.prototype.fp_incr = function(days) {
  return new Date(this.getFullYear(), this.getMonth(), this.getDate() + (typeof days === 'string' ? parseInt(days, 10) : days));
};
if (typeof window !== 'undefined') {
  window.flatpickr = flatpickr;
}
var esm_default = flatpickr;

// src/js/_module/_flatpickrCalendar.ts
var import_ja = __toESM(require_ja());
function flatpickrCalendar(wrapperEl, inputEl, mode) {
  const targetEl = wrapperEl.querySelectorAll(
    '.js-calendar'
  );
  if (!targetEl?.length) return;
  for (const element of Array.from(targetEl)) {
    const id = element.getAttribute('id');
    const inputDate = document.getElementById(
      `${id}-Date`
    );
    const inputDateStart = document.getElementById(
      `${id}-DateStart`
    );
    const inputDateEnd = document.getElementById(
      `${id}-DateEnd`
    );
    const selectYearMonth = document.getElementById(
      `${id}-YearMonth`
    );
    const monthCountBefore = 0;
    const monthCountAfter = 1;
    const monthCount = monthCountBefore + 1 + monthCountAfter;
    const now = /* @__PURE__ */ new Date();
    const monthStart = new Date(
      now.getFullYear(),
      now.getMonth() - monthCountBefore,
      1
    );
    const monthEnd = new Date(
      monthStart.getFullYear(),
      monthStart.getMonth() + monthCount,
      0
    );
    const generateOptions = (element2) => {
      for (let i = 0; i < monthCount; i++) {
        const date = new Date(
          monthStart.getFullYear(),
          monthStart.getMonth() + i,
          1
        );
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const option = document.createElement('option');
        option.value = `${year}-${month}`;
        option.textContent = `${year}\u5E74${month}\u6708`;
        if (date.getFullYear() === now.getFullYear() && date.getMonth() === now.getMonth()) {
          option.selected = true;
        }
        element2.appendChild(option);
      }
    };
    if (selectYearMonth) generateOptions(selectYearMonth);
    const selectCustom = document.getElementById(
      `${id}-Custom`
    );
    let isCustomChange = false;
    const buttonClear = document.getElementById(
      `${id}-Clear`
    );
    const buttonSubmit = document.getElementById(
      `${id}-Submit`
    );
    const calendarEl = document.getElementById(
      `${id}-Calendar`
    );
    if (calendarEl) {
      const calendar = esm_default(calendarEl, {
        inline: true,
        // デフォルトで表示
        locale: import_ja.Japanese,
        // 日本語化
        mode,
        // "single" | "multiple" | "range" | "time",
        minDate: monthStart,
        maxDate: monthEnd,
        onChange: (selectedDates) => {
          if (mode === 'single' && inputDate && selectedDates.length) {
            inputDate.value = `${formatDate(selectedDates[0])}`;
          }
          if (mode === 'range' && inputDateStart && inputDateEnd && selectedDates.length === 2) {
            inputDateStart.value = `${formatDate(selectedDates[0])}`;
            inputDateEnd.value = `${formatDate(selectedDates[1])}`;
          }
          if (selectYearMonth && selectedDates.length) {
            const selectedDate = selectedDates[0];
            const year = selectedDate.getFullYear();
            const month = String(selectedDate.getMonth() + 1).padStart(2, '0');
            const value = `${year}-${month}`;
            for (let i = 0; i < selectYearMonth.options.length; i++) {
              if (selectYearMonth.options[i].value === value) {
                selectYearMonth.selectedIndex = i;
                break;
              }
            }
          }
          if (selectCustom) {
            if (isCustomChange) {
              isCustomChange = false;
            } else {
              selectCustom.selectedIndex = 0;
            }
          }
        }
      });
      selectYearMonth?.addEventListener('change', () => {
        const [year, month] = selectYearMonth.value.split('-').map(Number);
        const date = new Date(year, month - 1, 1);
        calendar.jumpToDate(date);
      });
      selectCustom?.addEventListener(
        'change',
        function() {
          const selectedOption = this.options[this.selectedIndex];
          const type = selectedOption.dataset.custom;
          let end = /* @__PURE__ */ new Date();
          let start = new Date(end);
          if (type === '7days') {
            start.setDate(end.getDate() - 6);
          } else if (type === '1month') {
            start.setMonth(end.getMonth() - 1);
            start.setDate(start.getDate() + 1);
          }
          if (start < monthStart) {
            start = new Date(monthStart);
          }
          if (end > monthEnd) {
            end = new Date(monthEnd);
          }
          isCustomChange = true;
          calendar.setDate(type === 'today' ? [end, end] : [start, end], true);
          calendar.jumpToDate(start);
        }
      );
      buttonClear?.addEventListener('click', () => {
        if (inputDateStart && inputDateEnd) {
          inputDateStart.value = '';
          inputDateEnd.value = '';
        }
        calendar.clear();
        if (selectYearMonth) {
          selectYearMonth.selectedIndex = monthCountBefore;
        }
      });
      buttonSubmit?.addEventListener('click', () => {
        let val = '';
        if (mode === 'single') {
          val = inputDate?.value ? inputDate?.value : '';
        } else if (mode === 'range') {
          val = inputDateStart?.value && inputDateEnd?.value ? `${inputDateStart?.value} - ${inputDateEnd?.value}` : '';
        }
        inputEl.value = val;
      });
    }
    const formatDate = (date) => {
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, '0');
      const d = String(date.getDate()).padStart(2, '0');
      return `${y}.${m}.${d}`;
    };
  }
}

// src/js/_module/_schedulesetting.ts
function schedulesetting() {
  const el_schedule = document.querySelectorAll(
    '.js-schedulesetting'
  );
  if (!el_schedule?.length || el_schedule.length < 2) return;
  const original = el_schedule[1];
  const clone = original.cloneNode(true);
  let counter = el_schedule?.length;
  const maxCount = 3;
  const kanjiNumbers = [
    '',
    '\u4E00',
    '\u4E8C',
    '\u4E09',
    '\u56DB',
    '\u4E94',
    '\u516D',
    '\u4E03',
    '\u516B',
    '\u4E5D',
    '\u5341'
  ];
  const button_add = document.getElementById(
    'js-schedulesetting-add'
  );
  button_add?.addEventListener('click', () => {
    const container = document.getElementById(
      'js-schedulesetting-container'
    );
    if (!container) return;
    if (counter < maxCount) {
      const el_clone = clone.cloneNode(true);
      updateNumbers(el_clone, counter + 1);
      replaceKanjiNumber(el_clone, counter + 1);
      init_schedule(el_clone);
      container.appendChild(el_clone);
      counter++;
      if (counter >= maxCount) {
        button_add.disabled = true;
        button_add.setAttribute('aria-disabled', 'true');
      }
    }
  });
  const updateNumbers = (element, count) => {
    for (const attr of ['id', 'aria-controls']) {
      if (element.hasAttribute?.(attr)) {
        const original2 = element.getAttribute(attr);
        if (original2) {
          const updated = original2.replace(/-\d+(?=-|$)/, `-${count}`);
          element.setAttribute(attr, updated);
        }
      }
    }
    for (const child2 of Array.from(element.children)) {
      updateNumbers(child2, count);
    }
  };
  const replaceKanjiNumber = (element, count) => {
    const regex = /第(.+?)希望/g;
    if (element.nodeType === Node.TEXT_NODE) {
      if (element.textContent) {
        element.textContent = element.textContent.replace(
          regex,
          `\u7B2C${kanjiNumbers[count]}\u5E0C\u671B`
        );
      }
    } else {
      for (const child2 of Array.from(element.childNodes)) {
        replaceKanjiNumber(child2, count);
      }
    }
  };
  const modal2 = (button, content) => {
    const is_expanded = button.getAttribute('aria-expanded') === 'true';
    button.setAttribute('aria-expanded', String(!is_expanded));
    content.setAttribute('aria-hidden', String(is_expanded));
    if (!is_expanded) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
      button.focus();
    }
  };
  const init_modal = (button, content, input) => {
    button.addEventListener(
      'click',
      () => {
        flatpickrCalendar(content, input, 'single');
      },
      { once: true }
    );
    button.addEventListener('click', () => {
      modal2(button, content);
    });
    content.addEventListener('click', () => {
      modal2(button, content);
    });
    const contentBody = content.querySelector(':scope > *');
    contentBody?.addEventListener('click', (event) => {
      event.stopPropagation();
    });
    const closeButtons = content.querySelectorAll(
      '.js-schedulesetting-close, .js-calendar-close'
    );
    if (!closeButtons?.length) return;
    for (const element of Array.from(closeButtons)) {
      element.addEventListener('click', () => {
        modal2(button, content);
      });
    }
  };
  const init_schedule = (el_schedule2) => {
    const content = el_schedule2.querySelector(
      '[id^="modal-"]'
    );
    if (!content) return;
    const button = el_schedule2.querySelector(
      '[aria-controls^="modal-"]'
    );
    if (!button) return;
    const input = button.previousElementSibling;
    if (!input) return;
    const button_clear = el_schedule2.querySelector(
      '.js-schedulesetting-clear'
    );
    button_clear?.addEventListener('click', () => {
      input.value = '';
      const select = el_schedule2.querySelectorAll(
        'select'
      );
      if (!select?.length) return;
      for (const element of Array.from(select)) {
        element.selectedIndex = 0;
      }
    });
    init_modal(button, content, input);
  };
  for (const element of Array.from(el_schedule)) {
    init_schedule(element);
  }
}

// src/js/_module/_display-calendar.ts
function displayCalendar() {
  const content = document.getElementById('displayCalendarContent');
  if (!content) return;
  const input = document.querySelector('.js-calendar-input');
  if (!input) return;
  const button = document.querySelector('.js-calendar-button');
  const performCloseActions = () => {
    if (button) {
      button.setAttribute('aria-expanded', 'false');
    }
    content.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  };
  if (button) {
    button.addEventListener(
      'click',
      () => {
        flatpickrCalendar(content, input, 'range');
      },
      { once: true }
    );
    button.addEventListener('click', () => {
      const isCurrentlyExpanded = button.getAttribute('aria-expanded') === 'true';
      if (isCurrentlyExpanded) {
        button.setAttribute('aria-expanded', 'false');
        content.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      } else {
        button.setAttribute('aria-expanded', 'true');
        content.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      }
    });
  }
  const closeTriggers = document.querySelectorAll('.js-calendar-close');
  closeTriggers.forEach((trigger) => {
    trigger.addEventListener('click', () => {
      performCloseActions();
    });
  });
}

// src/js/_module/_tab.ts
function initializeTabs() {
  document.addEventListener('click', (event) => {
    const clickedButton = event.target.closest('.js-tab-btn');
    if (!clickedButton) return;
    const container = clickedButton.closest('.js-tab-container');
    if (!container) return;
    const tabId = clickedButton.dataset.tab;
    if (!tabId) {
      console.error('Clicked tab button does not have a data-tab attribute:', clickedButton);
      return;
    }
    const tabButtons = container.querySelectorAll('.js-tab-btn');
    const tabTargets = container.querySelectorAll('.js-tab-target');
    tabButtons.forEach((btn) => btn.classList.remove('__current'));
    clickedButton.classList.add('__current');
    tabTargets.forEach((target) => target.classList.remove('__current'));
    const targetElement = container.querySelector(`#${tabId}`);
    if (targetElement) {
      targetElement.classList.add('__current');
    } else {
      console.error(`Target element with ID #${tabId} not found within container:`, container);
    }
  });
  document.querySelectorAll('.js-tab-container').forEach((container) => {
    const hasActiveTab = container.querySelector('.js-tab-btn.__current');
    if (!hasActiveTab) {
      const firstTab = container.querySelector('.js-tab-btn');
      if (firstTab) firstTab.click();
    }
  });
  const urlParams = new URLSearchParams(window.location.search);
  const tabParam = urlParams.get('tab');
  if (tabParam) {
    const targetTab = document.querySelector(`.js-tab-btn[data-tab="${tabParam}"]`);
    if (targetTab) {
      targetTab.click();
    } else {
      console.warn(`Tab with data-tab="${tabParam}" not found.`);
      const firstTab = document.querySelector('.js-tab-btn');
      if (firstTab) firstTab.click();
    }
  }
}

// src/js/_module/_add_remove_entry.ts
function addRemoveEntry() {
  document.querySelectorAll('.js-form-block').forEach((area, areaIndex) => {
    const entryList = area.querySelector('.js-entry-list');
    if (!entryList) return;
    const addButton = area.querySelector('.js-add-entry') || null;
    const allCheckbox = area.querySelector('.js-all') || null;
    const maxEntries = parseInt(entryList.dataset.entries || '3', 10);
    let entryCounter = 0;
    const firstEntry = entryList.children[0];
    if (!firstEntry) return;
    const pristineTemplate = firstEntry.cloneNode(true);
    const updateDeleteButtons = () => {
      const entries = Array.from(entryList.children).filter(
        (child2) => child2.tagName === 'LI'
      );
      const canDelete = entries.length > 1;
      entries.forEach((li) => {
        const deleteButton = li.querySelector('.js-delete-entry');
        if (deleteButton) {
          deleteButton.disabled = !canDelete;
        }
      });
      if (addButton) {
        addButton.disabled = entries.length >= maxEntries || (allCheckbox?.checked ?? false);
      }
    };
    const bindDeleteButton = (li) => {
      const deleteButton = li.querySelector('.js-delete-entry');
      if (deleteButton) {
        deleteButton.disabled = false;
        deleteButton.addEventListener('click', () => {
          li.remove();
          updateDeleteButtons();
        });
      }
    };
    const createEntry = () => {
      const newEntry = pristineTemplate.cloneNode(true);
      entryCounter += 1;
      const timestamp = Date.now();
      const uniqueBase = `${areaIndex}-${timestamp}`;
      const elements = newEntry.querySelectorAll('[id], [name], label[for], [data-modal-target], [data-tab]');
      elements.forEach((el) => {
        if (el.hasAttribute('id')) {
          const oldId = el.getAttribute('id');
          if (oldId) {
            const newId = `${oldId}-${uniqueBase}`;
            el.setAttribute('id', newId);
            const label = newEntry.querySelector(`label[for="${oldId}"]`);
            if (label) {
              label.setAttribute('for', newId);
            }
          }
        }
        if (el.hasAttribute('name')) {
          const oldName = el.getAttribute('name');
          if (oldName) {
            el.setAttribute('name', `${oldName}-${uniqueBase}`);
          }
        }
        if (el.hasAttribute('data-tab')) {
          const oldTab = el.getAttribute('data-tab');
          if (oldTab) {
            el.setAttribute('data-tab', `${oldTab}-${uniqueBase}`);
          }
        }
        if (el.hasAttribute('data-modal-target')) {
          const oldTarget = el.getAttribute('data-modal-target');
          if (!el.hasAttribute('data-unique-id')) {
            if (oldTarget) {
              el.setAttribute('data-modal-target', `${oldTarget}-${uniqueBase}`);
            }
          }
        }
      });
      newEntry.querySelectorAll('input, select, textarea').forEach((el) => {
        if (el instanceof HTMLInputElement) {
          if (el.type === 'checkbox' || el.type === 'radio') {
            el.checked = el.defaultChecked;
          } else {
            el.value = el.defaultValue;
          }
        } else if (el instanceof HTMLSelectElement) {
          el.selectedIndex = 0;
        } else if (el instanceof HTMLTextAreaElement) {
          el.value = '';
        }
      });
      bindDeleteButton(newEntry);
      return newEntry;
    };
    bindDeleteButton(firstEntry);
    if (addButton) {
      addButton.addEventListener('click', () => {
        const newEntry = createEntry();
        entryList.appendChild(newEntry);
        updateDeleteButtons();
      });
    }
    if (allCheckbox) {
      allCheckbox.addEventListener('change', () => {
        const isChecked = allCheckbox.checked;
        if (addButton) {
          addButton.disabled = isChecked || Array.from(entryList.children).filter(
            (child2) => child2.tagName === 'LI'
          ).length >= maxEntries;
        }
        entryList.classList.toggle('-is-disabled', isChecked);
      });
    }
    updateDeleteButtons();
  });
}

// src/js/_module/_style_select.ts
function styleSelect() {
  const updateClass = (select) => {
    if (select.value) {
      select.classList.add('--has-value');
    } else {
      select.classList.remove('--has-value');
    }
  };
  document.querySelectorAll('.js-select').forEach(updateClass);
  document.addEventListener('change', (event) => {
    const target = event.target;
    if (target instanceof HTMLSelectElement && target.classList.contains('js-select')) {
      updateClass(target);
    }
  });
}

// src/js/_module/_accordion.ts
function accordion() {
  document.addEventListener('click', (e) => {
    const toggle = e.target.closest('.js-acc-toggle');
    if (!toggle) return;
    e.preventDefault();
    const content = toggle.nextElementSibling;
    if (!content) return;
    toggle.classList.toggle('-is-opened');
    const isOpening = !content.classList.contains('-is-opened');
    if (isOpening) {
      openAccordion(content);
    } else {
      closeAccordion(content);
    }
    content.classList.toggle('-is-opened');
  });
}
function openAccordion(el) {
  el.style.display = 'block';
  const height = el.scrollHeight;
  el.style.height = '0px';
  el.style.overflow = 'hidden';
  requestAnimationFrame(() => {
    el.style.transition = 'height 0.3s ease';
    el.style.height = height + 'px';
    const cleanup = () => {
      el.style.height = 'auto';
      el.style.overflow = '';
      el.style.transition = '';
      el.removeEventListener('transitionend', cleanup);
    };
    el.addEventListener('transitionend', cleanup);
  });
}
function closeAccordion(el) {
  const height = el.scrollHeight;
  el.style.height = height + 'px';
  el.style.overflow = 'hidden';
  requestAnimationFrame(() => {
    el.style.transition = 'height 0.3s ease';
    el.style.height = '0px';
    const cleanup = () => {
      el.style.display = 'none';
      el.style.height = '';
      el.style.overflow = '';
      el.style.transition = '';
      el.removeEventListener('transitionend', cleanup);
    };
    el.addEventListener('transitionend', cleanup);
  });
}

// src/js/_module/_set_field.ts
function setField() {
  document.addEventListener('click', (event) => {
    const target = event.target;
    if (target.closest('.js-modal-set')) {
      const setButton = target.closest('.js-modal-set');
      const modalContainer = setButton.closest('.js-modal-container');
      if (!modalContainer) return;
      const selectedRadio = modalContainer.querySelector('input[type="radio"]:checked');
      if (!selectedRadio) return;
      const container = modalContainer.closest('.js-entry-item');
      if (!container) return;
      const inputTarget = container.querySelector('.js-input-target');
      if (!inputTarget) return;
      inputTarget.value = selectedRadio.value;
      modalContainer.classList.remove('is-active');
      document.body.style.overflow = '';
    }
  });
}

// src/js/_module/_check_true.ts
function checkTrue() {
  const radioAreas = document.querySelectorAll('.js-radio-area');
  radioAreas.forEach((area) => {
    const radios = area.querySelectorAll('.js-radio-button');
    const input = area.querySelector('.js-input-area');
    if (!input) return;
    radios.forEach((radio) => {
      radio.addEventListener('change', () => {
        const isTrue = radio.dataset.true === 'true';
        input.classList.toggle('-is-disabled', !isTrue);
      });
    });
  });
}

// src/js/_module/_tooltip.ts
function initializeTooltips() {
  const tooltipOpenButtons = document.querySelectorAll('.js-tooltip-open-button');
  tooltipOpenButtons.forEach((button) => {
    button.addEventListener('click', (event) => {
      const tooltipContainer = button.querySelector('.js-tooltip-container');
      if (tooltipContainer) {
        document.querySelectorAll('.js-tooltip-container.is-active').forEach((openTooltip) => {
          if (openTooltip !== tooltipContainer) {
            openTooltip.classList.remove('is-active');
          }
        });
        tooltipContainer.classList.add('is-active');
      }
    });
  });
  const tooltipCloseTriggers = document.querySelectorAll('.js-tooltip-close-trigger');
  tooltipCloseTriggers.forEach((trigger) => {
    trigger.addEventListener('click', (event) => {
      event.stopPropagation();
      const tooltipContainer = trigger.closest('.js-tooltip-container');
      if (tooltipContainer) {
        tooltipContainer.classList.remove('is-active');
      }
    });
  });
  document.addEventListener('click', (event) => {
    const openTooltips = document.querySelectorAll('.js-tooltip-container.is-active');
    openTooltips.forEach((tooltip) => {
      const openButton = tooltip.parentElement;
      if (openButton && !openButton.contains(event.target) && !tooltip.contains(event.target)) {
        tooltip.classList.remove('is-active');
      }
    });
  });
}

// src/js/_module/_jobsearchSelect.ts
function initializeJobSearchSelect() {
  const selectContainers = document.querySelectorAll('.js-jobsearch-select');
  selectContainers.forEach((container) => {
    const radioGroupName = container.dataset.select;
    const labelToUpdate = container.querySelector('.js-jobsearch-select_label');
    const toggleButton = container.querySelector('.js-jobsearch-select_btn');
    const listElement = container.querySelector('.js-jobsearch-select_list');
    if (!radioGroupName) {
      console.warn('Container is missing data-select attribute:', container);
      return;
    }
    if (!labelToUpdate) {
      console.warn('Container is missing .js-jobsearch-select_label element:', container);
      return;
    }
    if (!toggleButton) {
      console.warn('Container is missing .js-jobsearch-select_btn element:', container);
      return;
    }
    if (!listElement) {
      console.warn('Container is missing .js-jobsearch-select_list element:', container);
      return;
    }
    const radioButtons = container.querySelectorAll(
      `input[type="radio"][name="${radioGroupName}"]`
    );
    if (radioButtons.length === 0) {
      console.warn(`No radio buttons found with name "${radioGroupName}" in container:`, container);
      return;
    }
    const updateLabelAndCloseList = () => {
      const checkedRadioButton = container.querySelector(
        `input[type="radio"][name="${radioGroupName}"]:checked`
      );
      if (checkedRadioButton) {
        let newLabelText = '';
        if (checkedRadioButton.id) {
          const correspondingLabel = document.querySelector(`label[for="${checkedRadioButton.id}"]`);
          if (correspondingLabel && correspondingLabel.textContent) {
            newLabelText = correspondingLabel.textContent.trim();
          } else {
            newLabelText = checkedRadioButton.value;
            console.warn(`Label for radio button with id "${checkedRadioButton.id}" not found or has no text. Using value instead.`);
          }
        } else {
          newLabelText = checkedRadioButton.value;
          console.warn('Checked radio button has no id. Using value instead.', checkedRadioButton);
        }
        labelToUpdate.textContent = newLabelText;
      }
      if (listElement.classList.contains('__opened')) {
        listElement.classList.remove('__opened');
      }
    };
    const initialUpdateLabel = () => {
      const checkedRadioButton = container.querySelector(
        `input[type="radio"][name="${radioGroupName}"]:checked`
      );
      if (checkedRadioButton) {
        let newLabelText = '';
        if (checkedRadioButton.id) {
          const correspondingLabel = document.querySelector(`label[for="${checkedRadioButton.id}"]`);
          if (correspondingLabel && correspondingLabel.textContent) {
            newLabelText = correspondingLabel.textContent.trim();
          } else {
            newLabelText = checkedRadioButton.value;
          }
        } else {
          newLabelText = checkedRadioButton.value;
        }
        labelToUpdate.textContent = newLabelText;
      }
    };
    initialUpdateLabel();
    radioButtons.forEach((radioButton) => {
      radioButton.addEventListener('change', updateLabelAndCloseList);
      radioButton.addEventListener('click', () => {
        if (radioButton.checked && listElement.classList.contains('__opened')) {
          listElement.classList.remove('__opened');
        }
      });
    });
    toggleButton.addEventListener('click', (event) => {
      event.stopPropagation();
      listElement.classList.toggle('__opened');
    });
    document.addEventListener('click', (event) => {
      if (!container.contains(event.target) && listElement.classList.contains('__opened')) {
        listElement.classList.remove('__opened');
      }
    });
  });
}

// src/js/_module/_jobsearchAccordion.ts
function initializeJobSearchAccordion() {
  document.addEventListener('DOMContentLoaded', () => {
    const accordionToggleButtons = document.querySelectorAll('.js-jobsearch-acc-toggle');
    accordionToggleButtons.forEach((button) => {
      button.addEventListener('click', () => {
        button.classList.toggle('-is-opened');
        const parentElement = button.parentElement;
        if (parentElement) {
          const targetElement = parentElement.nextElementSibling;
          if (targetElement && targetElement.classList.contains('js-jobsearch-acc-target')) {
            targetElement.classList.toggle('-is-opened');
          }
        }
      });
    });
  });
}

// src/js/_module/_graduation.ts
function graduation() {
  let activeEntryItem = null;
  document.addEventListener('click', (event) => {
    const target = event.target;
    const openButton = target.closest('.js-modal-open-button');
    if (openButton) {
      activeEntryItem = openButton.closest('.js-entry-item');
      const modal2 = document.querySelector('#graduation-calendar');
      if (modal2) {
        modal2.classList.add('is-active');
      }
      return;
    }
    const td = target.closest('td');
    const calendar = target.closest('.js-graduation-calendar');
    if (td && calendar && activeEntryItem) {
      const year = td.getAttribute('data-year');
      if (!year) return;
      const select = activeEntryItem.querySelector('.js-graduation-year');
      if (!select) return;
      const matchingOption = Array.from(select.options).find(
        (option) => option.value === year
      );
      if (matchingOption) {
        select.value = year;
        select.dispatchEvent(new Event('change'));
        select.classList.add('--has-value');
      }
      const modal2 = document.querySelector('#graduation-calendar');
      if (modal2) {
        modal2.classList.remove('is-active');
        document.body.style.overflow = '';
      }
      activeEntryItem = null;
    }
  });
}

// src/js/_module/_clear.ts
function clear() {
  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!target.classList.contains('js-clear')) return;
    const parent = target.parentElement;
    if (!parent) return;
    const clearTarget = parent.querySelector('.js-clear-target');
    if (!clearTarget) return;
    if (clearTarget.tagName === 'INPUT' && clearTarget.type === 'text') {
      clearTarget.value = '';
    } else if (clearTarget.tagName === 'SELECT') {
      clearTarget.selectedIndex = 0;
    }
  });
}

// src/js/_module/_clearFormElements.ts
function clearFormElementsById(containerId, clearButtonId) {
  const container = document.getElementById(containerId);
  const clearButton = document.getElementById(clearButtonId);
  if (!container) {
    return;
  }
  if (!clearButton) {
    return;
  }
  clearButton.addEventListener('click', () => {
    const textInputs = container.querySelectorAll(
      'input[type="text"], input[type="password"], input[type="email"], input[type="search"], input[type="tel"], input[type="url"], textarea'
    );
    textInputs.forEach((input) => {
      input.value = '';
    });
    const selectElements = container.querySelectorAll('select');
    selectElements.forEach((select) => {
      select.selectedIndex = 0;
    });
    const checkboxInputs = container.querySelectorAll('input[type="checkbox"]');
    checkboxInputs.forEach((checkbox) => {
      checkbox.checked = false;
    });
    const radioInputs = container.querySelectorAll('input[type="radio"]');
    radioInputs.forEach((radio) => {
      radio.checked = false;
    });
  });
}

// src/js/_module/_type-search.ts
function typeSearch() {
  document.addEventListener('input', (event) => {
    const input = event.target;
    if (!input.classList.contains('js-type-search')) return;
    const container = input.parentElement;
    if (!container) return;
    const searchItems = container.querySelector('.js-search-items');
    if (searchItems) {
      searchItems.classList.add('--opened');
    }
  });
  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!target.classList.contains('js-search-items__item')) return;
    const container = target.closest('.js-search-items')?.parentElement;
    if (!container) return;
    const input = container.querySelector('.js-type-search');
    const searchItems = container.querySelector('.js-search-items');
    if (input && searchItems) {
      input.value = target.textContent?.trim() || '';
      searchItems.classList.remove('--opened');
    }
  });
}

// src/js/_module/_heartAnimation.ts
function initializeHeartAnimation() {
  document.addEventListener('DOMContentLoaded', () => {
    const heartElements = document.querySelectorAll('.js-heart');
    heartElements.forEach((heartElement) => {
      heartElement.addEventListener('click', () => {
        heartElement.classList.add('__animation');
      });
    });
  });
}

// src/js/_module/_applyOpenedClassLogic.ts
function applyOpenedClassLogic() {
  const applyLists = document.querySelectorAll('.js-apply-list');
  applyLists.forEach((listElement) => {
    if (listElement.children.length <= 2) {
      const prevSibling = listElement.previousElementSibling;
      if (prevSibling && prevSibling.classList.contains('js-apply-list_btn')) {
        listElement.classList.add('-is-opened');
        prevSibling.classList.add('-is-opened');
      }
    }
  });
}

// src/js/_module/_setKana.ts
function setKana() {
  document.addEventListener('change', (event) => {
    const target = event.target;
    if (!(target instanceof HTMLSelectElement) || !target.classList.contains('js-ken-select')) {
      return;
    }
    const kanaWrap = target.closest('.js-kana-wrap');
    if (!kanaWrap) return;
    const selectedOption = target.selectedOptions[0];
    const kana = selectedOption?.dataset.kana ?? '';
    const kanaInput = kanaWrap.querySelector('.js-ken-kana');
    if (kanaInput) {
      kanaInput.value = kana;
    }
  });
}

// src/js/_module/_syncCheckboxes.ts
var syncChildCheckboxes = () => {
  const parentCheckboxes = document.querySelectorAll('.js-check-parent');
  parentCheckboxes.forEach((parentCheckbox) => {
    const wrapper = parentCheckbox.closest('.js-check-parent_wp');
    if (!wrapper) {
      return;
    }
    const targetContainer = wrapper.nextElementSibling;
    if (!targetContainer || !targetContainer.classList.contains('js-check-parent_target')) {
      return;
    }
    const childCheckboxes = targetContainer.querySelectorAll(
      ':scope > .p-jobsearch-search_accordion input[type="checkbox"], :scope .p-jobsearch-search_accordions input[type="checkbox"]'
      // .p-jobsearch-search_accordions 内の末端チェックボックス
    );
    if (childCheckboxes.length === 0) {
      return;
    }
    const updateParentState = () => {
      const totalChildren = childCheckboxes.length;
      const checkedChildren = Array.from(childCheckboxes).filter((cb) => cb.checked && !cb.indeterminate).length;
      const indeterminateChildren = Array.from(childCheckboxes).filter((cb) => cb.indeterminate).length;
      const oldChecked = parentCheckbox.checked;
      const oldIndeterminate = parentCheckbox.indeterminate;
      if (checkedChildren === totalChildren) {
        parentCheckbox.checked = true;
        parentCheckbox.indeterminate = false;
      } else if (checkedChildren > 0 || indeterminateChildren > 0) {
        parentCheckbox.checked = false;
        parentCheckbox.indeterminate = true;
      } else {
        parentCheckbox.checked = false;
        parentCheckbox.indeterminate = false;
      }
      if (oldChecked !== parentCheckbox.checked || oldIndeterminate !== parentCheckbox.indeterminate) {
        parentCheckbox.dispatchEvent(new Event('change'));
      }
    };
    parentCheckbox.addEventListener('change', (e) => {
      if (!e.isTrusted) return;
      const isChecked = parentCheckbox.checked;
      childCheckboxes.forEach((childCheckbox) => {
        childCheckbox.checked = isChecked;
        childCheckbox.dispatchEvent(new Event('change'));
      });
      parentCheckbox.indeterminate = false;
    });
    childCheckboxes.forEach((childCheckbox) => {
      childCheckbox.addEventListener('change', (e) => {
        e.stopPropagation();
        updateParentState();
      });
    });
    updateParentState();
  });
};

// src/js/_module/_bulkSelection.ts
var bulkJobSelection = () => {
  const checkAllCheckbox = document.querySelector('.js-check-alljob');
  const jobItemCheckboxes = document.querySelectorAll('.js-check-jobitem');
  if (!checkAllCheckbox || jobItemCheckboxes.length === 0) {
    return;
  }
  const updateCheckAllState = () => {
    const allChecked = Array.from(jobItemCheckboxes).every((checkbox) => checkbox.checked);
    checkAllCheckbox.checked = allChecked;
  };
  const onCheckAllChange = () => {
    const isChecked = checkAllCheckbox.checked;
    jobItemCheckboxes.forEach((checkbox) => {
      checkbox.checked = isChecked;
    });
  };
  checkAllCheckbox.addEventListener('change', onCheckAllChange);
  jobItemCheckboxes.forEach((checkbox) => {
    checkbox.addEventListener('change', updateCheckAllState);
  });
  updateCheckAllState();
};

// src/js/assets/js/script.ts
modal();
showPassword();
splideSlider();
// gMenu();
pApply();
schedulesetting();
displayCalendar();
initializeTabs();
addRemoveEntry();
styleSelect();
accordion();
setField();
checkTrue();
initializeTooltips();
initializeJobSearchSelect();
initializeJobSearchAccordion();
graduation();
clear();
clearFormElementsById('modalSearch', 'clearModalSearch');
clearFormElementsById('modalSearch2', 'clearModalSearch2');
clearFormElementsById('modalSearch3', 'clearModalSearch3');
clearFormElementsById('modalSearch4', 'clearModalSearch4');
typeSearch();
initializeHeartAnimation();
applyOpenedClassLogic();
setKana();
syncChildCheckboxes();
bulkJobSelection();
/*! Bundled license information:

@splidejs/splide/dist/js/splide.esm.js:
  (*!
   * Splide.js
   * Version  : 4.1.4
   * License  : MIT
   * Copyright: 2022 Naotoshi Fujita
   *)
*/
//# sourceMappingURL=script.js.map
